// src/components/smart-shopping-listings/flights-listings.tsx
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  fragment IconFragments on Icon {\n    description\n    id\n    size\n    theme\n    title\n    withBackground\n    spotLight\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  fragment MarkFragments on Mark {\n    description\n    id\n    markSize: size\n    url {\n      ... on HttpURI {\n        __typename\n        relativePath\n        value\n      }\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  fragment IllustrationFragments on Illustration {\n    description\n    id\n    link: url\n  }\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  fragment UIGraphicFragment on UIGraphic {\n    ... on Icon {\n      ...IconFragments\n    }\n\n    ... on Mark {\n      ...MarkFragments\n    }\n\n    ... on Illustration {\n      ...IllustrationFragments\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSTextIconListItemFragment on EGDSTextIconListItem {\n    icon {\n      ...IconFragments\n    }\n    text\n  }\n\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSNestedLevelOneListItemFragment on EGDSNestedLevelOneListItem {\n    text\n  }\n"
    ]);
    _templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSNestedLevelOneListFragment on EGDSNestedLevelOneList {\n    items {\n      ...EGDSNestedLevelOneListItemFragment\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject6 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSTextStandardListItemFragment on EGDSTextStandardListItem {\n    text\n    nestedLevelOneList {\n      ...EGDSNestedLevelOneListFragment\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject7 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSHeadingFragment on EGDSHeading {\n    text\n    headingType\n  }\n"
    ]);
    _templateObject8 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSParagraphFragment on EGDSParagraph {\n    text\n    style\n  }\n"
    ]);
    _templateObject9 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _tagged_template_literal([
        "\n  fragment ActionFragment on UILinkAction {\n    accessibility\n    analytics {\n      linkName\n      referrerId\n    }\n    resource {\n      value\n      ... on HttpURI {\n        relativePath\n      }\n    }\n    target\n    useRelativePath\n  }\n"
    ]);
    _templateObject10 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSStandardLinkFragment on EGDSStandardLink {\n    action {\n      ...ActionFragment\n    }\n    standardLinkIcon: icon {\n      ...IconFragments\n    }\n    iconPosition\n    size\n    text\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject11 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSGraphicTextFragment on EGDSGraphicText {\n    text\n    textGraphic: graphic {\n      ...UIGraphicFragment\n    }\n    trailingGraphics {\n      ...UIGraphicFragment\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject12 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSIconTextFragment on EGDSIconText {\n    icon {\n      ...IconFragments\n    }\n    text\n  }\n\n  ",
        "\n"
    ]);
    _templateObject13 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSInlineLinkFragment on EGDSInlineLink {\n    action {\n      ...ActionFragment\n    }\n    size\n    text\n  }\n\n  ",
        "\n"
    ]);
    _templateObject14 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSPlainTextFragment on EGDSPlainText {\n    text\n  }\n"
    ]);
    _templateObject15 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSStylizedTextFragment on EGDSStylizedText {\n    decorative\n    stylizedSize: size\n    text\n    theme\n    weight\n  }\n"
    ]);
    _templateObject16 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSSpannableTextContentFragment on EGDSText {\n    ...EGDSStylizedTextFragment\n    ...EGDSPlainTextFragment\n    ...EGDSGraphicTextFragment\n    ...EGDSIconTextFragment\n    ...EGDSStandardLinkFragment\n    ...EGDSHeadingFragment\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject17 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSSpannableTextFragment on EGDSSpannableText {\n    text\n    contents {\n      ...EGDSSpannableTextContentFragment\n    }\n    inlineContent {\n      ...EGDSSpannableTextContentFragment\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject18 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSTextFragment on EGDSText {\n    __typename\n    ...EGDSHeadingFragment\n    ...EGDSGraphicTextFragment\n    ...EGDSSpannableTextFragment\n    ...EGDSPlainTextFragment\n    ...EGDSStylizedTextFragment\n    ...EGDSIconTextFragment\n    ...EGDSParagraphFragment\n    ...EGDSStandardLinkFragment\n    ...EGDSInlineLinkFragment\n    ...EGDSTextStandardListItemFragment\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject19 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = _tagged_template_literal([
        "\n  fragment FlightsTextContainerListItemFragment on FlightsTextContainerListItem {\n    content {\n      ...EGDSTextFragment\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject20 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSTextListItemFragment on EGDSTextListItem {\n    ...EGDSTextStandardListItemFragment\n    ...EGDSTextIconListItemFragment\n    ...FlightsTextContainerListItemFragment\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject21 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSBulletedListFragment on EGDSBulletedList {\n    listItems {\n      ...EGDSTextListItemFragment\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject22 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSUnorderedListFragment on EGDSUnorderedList {\n    listItems {\n      ...EGDSTextListItemFragment\n    }\n    textListSize: size\n  }\n\n  ",
        "\n"
    ]);
    _templateObject23 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = _tagged_template_literal([
        "\n  fragment ClientSideAnalyticsFragment on ClientSideAnalytics {\n    linkName\n    referrerId\n    uisPrimeMessages {\n      messageContent\n      schemaName\n    }\n  }\n"
    ]);
    _templateObject24 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = _tagged_template_literal([
        "\n  fragment ClientSideImpressionEventAnalyticsFragment on ClientSideImpressionEventAnalytics {\n    linkName\n    referrerId\n    event\n    url\n    uisPrimeMessages {\n      messageContent\n      schemaName\n    }\n  }\n"
    ]);
    _templateObject25 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject26() {
    var data = _tagged_template_literal([
        "\n  fragment ClientActionFragment on FlightsClientAction {\n    accessibility\n    analyticsList {\n      ...ClientSideAnalyticsFragment\n    }\n    ... on FlightsCreditSelectionAction {\n      originalBookingId\n    }\n    ... on FlightsResourceLinkAction {\n      resource {\n        ... on HttpURI {\n          relativePath\n          value\n        }\n      }\n    }\n    ... on FlightsSelectionAction {\n      value\n    }\n    ... on FlightsSearchCriteriaChangeAction {\n      searchCriteria {\n        flightsSearchContext {\n          hasCreditRedemptionIntent\n          originalBookingId\n          searchCriteriaMismatch\n          tripType\n          previousOriginalBookingId\n        }\n        travelerDetails {\n          ages\n          count\n          travelerType\n        }\n      }\n    }\n    ... on FlightsBoundNavigation {\n      jcid\n      mipt\n      pageId\n      stepIndicatorJcid\n    }\n    ... on FlightsNavigateToDetails {\n      dialogId\n      nextPage {\n        ... on HttpURI {\n          relativePath\n          value\n        }\n      }\n      packagesUrl {\n        ... on HttpURI {\n          relativePath\n          value\n        }\n      }\n    }\n    ... on MultiItemSelectProducts {\n      flightsOfferNaturalKeys {\n        flightNaturalKey {\n          offerToken\n          productTokens\n          travelers {\n            age\n            type\n          }\n        }\n      }\n      multiItemPriceToken\n      multiItemSessionId\n    }\n    ... on MultiItemSelectPackage {\n      packageOfferId\n    }\n    ... on InsuranceSwitchToggleAction {\n      insuranceCriteria {\n        freePmpCustomerPlacement\n        selectedProductId\n      }\n      jcidValue: jcid\n      checkedAccessibilityAnnouncement\n      uncheckedAccessibilityAnnouncement\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject26 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject27() {
    var data = _tagged_template_literal([
        "\n  fragment FlightsActionButtonFragment on FlightsActionButton {\n    clientAction {\n      ...ClientActionFragment\n    }\n    disabled\n    primary\n    buttonStyle: style\n    accessibility\n    icon {\n      ...IconFragments\n    }\n    analytics {\n      ...ClientSideAnalyticsFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject27 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject28() {
    var data = _tagged_template_literal([
        "\n  fragment FlightsActionLinkFragment on FlightsActionLink {\n    accessibility\n    clientAction {\n      ...ClientActionFragment\n    }\n    disabled\n    primary\n    icon {\n      ...IconFragments\n    }\n    analytics {\n      ...ClientSideAnalyticsFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject28 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject29() {
    var data = _tagged_template_literal([
        "\n  fragment FlightsDialogTriggerFragment on FlightsDialogTrigger {\n    dialogAction\n    dialogId\n    dynamicDialogId\n    trigger {\n      __typename\n      ...FlightsActionButtonFragment\n      ...FlightsActionLinkFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject29 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject30() {
    var data = _tagged_template_literal([
        "\n  fragment UIMessagingCardFragment on UIMessagingCard {\n    primary\n    secondaries\n    graphic {\n      ...UIGraphicFragment\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject30 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject31() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSElementFragment on EGDSElement {\n    ...EGDSHeadingFragment\n    ...EGDSParagraphFragment\n    ...EGDSStandardLinkFragment\n    ...FlightsActionButtonFragment\n    ...FlightsActionLinkFragment\n    ...FlightsDialogTriggerFragment\n    ...EGDSBulletedListFragment\n    ...EGDSSpannableTextFragment\n    ...EGDSUnorderedListFragment\n    ...UIMessagingCardFragment\n    ...IllustrationFragments\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject31 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject32() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSTextListFragment on EGDSTextList {\n    ...EGDSUnorderedListFragment\n  }\n\n  ",
        "\n"
    ]);
    _templateObject32 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject33() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSLinkListFragment on EGDSLinkList {\n    listItems {\n      ...EGDSStandardLinkFragment\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject33 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject34() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSPriceLockupFragment on EGDSPriceLockup {\n    accessibilityPrice\n    leadingCaption\n    lockupFormattedPoints\n    isPointsFirst\n    lockupPrice\n    priceSubtextBold\n    priceSubtextFirst\n    priceSubtextStandard\n    strikeThroughPrice\n  }\n"
    ]);
    _templateObject34 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject35() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSBasicSectionHeadingFragment on EGDSBasicSectionHeading {\n    heading {\n      ...EGDSHeadingFragment\n    }\n    graphic {\n      ...UIGraphicFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject35 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject36() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSSectionHeadingFragment on EGDSSectionHeading {\n    heading {\n      ...EGDSHeadingFragment\n    }\n    subheading\n    ... on FlightsOfferSectionHeading {\n      mark {\n        ...MarkFragments\n      }\n    }\n    ... on EGDSBasicSectionHeading {\n      graphic {\n        ...UIGraphicFragment\n      }\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject36 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject37() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSTextSectionFragment on EGDSTextSection {\n    contents {\n      ...EGDSTextFragment\n    }\n    heading {\n      ...EGDSSectionHeadingFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject37 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject38() {
    var data = _tagged_template_literal([
        "\n  fragment FlightsPhraseAnalyticsFragment on FlightsAnalytics {\n    linkName\n    referrerId\n  }\n"
    ]);
    _templateObject38 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject39() {
    var data = _tagged_template_literal([
        "\n  fragment FlightsPhraseLinkNodeFragment on FlightsPhraseLinkNode {\n    accessibility\n    analytics {\n      ...FlightsPhraseAnalyticsFragment\n    }\n    displayAnalytics {\n      ...FlightsPhraseAnalyticsFragment\n    }\n    scrollAnalytics {\n      ...FlightsPhraseAnalyticsFragment\n    }\n    icon\n    link\n    styles\n    text\n  }\n\n  ",
        "\n"
    ]);
    _templateObject39 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject40() {
    var data = _tagged_template_literal([
        "\n  fragment FlightsPhraseTextNodeFragment on FlightsPhraseTextNode {\n    styles\n    text\n  }\n"
    ]);
    _templateObject40 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject41() {
    var data = _tagged_template_literal([
        "\n  fragment FlightsPhrasePartFragment on FlightsPhrasePart {\n    __typename\n    ... on FlightsPhraseTextNode {\n      ...FlightsPhraseTextNodeFragment\n    }\n    ... on FlightsPhraseLinkNode {\n      ...FlightsPhraseLinkNodeFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject41 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject42() {
    var data = _tagged_template_literal([
        "\n  fragment FlightsPhraseFragment on FlightsPhrase {\n    completeText\n    items {\n      ...FlightsPhrasePartFragment\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject42 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject43() {
    var data = _tagged_template_literal([
        "\n  fragment FlightsPricePresentationFragment on PricePresentation {\n    title {\n      primary\n    }\n    sections {\n      ...PricePresentationSectionFragment\n    }\n    footer {\n      header\n      messages {\n        ...PriceLineElementFragment\n      }\n    }\n  }\n\n  fragment PricePresentationSectionFragment on PricePresentationSection {\n    header {\n      name {\n        ...PricePresentationLineItemEntryFragment\n      }\n      enrichedValue {\n        ...PricePresentationLineItemEntryFragment\n      }\n    }\n    subSections {\n      ...PricePresentationSubSectionFragment\n    }\n  }\n\n  fragment PricePresentationSubSectionFragment on PricePresentationSubSection {\n    header {\n      name {\n        primaryMessage {\n          __typename\n          ... on PriceLineText {\n            primary\n          }\n          ... on PriceLineHeading {\n            primary\n          }\n        }\n      }\n      enrichedValue {\n        ...PricePresentationLineItemEntryFragment\n      }\n    }\n    items {\n      ...PricePresentationLineItemFragment\n    }\n  }\n\n  fragment PricePresentationLineItemFragment on PricePresentationLineItem {\n    enrichedValue {\n      ...PricePresentationLineItemEntryFragment\n    }\n    name {\n      ...PricePresentationLineItemEntryFragment\n    }\n  }\n\n  fragment PricePresentationLineItemEntryFragment on PricePresentationLineItemEntry {\n    primaryMessage {\n      ...PriceLineElementFragment\n    }\n    secondaryMessages {\n      ...PriceLineElementFragment\n    }\n  }\n\n  fragment PriceLineElementFragment on PricePresentationLineItemMessage {\n    __typename\n    ...PriceLineTextFragment\n    ...PriceLineHeadingFragment\n    ...PriceLineBadgeFragment\n    ...InlinePriceLineTextFragment\n  }\n\n  fragment PriceLineTextFragment on PriceLineText {\n    __typename\n    theme\n    primary\n    weight\n    additionalInfo {\n      ...AdditionalInformationPopoverFragment\n    }\n    additionalInformation {\n      ...PricePresentationAdditionalInformationFragment\n    }\n    icon {\n      id\n      description\n      size\n    }\n    graphic {\n      ...UIGraphicFragment\n    }\n  }\n\n  fragment UIGraphicFragment on UIGraphic {\n    ... on Icon {\n      ...IconFragments\n    }\n\n    ... on Mark {\n      ...MarkFragments\n    }\n\n    ... on Illustration {\n      ...IllustrationFragments\n    }\n  }\n\n  fragment IconFragments on Icon {\n    description\n    id\n    size\n    theme\n    title\n    withBackground\n    spotLight\n  }\n\n  fragment MarkFragments on Mark {\n    description\n    id\n    markSize: size\n    url {\n      ... on HttpURI {\n        __typename\n        relativePath\n        value\n      }\n    }\n  }\n\n  fragment IllustrationFragments on Illustration {\n    description\n    id\n    link: url\n  }\n\n  fragment PricePresentationAdditionalInformationFragment on PricePresentationAdditionalInformation {\n    ...PricePresentationAdditionalInformationDialogFragment\n    ...PricePresentationAdditionalInformationPopoverFragment\n  }\n\n  fragment PricePresentationAdditionalInformationDialogFragment on PricePresentationAdditionalInformationDialog {\n    closeAnalytics {\n      linkName\n      referrerId\n    }\n    enrichedSecondaries {\n      ...AdditionalInformationPopoverSectionFragment\n    }\n    footer {\n      ...PricePresentationAdditionalInformationDialogFooterFragment\n    }\n    icon {\n      id\n      description\n      size\n    }\n    openAnalytics {\n      linkName\n      referrerId\n    }\n  }\n\n  fragment PricePresentationAdditionalInformationDialogFooterFragment on EGDSDialogFooter {\n    ... on EGDSInlineDialogFooter {\n      buttons {\n        ...PricePresentationAdditionalInformationDialogFooterButtonsFragment\n      }\n    }\n    ... on EGDSStackedDialogFooter {\n      buttons {\n        ...PricePresentationAdditionalInformationDialogFooterButtonsFragment\n      }\n    }\n  }\n\n  fragment PricePresentationAdditionalInformationDialogFooterButtonsFragment on EGDSButton {\n    accessibility\n    disabled\n    primary\n  }\n\n  fragment PricePresentationAdditionalInformationPopoverFragment on PricePresentationAdditionalInformationPopover {\n    analytics {\n      linkName\n      referrerId\n    }\n    enrichedSecondaries {\n      ...AdditionalInformationPopoverSectionFragment\n    }\n    icon {\n      id\n      description\n      size\n    }\n  }\n\n  fragment AdditionalInformationPopoverFragment on AdditionalInformationPopover {\n    icon {\n      id\n      description\n      size\n    }\n    enrichedSecondaries {\n      ...AdditionalInformationPopoverSectionFragment\n    }\n    analytics {\n      linkName\n      referrerId\n    }\n  }\n\n  fragment AdditionalInformationPopoverSectionFragment on AdditionalInformationPopoverSection {\n    __typename\n    ... on AdditionalInformationPopoverTextSection {\n      ...AdditionalInformationPopoverTextSectionFragment\n    }\n    ... on AdditionalInformationPopoverListSection {\n      ...AdditionalInformationPopoverListSectionFragment\n    }\n    ... on AdditionalInformationPopoverGridSection {\n      ...AdditionalInformationPopoverGridSectionFragment\n    }\n  }\n\n  fragment AdditionalInformationPopoverTextSectionFragment on AdditionalInformationPopoverTextSection {\n    __typename\n    text {\n      text\n      ...EGDSStandardLinkFragment\n    }\n  }\n\n  fragment AdditionalInformationPopoverListSectionFragment on AdditionalInformationPopoverListSection {\n    __typename\n    content {\n      __typename\n      items {\n        text\n      }\n    }\n  }\n\n  fragment AdditionalInformationPopoverGridSectionFragment on AdditionalInformationPopoverGridSection {\n    __typename\n    subSections {\n      header {\n        name {\n          primaryMessage {\n            ...AdditionalInformationPopoverGridLineItemMessageFragment\n          }\n        }\n      }\n      items {\n        name {\n          ...AdditionalInformationPopoverGridLineItemEntryFragment\n        }\n        enrichedValue {\n          ...AdditionalInformationPopoverGridLineItemEntryFragment\n        }\n      }\n    }\n  }\n\n  fragment AdditionalInformationPopoverGridLineItemEntryFragment on PricePresentationLineItemEntry {\n    primaryMessage {\n      ...AdditionalInformationPopoverGridLineItemMessageFragment\n    }\n    secondaryMessages {\n      ...AdditionalInformationPopoverGridLineItemMessageFragment\n    }\n  }\n\n  fragment AdditionalInformationPopoverGridLineItemMessageFragment on PricePresentationLineItemMessage {\n    ... on PriceLineText {\n      __typename\n      primary\n    }\n    ... on PriceLineHeading {\n      __typename\n      tag\n      size\n      primary\n    }\n  }\n\n  fragment PriceLineHeadingFragment on PriceLineHeading {\n    __typename\n    primary\n    tag\n    size\n    additionalInfo {\n      ...AdditionalInformationPopoverFragment\n    }\n    additionalInformation {\n      ...PricePresentationAdditionalInformationFragment\n    }\n    icon {\n      id\n      description\n      size\n    }\n  }\n\n  fragment PriceLineBadgeFragment on PriceLineBadge {\n    __typename\n    badge {\n      accessibility\n      text\n      theme\n      graphic {\n        ...UIGraphicFragment\n      }\n    }\n  }\n\n  fragment InlinePriceLineTextFragment on InlinePriceLineText {\n    __typename\n    inlineItems {\n      ...PriceLineTextFragment\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject43 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject44() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSBadgeFragment on EGDSBadge {\n    accessibility\n    text\n    theme\n    graphic {\n      ...UIGraphicFragment\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject44 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject45() {
    var data = _tagged_template_literal([
        "\n  fragment TripTotalsDetailFragment on FlightsPriceSummaryTripTotalItem {\n    tripTotal {\n      roundedPrice\n      price\n    }\n    ancillaryIncludesText\n  }\n"
    ]);
    _templateObject45 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject46() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSButtonFragment on EGDSButton {\n    ...FlightsActionButtonFragment\n    ...FlightsDialogTriggerFragment\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject46 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject47() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSActionDialogFragment on EGDSActionDialog {\n    footer {\n      buttons {\n        ...EGDSButtonFragment\n      }\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject47 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject48() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSFullScreenDialogFragment on EGDSFullScreenDialog {\n    toolbar {\n      closeText\n      title\n    }\n  }\n"
    ]);
    _templateObject48 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject49() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSDialogFragment on EGDSDialog {\n    closeAnalytics {\n      ...ClientSideAnalyticsFragment\n    }\n    ...EGDSFullScreenDialogFragment\n    ...EGDSActionDialogFragment\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject49 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject50() {
    var data = _tagged_template_literal([
        "\n  fragment FlightsDialogFragment on FlightsDialog {\n    dialog {\n      __typename\n      ...EGDSDialogFragment\n    }\n    dialogContent: content {\n      __typename\n      ...EGDSElementFragment\n    }\n    dialogId\n    dynamicDialogId\n    displayAnalytics {\n      ...ClientSideAnalyticsFragment\n    }\n    initialState\n    footer {\n      ...EGDSElementFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject50 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject51() {
    var data = _tagged_template_literal([
        "\n  fragment TextWrapperFragment on TextWrapper {\n    textA11yMessage: accessibilityMessage\n    text {\n      ...EGDSTextFragment\n      ...EGDSStylizedTextFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject51 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject52() {
    var data = _tagged_template_literal([
        "\n  fragment IconWrapperFragment on IconWrapper {\n    iconA11yMessage: accessibilityMessage\n    icons {\n      ...IconFragments\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject52 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject53() {
    var data = _tagged_template_literal([
        "\n  fragment MarkWrapperFragment on MarkWrapper {\n    mark {\n      ...MarkFragments\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject53 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject54() {
    var data = _tagged_template_literal([
        "\n  fragment SuperlativeTextFragment on SuperlativeText {\n    superlativeTextA11yMessage: accessibilityMessage\n    text {\n      ...EGDSStylizedTextFragment\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject54 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject55() {
    var data = _tagged_template_literal([
        "\n  fragment BadgeWrapperFragment on BadgeWrapper {\n    badge {\n      ...EGDSBadgeFragment\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject55 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject56() {
    var data = _tagged_template_literal([
        "\n  fragment FlightsInformationTextItemFragment on FlightsInformationTextItem {\n    ...MarkWrapperFragment\n    ...TextWrapperFragment\n    ...IconWrapperFragment\n    ...SuperlativeTextFragment\n    ...BadgeWrapperFragment\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject56 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject57() {
    var data = _tagged_template_literal([
        "\n  fragment FlightsInformationTextFragment on FlightsInformationText {\n    content {\n      ...FlightsInformationTextItemFragment\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject57 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject58() {
    var data = _tagged_template_literal([
        "\n  fragment FlightsJourneyHeaderFragment on FlightsJourneyHeaderInformation {\n    content {\n      ...FlightsInformationTextFragment\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject58 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject59() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSCarouselFragment on EGDSCarousel {\n    nextButton {\n      ...EGDSButtonFragment\n    }\n    previousButton {\n      ...EGDSButtonFragment\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject59 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject60() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSBasicTabsFragment on EGDSBasicTabs {\n    egdsElementId\n    selectedTabId\n    tabs {\n      ... on EGDSBasicTab {\n        tabId\n        label\n        accessibility\n        clickAnalytics {\n          ...ClientSideAnalyticsFragment\n        }\n      }\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject60 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject61() {
    var data = _tagged_template_literal([
        "\n  fragment FlightsCategorizedListItemFragment on FlightsCategorizedListItem {\n    primary {\n      ...EGDSSpannableTextFragment\n    }\n    secondary\n    tertiary\n    secondaryContent {\n      ...EGDSSpannableTextFragment\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject61 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject62() {
    var data = _tagged_template_literal([
        "\n  fragment FlightsCategorizedListSectionFragment on FlightsCategorizedListSection {\n    flightsCategorizedListSectionA11yMessage: accessibilityMessage\n    footnote\n    heading\n    additionalInfo\n    items {\n      ...FlightsCategorizedListItemFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject62 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject63() {
    var data = _tagged_template_literal([
        "\n  fragment FlightsCategorizedListFragment on FlightsCategorizedList {\n    sections {\n      ...FlightsCategorizedListSectionFragment\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject63 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject64() {
    var data = _tagged_template_literal([
        "\n  fragment FareActionFragment on FareAction {\n    action {\n      ...FlightsActionButtonFragment\n    }\n    states\n  }\n\n  ",
        "\n"
    ]);
    _templateObject64 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject65() {
    var data = _tagged_template_literal([
        "\n  fragment FlightsDetailsAndFaresPriceSectionFragment on FlightsDetailsAndFaresPriceSection {\n    leadingPrice {\n      ...EGDSSpannableTextFragment\n    }\n    price {\n      ...EGDSSpannableTextFragment\n    }\n    secondaryTexts {\n      ...EGDSSpannableTextFragment\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject65 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject66() {
    var data = _tagged_template_literal([
        "\n  fragment FarePricingFragment on FarePricing {\n    priceLockup {\n      ...EGDSPriceLockupFragment\n    }\n    priceSection {\n      ...FlightsDetailsAndFaresPriceSectionFragment\n    }\n    states\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject66 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject67() {
    var data = _tagged_template_literal([
        "\n  fragment FareHeadingFragment on FareHeading {\n    badge {\n      ...EGDSBadgeFragment\n    }\n    fareDetails {\n      ...EGDSTextFragment\n    }\n    farePricing {\n      ...FarePricingFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject67 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject68() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSExpandoPeekFragment on EGDSExpandoPeek {\n    expandedLabel\n    collapsedLabel\n    expandAnalytics {\n      linkName\n      referrerId\n    }\n    threshold\n    minimalHeight\n  }\n"
    ]);
    _templateObject68 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject69() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSExpandoListItemFragment on EGDSExpandoListItem {\n    collapseAnalytics {\n      linkName\n      referrerId\n    }\n    collapsedLabel\n    expandAnalytics {\n      linkName\n      referrerId\n    }\n    expandedLabel\n    expanded\n  }\n"
    ]);
    _templateObject69 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject70() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSExpandoLinkFragment on EGDSExpandoLink {\n    collapseAnalytics {\n      linkName\n      referrerId\n    }\n    collapsedLabel\n    expandAnalytics {\n      linkName\n      referrerId\n    }\n    expanded\n    expandedLabel\n  }\n"
    ]);
    _templateObject70 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject71() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSExpandoFragment on EGDSExpando {\n    ... on EGDSExpandoPeek {\n      ...EGDSExpandoPeekFragment\n    }\n    ... on EGDSExpandoListItem {\n      ...EGDSExpandoListItemFragment\n    }\n    ... on EGDSExpandoLink {\n      ...EGDSExpandoLinkFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject71 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject72() {
    var data = _tagged_template_literal([
        "\n  fragment FlightsSponsoredFareInformationFragment on FlightsSponsoredFareInformation {\n    mediaSection {\n      badge {\n        ...EGDSBadgeFragment\n        size\n      }\n      featureImage {\n        url\n        description\n        thumbnailClickAnalytics {\n          ...ClientSideAnalyticsFragment\n        }\n      }\n    }\n    heading {\n      __typename\n      accessibility\n      text\n    }\n    description\n    bulletpoints {\n      ...EGDSTextListFragment\n    }\n    priceLockup {\n      ...EGDSPriceLockupFragment\n    }\n    onViewedAnalytics {\n      ...ClientSideAnalyticsFragment\n    }\n    sponsoredFareAnalyticsList {\n      ...ClientSideAnalyticsFragment\n    }\n    onClickAnalyticsList {\n      ...ClientSideAnalyticsFragment\n    }\n    showMoreExpando {\n      ...EGDSExpandoPeekFragment\n      collapseAnalytics {\n        ...ClientSideAnalyticsFragment\n      }\n      expanded\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject72 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject73() {
    var data = _tagged_template_literal([
        "\n  fragment FlightsActionCheckboxFragment on FlightsActionCheckbox {\n    clientAction {\n      ...ClientActionFragment\n    }\n    label {\n      ...EGDSTextFragment\n    }\n    state\n    checkedAccessibility\n    checkedAnalytics {\n      ...ClientSideAnalyticsFragment\n    }\n    uncheckedAccessibility\n    uncheckedAnalytics {\n      ...ClientSideAnalyticsFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject73 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject74() {
    var data = _tagged_template_literal([
        "\n  fragment PriceMatchPromiseCardHeadingFragment on FarePriceMatchPromiseCardHeadingType {\n    ...EGDSBasicSectionHeadingFragment\n    ...EGDSGraphicTextFragment\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject74 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject75() {
    var data = _tagged_template_literal([
        "\n  fragment PriceMatchPromiseSelectableCardFragment on FarePriceMatchPromiseSelectableCard {\n    checkbox {\n      ...FlightsActionCheckboxFragment\n    }\n    headingSection {\n      ...PriceMatchPromiseCardHeadingFragment\n    }\n    infoTrigger {\n      ...FlightsDialogTriggerFragment\n    }\n    price\n    priceInfo\n    priceMatchPromiseState\n    description\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject75 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject76() {
    var data = _tagged_template_literal([
        "\n  fragment FarePriceMatchPromiseRemovableCardFragment on FarePriceMatchPromiseRemovableCard {\n    heading {\n      ...EGDSIconTextFragment\n    }\n    priceMatchPromiseState\n    removeAction {\n      ...FlightsActionLinkFragment\n    }\n    subHeading\n  }\n\n  ",
        "\n"
    ]);
    _templateObject76 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject77() {
    var data = _tagged_template_literal([
        "\n  fragment FarePriceMatchPromiseStaticCardFragment on FarePriceMatchPromiseStaticCard {\n    heading {\n      ...EGDSIconTextFragment\n    }\n    priceMatchPromiseState\n    subHeading\n  }\n\n  ",
        "\n"
    ]);
    _templateObject77 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject78() {
    var data = _tagged_template_literal([
        "\n  fragment FarePriceMatchPromisePresentationFragment on FarePriceMatchPromisePresentation {\n    cards {\n      ...PriceMatchPromiseSelectableCardFragment\n      ...FarePriceMatchPromiseRemovableCardFragment\n      ...FarePriceMatchPromiseStaticCardFragment\n    }\n    priceMatchPromiseState\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject78 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject79() {
    var data = _tagged_template_literal([
        "\n  fragment FareInformationCardFragment on FareInformationCard {\n    action {\n      ...FareActionFragment\n    }\n    amenities {\n      ...FlightsCategorizedListFragment\n    }\n    fareDetails {\n      ...EGDSTextFragment\n    }\n    featuredHeader\n    heading {\n      ...FareHeadingFragment\n    }\n    priceMatchPromise {\n      ...FarePriceMatchPromisePresentationFragment\n    }\n    state\n    highlighted\n    fareCardIdentifier\n    scrollAnalytics {\n      ...ClientSideAnalyticsFragment\n    }\n    fareTabs {\n      ...EGDSBasicTabsFragment\n    }\n    sponsoredContent {\n      ...FlightsSponsoredFareInformationFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject79 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject80() {
    var data = _tagged_template_literal([
        "\n  fragment FlightsFaresInformationFragment on FlightsFaresInformation {\n    faresCarousel {\n      ...EGDSCarouselFragment\n    }\n    heading\n    fares {\n      ...FareInformationCardFragment\n    }\n    scrollAnalytics {\n      ...ClientSideAnalyticsFragment\n    }\n    sponsoredUpsellAvailableAnalytics {\n      ...ClientSideAnalyticsFragment\n    }\n    subheading\n    totalFareCount\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject80 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject81() {
    var data = _tagged_template_literal([
        "\n  fragment FlightsHygieneAmenitiesSectionFragment on FlightsHygieneAmenitiesSection {\n    header\n    footer\n    amenities {\n      ...EGDSIconTextFragment\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject81 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject82() {
    var data = _tagged_template_literal([
        "\n  fragment FlightsJourneyWithDetailsFragment on FlightsJourneyWithDetails {\n    details {\n      ...EGDSTextFragment\n    }\n    footnotes {\n      ...EGDSTextFragment\n    }\n    header\n    subheader\n  }\n\n  ",
        "\n"
    ]);
    _templateObject82 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject83() {
    var data = _tagged_template_literal([
        "\n  fragment FlightsSustainabilityCardFragment on FlightsSustainabilityCard {\n    cardContent {\n      text {\n        ...FlightsPhraseFragment\n      }\n      icon {\n        ...IconFragments\n      }\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject83 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject84() {
    var data = _tagged_template_literal([
        "\n  fragment FlightsAnalyticsFragment on FlightsAnalytics {\n    linkName\n    referrerId\n  }\n"
    ]);
    _templateObject84 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject85() {
    var data = _tagged_template_literal([
        "\n  fragment FlightsIconAndLabelFragment on FlightsIconAndLabel {\n    accessibility\n    icon {\n      ...IconFragments\n    }\n    label\n    theme\n    displayAnalytics {\n      ...FlightsAnalyticsFragment\n    }\n    displayAnalyticsList {\n      ...ClientSideAnalyticsFragment\n    }\n    subText {\n      ...EGDSStylizedTextFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject85 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject86() {
    var data = _tagged_template_literal([
        "\n  fragment JourneyAmenitiesWithLabelFragment on FlightsJourneyDetails {\n    journeyAmenities {\n      ...FlightsIconAndLabelFragment\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject86 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject87() {
    var data = _tagged_template_literal([
        "\n  fragment JourneyDetailsBadgeFragment on JourneyDetailsBadge {\n    badge {\n      ...EGDSBadgeFragment\n    }\n    link {\n      ...EGDSStandardLinkFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject87 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject88() {
    var data = _tagged_template_literal([
        "\n  fragment AdditionalInformationFragment on AdditionalInformation {\n    durationAndStop\n    nextFlightOriginAirportInfo {\n      ...FlightsIconAndLabelFragment\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject88 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject89() {
    var data = _tagged_template_literal([
        "\n  fragment FlightsMessageAndAccessibilityFragment on FlightsMessageAndAccessibility {\n    flightsMessageAndAccessibilityA11yMessage: accessibilityMessage\n    text\n    size\n    theme\n  }\n"
    ]);
    _templateObject89 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject90() {
    var data = _tagged_template_literal([
        "\n  fragment CoordinateInformationFragment on CoordinateInformation {\n    flightDetailsWarningInfo {\n      ...FlightsIconAndLabelFragment\n    }\n    icon {\n      ...IconFragments\n    }\n    subtitle\n    titleAndAccessibilityMessage {\n      ...FlightsMessageAndAccessibilityFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject90 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject91() {
    var data = _tagged_template_literal([
        "\n  fragment JourneyAmenitiesFragment on FlightsJourneyAmenities {\n    journeyAmenitiesA11yMessage: accessibilityMessage\n    amenities {\n      ...FlightsIconAndLabelFragment\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject91 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject92() {
    var data = _tagged_template_literal([
        "\n  fragment FlightsConnectionInformationFragment on FlightsConnectionInformation {\n    flightsConnection {\n      aircraftModel\n      airlineInfo\n      cabinClassAndBookingCode\n      connectionArrival {\n        ...CoordinateInformationFragment\n      }\n      connectionDeparture {\n        ...CoordinateInformationFragment\n      }\n      duration\n      journeyAmenities {\n        ...JourneyAmenitiesFragment\n      }\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject92 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject93() {
    var data = _tagged_template_literal([
        "\n  fragment JourneySectionFragment on JourneySection {\n    journeyConnectionInformation {\n      __typename\n      ... on AdditionalInformation {\n        ...AdditionalInformationFragment\n      }\n      ... on FlightsConnectionInformation {\n        ...FlightsConnectionInformationFragment\n      }\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject93 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject94() {
    var data = _tagged_template_literal([
        "\n  fragment FlightsJourneyDetailsFragment on FlightsJourneyDetails {\n    journeySections {\n      ...JourneySectionFragment\n    }\n    ...JourneyAmenitiesWithLabelFragment\n    badge {\n      ...JourneyDetailsBadgeFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject94 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject95() {
    var data = _tagged_template_literal([
        "\n  fragment FlightsJourneyDetailsInformationFragment on FlightsJourneyDetailsInformation {\n    content {\n      ...FlightsJourneyDetailsFragment\n    }\n    expando {\n      ...EGDSExpandoFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject95 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject96() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSStandardMessagingCardFragment on EGDSStandardMessagingCard {\n    message\n    graphic {\n      ...UIGraphicFragment\n    }\n    links {\n      ...EGDSStandardLinkFragment\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject96 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject97() {
    var data = _tagged_template_literal([
        "\n  fragment FlightsMessagingCardFragment on FlightsMessagingCard {\n    cardContent {\n      ...EGDSStandardMessagingCardFragment\n    }\n    displayAnalytics {\n      ...ClientSideAnalyticsFragment\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject97 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject98() {
    var data = _tagged_template_literal([
        "\n  fragment FlightsDetailsAndFaresContentFragment on FlightsDetailsAndFaresContent {\n    dialogId\n    dynamicDialogId\n    nestedDialogs {\n      ...FlightsDialogFragment\n    }\n    priceMatchPromiseNestedDialogs {\n      ...FlightsDialogFragment\n    }\n    sections {\n      __typename\n      ...FlightsJourneyHeaderFragment\n      ...FlightsJourneyDetailsInformationFragment\n      ...FlightsJourneyWithDetailsFragment\n      ...FlightsHygieneAmenitiesSectionFragment\n      ...TextWrapperFragment\n      ...FlightsFaresInformationFragment\n      ...FlightsSustainabilityCardFragment\n      ...FlightsMessagingCardFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject98 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject99() {
    var data = _tagged_template_literal([
        "\n  fragment FlightsDetailsAndFaresFooterFragment on FlightsDetailsAndFaresFooter {\n    action {\n      ...FlightsActionButtonFragment\n    }\n    dialogId\n    dynamicDialogId\n    priceLockup {\n      ...EGDSPriceLockupFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject99 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject100() {
    var data = _tagged_template_literal([
        "\n  fragment FlightsExperienceActionButtonFragment on FlightsExperienceActionButton {\n    clientAction {\n      ...ClientActionFragment\n    }\n    disabled\n    primary\n    buttonStyle: style\n    accessibility\n    icon {\n      ...IconFragments\n    }\n    analytics {\n      ...ClientSideAnalyticsFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject100 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject101() {
    var data = _tagged_template_literal([
        "\n  fragment FlightsExperienceDialogTriggerFragment on FlightsExperienceDialogTrigger {\n    dialogAction\n    dialogId\n    dynamicDialogId\n    trigger {\n      __typename\n      ...FlightsExperienceActionButtonFragment\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject101 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject102() {
    var data = _tagged_template_literal([
        "\n  fragment FlightsSmartShoppingPriceSummaryFragment on FlightsSmartShoppingPriceSummary {\n    price {\n      ...EGDSSpannableTextFragment\n    }\n    leadingPrice {\n      ...EGDSSpannableTextFragment\n    }\n    primaryText {\n      ...EGDSSpannableTextFragment\n    }\n    secondaryText {\n      ...EGDSSpannableTextFragment\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject102 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject103() {
    var data = _tagged_template_literal([
        "\n  fragment DurationTimelineSideSectionFragment on DurationTimelineSideSection {\n    primary\n    secondaryMessage {\n      shortMessage\n      longMessage\n    }\n    differentDayArrival\n  }\n"
    ]);
    _templateObject103 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject104() {
    var data = _tagged_template_literal([
        "\n  fragment FlightCardDurationTimelineFragment on FlightCardDurationTimeline {\n    primary {\n      ... on EGDSStylizedText {\n        text\n        weight\n      }\n    }\n    secondary {\n      ... on EGDSTextSection {\n        contents {\n          ... on EGDSStylizedText {\n            text\n            weight\n          }\n        }\n      }\n    }\n    stops\n    start {\n      ...DurationTimelineSideSectionFragment\n    }\n    end {\n      ...DurationTimelineSideSectionFragment\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject104 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject105() {
    var data = _tagged_template_literal([
        "\n  fragment FlightsSmartShoppingTertiarySectionFragment on FlightsSmartShoppingTertiarySection {\n    ...FlightCardDurationTimelineFragment\n    ...EGDSGraphicTextFragment\n    ...EGDSTextSectionFragment\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject105 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject106() {
    var data = _tagged_template_literal([
        "\n  fragment FlightsSmartShoppingOfferCardFragment on FlightsSmartShoppingOfferCard {\n    journeyContinuationId\n    sanitizedOfferToken\n    selected\n    sponsoredListingBeacons {\n      renderBeacons\n      clickBeacons\n    }\n    onDisplayAnalyticsList {\n      ...ClientSideAnalyticsFragment\n    }\n    featuredHeader {\n      heading\n    }\n    content {\n      badges {\n        ...EGDSBadgeFragment\n      }\n      secondaryBadges {\n        ...EGDSBadgeFragment\n        size\n      }\n      primarySection {\n        ...EGDSTextSectionFragment\n      }\n      tertiarySection {\n        ...FlightsSmartShoppingTertiarySectionFragment\n      }\n      priceSection {\n        ...FlightsSmartShoppingPriceSummaryFragment\n      }\n    }\n    offerDialogTrigger {\n      ...FlightsExperienceDialogTriggerFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject106 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject107() {
    var data = _tagged_template_literal([
        "\n  fragment FlightsExperienceBargainFareOfferFragment on FlightsExperienceBargainFareOffer {\n    accessibilityMessage\n    bargainPricingInformation {\n      ...FlightsSmartShoppingPriceSummaryFragment\n    }\n    description\n    header\n    offerDialogTrigger {\n      ...FlightsExperienceDialogTriggerFragment\n    }\n    sanitizedOfferToken\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject107 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject108() {
    var data = _tagged_template_literal([
        "\n  fragment FailedRequestMessagingFragment on FlightsActionableErrorMessaging {\n    action {\n      displayAction\n    }\n    icon {\n      ...IconFragments\n    }\n    title\n    message\n  }\n  ",
        "\n"
    ]);
    _templateObject108 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject109() {
    var data = _tagged_template_literal([
        "\n  query FlightsListingsDetailsAndFaresQuery(\n    $context: ContextInput!\n    $flightsSearchContext: FlightsSearchContextInput\n    $journeyCriteria: [FlightsJourneyCriteriaInput!]!\n    $queryState: FlightsQueryState\n    $searchFilterValuesList: [FlightsSearchFilterValuesInput!]\n    $searchPreferences: FlightsSearchPreferencesInput\n    $sortOption: FlightsSortOptionTypeInput\n    $travelerDetails: [FlightsTravelerDetailsInput!]\n    $searchPagination: PaginationInput\n    $shoppingContext: ShoppingContextInput\n    $faresSeparationType: FlightsFaresSeparationType\n    $flightsSearchComponentCriteria: FlightsSearchComponentCriteriaInput\n    $fareCalendarPrice: String\n    $flightsDisplayComponentValues: FlightsDisplayComponentValuesInput\n    $sideSheetQueryContext: SideSheetQueryContextInput\n  ) {\n    flightsSearch(\n      context: $context\n      flightsSearchContext: $flightsSearchContext\n      journeyCriteria: $journeyCriteria\n      queryState: $queryState\n      searchFilterValuesList: $searchFilterValuesList\n      searchPreferences: $searchPreferences\n      sortOption: $sortOption\n      travelerDetails: $travelerDetails\n      searchPagination: $searchPagination\n      shoppingContext: $shoppingContext\n      faresSeparationType: $faresSeparationType\n      flightsSearchComponentCriteria: $flightsSearchComponentCriteria\n      fareCalendarPrice: $fareCalendarPrice\n      flightsDisplayComponentValues: $flightsDisplayComponentValues\n      sideSheetQueryContext: $sideSheetQueryContext\n    ) {\n      smartShoppingExperienceEligibility\n      listingResult {\n        ... on FlightsLoadedListingResult {\n          listings {\n            ... on FlightsStandardOffer {\n              journeyContinuationId\n              journeys {\n                detailsAndFares {\n                  content {\n                    ...FlightsDetailsAndFaresContentFragment\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n      failedRequestMessaging {\n        ...FailedRequestMessagingFragment\n      }\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject109 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject110() {
    var data = _tagged_template_literal([
        "\n  fragment FlightsSideSheetFragment on FlightsSideSheet {\n    title\n    content {\n      ...EGDSElementFragment\n    }\n    footer {\n      ...EGDSElementFragment\n    }\n    initialState\n  }\n\n  ",
        "\n"
    ]);
    _templateObject110 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject111() {
    var data = _tagged_template_literal([
        "\n  fragment FlightsExperienceDialogSheetFragment on FlightsExperienceDialogSheet {\n    dialog {\n      dialog {\n        ...EGDSDialogFragment\n      }\n      dialogId\n    }\n    sheet {\n      title\n      accessibilityMessage\n      footer {\n        ...EGDSElementFragment\n      }\n    }\n    dialogId\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject111 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject112() {
    var data = _tagged_template_literal([
        "\n  fragment DateFragment on Date {\n    day\n    month\n    year\n  }\n"
    ]);
    _templateObject112 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject113() {
    var data = _tagged_template_literal([
        "\n  fragment MultiItemSearchContextFragment on MultiItemSearchContext {\n    flights {\n      primary {\n        journeyCriterias {\n          departureDate {\n            ...DateFragment\n          }\n          origin\n          destination\n        }\n        searchPreferences {\n          cabinClass\n          advancedFilters\n        }\n        tripType\n        travelers {\n          age\n          type\n        }\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject113 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject114() {
    var data = _tagged_template_literal([
        "\n  fragment MultiItemPackageableProductFragment on MultiItemPackageableProduct {\n    flights {\n      offerToken\n      productTokens\n      travelers {\n        age\n        type\n      }\n    }\n  }\n"
    ]);
    _templateObject114 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject115() {
    var data = _tagged_template_literal([
        "\n  fragment MultiItemFlightCrossSellPrimerFragment on MultiItemFlightCrossSellPrimer {\n    flightCrossSellProductType\n    multiItemSearchContext {\n      ...MultiItemSearchContextFragment\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject115 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject116() {
    var data = _tagged_template_literal([
        "\n  fragment FlightsSearchCrossSellOfferFragment on FlightsSearchCrossSellOffer {\n    multiItemFlightCrossSellOfferPrimer {\n      multiItemSearchContext {\n        ...MultiItemSearchContextFragment\n      }\n      multiItemPackageableProduct {\n        ...MultiItemPackageableProductFragment\n      }\n      brandedDealFallBack {\n        ...MultiItemFlightCrossSellPrimerFragment\n      }\n      price {\n        base {\n          amount\n        }\n        taxesAndFees {\n          amount\n        }\n      }\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject116 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject117() {
    var data = _tagged_template_literal([
        "\n  fragment SponsoredContentPlacementFragment on SponsoredContentPlacement {\n    productType\n    sponsoredContentContext {\n      pageName\n      sponsoredContentId\n      targeting {\n        adults\n        dateEnd {\n          ...DateFragment\n        }\n        dateStart {\n          ...DateFragment\n        }\n        destination\n        kids\n        locationResolver\n        origin\n      }\n      variant\n    }\n    __typename\n  }\n\n  ",
        "\n"
    ]);
    _templateObject117 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject118() {
    var data = _tagged_template_literal([
        "\n  fragment FlightsSmartShoppingLoadedListingsFragment on FlightsSmartShoppingLoadedListings {\n    accessibilityMessage\n    flightsListingsAnalytics {\n      ...ClientSideAnalyticsFragment\n    }\n    listings {\n      ...FlightsSmartShoppingOfferCardFragment\n      ...FlightsExperienceBargainFareOfferFragment\n      ...EGDSStylizedTextFragment\n      ...SponsoredContentPlacementFragment\n      ...FlightsSearchCrossSellOfferFragment\n    }\n    flightsDetailsAndFaresWrapper {\n      ...FlightsExperienceDialogSheetFragment\n    }\n    toast {\n      text\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject118 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject119() {
    var data = _tagged_template_literal([
        "\n  fragment FlightsServerErrorFragment on FlightsServerError {\n    heading\n    message\n    icon {\n      ...IconFragments\n    }\n    action {\n      ...FlightsActionButtonFragment\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject119 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject120() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSBasicPillFragment on EGDSBasicPill {\n    accessibility\n    deselectAnalytics {\n      ...ClientSideAnalyticsFragment\n    }\n    disabled\n    icon {\n      ...UIGraphicFragment\n    }\n    name\n    primary\n    selectAnalytics {\n      ...ClientSideAnalyticsFragment\n    }\n    selected\n    value\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject120 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject121() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSBasicRemovablePillFragment on EGDSBasicRemovablePill {\n    accessibility\n    disabled\n    icon {\n      ...UIGraphicFragment\n    }\n    name\n    primary\n    remove {\n      ...UIGraphicFragment\n    }\n    removeAnalytics {\n      ...ClientSideAnalyticsFragment\n    }\n    selected\n    value\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject121 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject122() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSPillFragment on EGDSPill {\n    __typename\n    ...EGDSBasicPillFragment\n    ...EGDSBasicRemovablePillFragment\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject122 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject123() {
    var data = _tagged_template_literal([
        "\n  fragment FlightsBasicShoppingAppliedFilterFragment on BasicShoppingAppliedFilter {\n    filter {\n      ...EGDSPillFragment\n    }\n    nextSearchCriteria {\n      __typename\n      selections {\n        __typename\n        id\n        value\n      }\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject123 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject124() {
    var data = _tagged_template_literal([
        "\n  fragment FlightsShoppingAppliedFilterFragment on ShoppingAppliedFilter {\n    ...FlightsBasicShoppingAppliedFilterFragment\n  }\n\n  ",
        "\n"
    ]);
    _templateObject124 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject125() {
    var data = _tagged_template_literal([
        "\n  fragment FlightsSmartShoppingOverFilteringErrorFragment on FlightsSmartShoppingOverFilteringError {\n    heading\n    message\n    errorAction {\n      ...FlightsExperienceActionButtonFragment\n    }\n    filterPills {\n      ...FlightsShoppingAppliedFilterFragment\n    }\n    icon {\n      ...IconFragments\n    }\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject125 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject126() {
    var data = _tagged_template_literal([
        "\n  fragment FlightsOnLoadErrorFragment on FlightsOnLoadError {\n    ...FlightsServerErrorFragment\n    ...FlightsSmartShoppingOverFilteringErrorFragment\n    analytics {\n      ...ClientSideImpressionEventAnalyticsFragment\n    }\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject126 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject127() {
    var data = _tagged_template_literal([
        "\n  fragment FlightsSmartShoppingListingsErrorFragment on FlightsSmartShoppingListingsError {\n    errorResponse {\n      ...FlightsOnLoadErrorFragment\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject127 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject128() {
    var data = _tagged_template_literal([
        "\n  query FlightsListingsLoadedQuery(\n    $context: ContextInput!\n    $journeyCriteria: [FlightsJourneyCriteriaInput!]!\n    $searchPreferences: FlightsSearchPreferencesInput\n    $shoppingContext: ShoppingContextInput\n    $travelerDetails: [FlightsSmartShoppingTravelerDetailsInput!]!\n    $flightsSearchContext: FlightsSearchContextInput!\n    $queryState: FlightsQueryState\n    $requestToast: FlightsFilterType\n    $sortOption: FlightsSortOptionTypeInput\n    $flightSearchFilterValuesList: [FlightsSearchFilterValuesInput!]\n  ) {\n    flightsListings(\n      context: $context\n      journeyCriteria: $journeyCriteria\n      searchPreferences: $searchPreferences\n      shoppingContext: $shoppingContext\n      travelerDetails: $travelerDetails\n      flightsSearchContext: $flightsSearchContext\n      queryState: $queryState\n      requestToast: $requestToast\n      sortOption: $sortOption\n      flightSearchFilterValuesList: $flightSearchFilterValuesList\n    ) {\n      __typename\n\n      ... on FlightsSmartShoppingLoadedListings {\n        ...FlightsSmartShoppingLoadedListingsFragment\n      }\n\n      ... on FlightsSmartShoppingListingsError {\n        ...FlightsSmartShoppingListingsErrorFragment\n      }\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject128 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject129() {
    var data = _tagged_template_literal([
        "\n  fragment FlightsSmartShoppingLoadingListingsFragment on FlightsSmartShoppingLoadingListings {\n    accessibility\n    listingsSkeletonCount\n    message\n    originDestination\n  }\n"
    ]);
    _templateObject129 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject130() {
    var data = _tagged_template_literal([
        "\n  query FlightsListingsQuery(\n    $context: ContextInput!\n    $flightSearchFilterValuesList: [FlightsSearchFilterValuesInput!]\n    $flightsSearchContext: FlightsSearchContextInput!\n    $journeyCriteria: [FlightsJourneyCriteriaInput!]!\n    $queryState: FlightsQueryState\n    $requestToast: FlightsFilterType\n    $searchPreferences: FlightsSearchPreferencesInput\n    $shoppingContext: ShoppingContextInput\n    $travelerDetails: [FlightsSmartShoppingTravelerDetailsInput!]!\n    $sortOption: FlightsSortOptionTypeInput\n  ) {\n    flightsListings(\n      context: $context\n      flightSearchFilterValuesList: $flightSearchFilterValuesList\n      flightsSearchContext: $flightsSearchContext\n      journeyCriteria: $journeyCriteria\n      queryState: $queryState\n      requestToast: $requestToast\n      searchPreferences: $searchPreferences\n      shoppingContext: $shoppingContext\n      travelerDetails: $travelerDetails\n      sortOption: $sortOption\n    ) {\n      ...FlightsSmartShoppingLoadingListingsFragment\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject130 = function _templateObject() {
        return data;
    };
    return data;
}
import React133, { useCallback as useCallback6, useState as useState3 } from "react";
import { gql as gql129, useQuery as useQuery3 } from "@apollo/client";
import { useBexApi as useBexApi3 } from "@shared-ui/bex-api-context";
// src/__generated__/globalTypes.ts
var FlightsCabinClass = /* @__PURE__ */ function(FlightsCabinClass2) {
    FlightsCabinClass2["BUSINESS"] = "BUSINESS";
    FlightsCabinClass2["COACH"] = "COACH";
    FlightsCabinClass2["FIRST"] = "FIRST";
    FlightsCabinClass2["PREMIUM_ECONOMY"] = "PREMIUM_ECONOMY";
    return FlightsCabinClass2;
}(FlightsCabinClass || {});
var FlightsSortType = /* @__PURE__ */ function(FlightsSortType2) {
    FlightsSortType2["ARRIVAL"] = "ARRIVAL";
    FlightsSortType2["BEST_BETS"] = "BEST_BETS";
    FlightsSortType2["BEST_SORT"] = "BEST_SORT";
    FlightsSortType2["CROSS_SORT"] = "CROSS_SORT";
    FlightsSortType2["DEPARTURE"] = "DEPARTURE";
    FlightsSortType2["DURATION"] = "DURATION";
    FlightsSortType2["NONSTOP"] = "NONSTOP";
    FlightsSortType2["PRICE"] = "PRICE";
    FlightsSortType2["RECOMMENDED"] = "RECOMMENDED";
    return FlightsSortType2;
}(FlightsSortType || {});
var FlightsTravelerType = /* @__PURE__ */ function(FlightsTravelerType2) {
    FlightsTravelerType2["ADULT"] = "ADULT";
    FlightsTravelerType2["CHILD"] = "CHILD";
    FlightsTravelerType2["INFANT_IN_LAP"] = "INFANT_IN_LAP";
    FlightsTravelerType2["INFANT_IN_SEAT"] = "INFANT_IN_SEAT";
    return FlightsTravelerType2;
}(FlightsTravelerType || {});
var FlightsTripType = /* @__PURE__ */ function(FlightsTripType2) {
    FlightsTripType2["MULTI_DESTINATION"] = "MULTI_DESTINATION";
    FlightsTripType2["ONE_WAY"] = "ONE_WAY";
    FlightsTripType2["ROUND_TRIP"] = "ROUND_TRIP";
    return FlightsTripType2;
}(FlightsTripType || {});
var TravelerDetailsType = /* @__PURE__ */ function(TravelerDetailsType2) {
    TravelerDetailsType2["ADULT"] = "ADULT";
    TravelerDetailsType2["CHILD"] = "CHILD";
    TravelerDetailsType2["INFANT_IN_LAP"] = "INFANT_IN_LAP";
    TravelerDetailsType2["INFANT_IN_SEAT"] = "INFANT_IN_SEAT";
    return TravelerDetailsType2;
}(TravelerDetailsType || {});
// src/components/smart-shopping-listings/__private/__fragments/listing-loading-offers.tsx
import React2 from "react";
// ../internal/src/components/flights-smart-shopping-offer-card/flights-smart-shopping-skeleton-card.tsx
import React from "react";
import { ViewLarge, Viewport, ViewSmall } from "@shared-ui/viewport-context";
import { UitkCardContentSection } from "uitk-react-cards";
import { UitkLayoutFlex } from "uitk-react-layout-flex";
import { UitkLineSkeleton } from "uitk-react-skeleton";
import { UitkSpacing } from "uitk-react-spacing";
var lineSpacing = {
    margin: {
        blockend: "two"
    }
};
var smallBottomLineSpacing = {
    margin: {
        blockstart: "twelve"
    }
};
var SmallViewSkeletons = function(param) {
    var tag = param.tag, border = param.border;
    return /* @__PURE__ */ React.createElement(UitkSpacing, null, /* @__PURE__ */ React.createElement(UitkCardContentSection, {
        tag: tag,
        border: border
    }, /* @__PURE__ */ React.createElement(UitkSpacing, {
        margin: lineSpacing.margin
    }, /* @__PURE__ */ React.createElement(UitkLineSkeleton, {
        animation: true
    })), /* @__PURE__ */ React.createElement(UitkSpacing, {
        margin: lineSpacing.margin
    }, /* @__PURE__ */ React.createElement(UitkLineSkeleton, {
        animation: true,
        type: "secondary"
    })), /* @__PURE__ */ React.createElement(UitkSpacing, {
        margin: smallBottomLineSpacing.margin
    }, /* @__PURE__ */ React.createElement(UitkLayoutFlex, {
        justifyContent: "space-between"
    }, /* @__PURE__ */ React.createElement(UitkLineSkeleton, {
        animation: true,
        type: "secondary"
    }), /* @__PURE__ */ React.createElement(UitkLineSkeleton, {
        animation: true,
        type: "secondary"
    })))));
};
var LargeViewSkeletons = function(param) {
    var tag = param.tag, border = param.border;
    return /* @__PURE__ */ React.createElement(UitkSpacing, null, /* @__PURE__ */ React.createElement(UitkCardContentSection, {
        padded: true,
        tag: tag,
        border: border
    }, /* @__PURE__ */ React.createElement(UitkSpacing, {
        margin: lineSpacing.margin
    }, /* @__PURE__ */ React.createElement(UitkLineSkeleton, {
        animation: true
    })), /* @__PURE__ */ React.createElement(UitkSpacing, {
        margin: lineSpacing.margin
    }, /* @__PURE__ */ React.createElement(UitkLayoutFlex, {
        justifyContent: "space-between"
    }, /* @__PURE__ */ React.createElement(UitkLineSkeleton, {
        animation: true,
        type: "secondary"
    }), /* @__PURE__ */ React.createElement(UitkLineSkeleton, {
        animation: true
    }))), /* @__PURE__ */ React.createElement(UitkLayoutFlex, {
        direction: "column",
        alignItems: "end"
    }, /* @__PURE__ */ React.createElement(UitkSpacing, {
        margin: lineSpacing.margin
    }, /* @__PURE__ */ React.createElement(UitkLineSkeleton, {
        animation: true,
        type: "secondary"
    }))), /* @__PURE__ */ React.createElement(UitkLineSkeleton, {
        animation: true,
        type: "secondary"
    })));
};
var FlightsSmartShoppingSkeletonCard = function(param) {
    var tag = param.tag, border = param.border;
    return /* @__PURE__ */ React.createElement(Viewport, null, /* @__PURE__ */ React.createElement(ViewSmall, null, /* @__PURE__ */ React.createElement(SmallViewSkeletons, {
        tag: tag,
        border: border
    })), /* @__PURE__ */ React.createElement(ViewLarge, null, /* @__PURE__ */ React.createElement(LargeViewSkeletons, {
        tag: tag,
        border: border
    })));
};
// src/components/smart-shopping-listings/__private/__fragments/listing-loading-offers.tsx
import { UitkCard as UitkCard2 } from "uitk-react-cards";
import { UitkList } from "uitk-react-list";
var ListingsLoadingOffers = function(param) {
    var _param_count = param.count, count = _param_count === void 0 ? 7 : _param_count;
    return /* @__PURE__ */ React2.createElement(UitkCard2, null, /* @__PURE__ */ React2.createElement(UitkList, {
        bullet: "no-bullet",
        spacing: false,
        "data-test-id": "listing-skeletons",
        "data-stid": "listing-skeletons"
    }, _to_consumable_array(Array(count)).map(function(nullElem, index) {
        return /* @__PURE__ */ React2.createElement(FlightsSmartShoppingSkeletonCard, {
            key: "listing-skeleton-".concat(index),
            tag: "li",
            border: count - 1 !== index ? "bottom" : void 0
        });
    })));
};
// src/components/smart-shopping-listings/__private/flights-listings-loaded.tsx
import React130, { useCallback as useCallback5, useEffect as useEffect5, useState as useState2 } from "react";
import { gql as gql127, useQuery as useQuery2 } from "@apollo/client";
import { useBexApi as useBexApi2 } from "@shared-ui/bex-api-context";
import { classNames } from "uitk-react-utils";
// src/components/smart-shopping-listings/__private/__fragments/flight-smart-shopping-loaded-listings.tsx
import React120, { useCallback as useCallback4, useReducer } from "react";
import { gql as gql117 } from "@apollo/client";
import { useClickstreamAnalytics as useClickstreamAnalytics12 } from "@shared-ui/clickstream-analytics-context";
// ../internal/src/components/egds-element/egds-element.tsx
import React31 from "react";
import { gql as gql32 } from "@apollo/client";
// ../internal/src/components/egds-bulleted-list/egds-bulleted-list.tsx
import React24 from "react";
import { gql as gql23 } from "@apollo/client";
import { UitkList as UitkList3 } from "uitk-react-list";
// ../internal/src/components/egds-list/egds-text-list-item.tsx
import React23 from "react";
import { gql as gql22 } from "@apollo/client";
// ../internal/src/components/egds-list/egds-text-icon-list-item.tsx
import React7 from "react";
import { gql as gql5 } from "@apollo/client";
import { UitkListItem } from "uitk-react-list";
// ../internal/src/components/ui-graphic/icon.tsx
import React3 from "react";
import { gql } from "@apollo/client";
import { UitkIcon, UitkIconSize } from "uitk-react-icons";
var _obj;
// ../internal/src/utils/icon-spotlight-mapper.ts
var SPOTLIGHT_MAP = (_obj = {}, _define_property(_obj, "INFO" /* INFO */ , "info"), _define_property(_obj, "POSITIVE" /* POSITIVE */ , "positive"), _define_property(_obj, "STANDARD" /* STANDARD */ , "standard"), _define_property(_obj, "WARNING" /* WARNING */ , "warning"), _obj);
// ../internal/src/components/ui-graphic/icon.tsx
var IconFragment = gql(_templateObject());
var _data_title, _data_theme, _ref;
var Icon = function(param) {
    var className = param.className, data = param.data, spotlight = param.spotlight;
    var _data;
    return /* @__PURE__ */ React3.createElement(UitkIcon, {
        className: className,
        description: data.description,
        id: data.id,
        name: data.id,
        size: data.size ? UitkIconSize[data.size] : void 0,
        title: (_data_title = data.title) !== null && _data_title !== void 0 ? _data_title : void 0,
        theme: (_data_theme = (_data = data) === null || _data === void 0 ? void 0 : _data.theme) !== null && _data_theme !== void 0 ? _data_theme : "default",
        shadow: Boolean(data.withBackground),
        spotlight: (_ref = data.spotLight && SPOTLIGHT_MAP[data.spotLight] || spotlight) !== null && _ref !== void 0 ? _ref : void 0
    });
};
Icon.displayName = "UitkIcon";
Icon.fragment = IconFragment;
// ../internal/src/components/ui-graphic/mark.tsx
import React4 from "react";
import { gql as gql2 } from "@apollo/client";
import { UitkMark, UitkMarkSize } from "uitk-react-mark";
var MarkFragment = gql2(_templateObject1());
var Mark = function(param) {
    var className = param.className, data = param.data;
    var _data_url;
    return /* @__PURE__ */ React4.createElement(UitkMark, {
        className: className,
        description: data.description,
        id: data.id,
        name: data.id,
        size: data.markSize ? UitkMarkSize[data.markSize] : void 0,
        url: (_data_url = data.url) === null || _data_url === void 0 ? void 0 : _data_url.value
    });
};
Mark.displayName = "Mark";
Mark.fragment = MarkFragment;
// ../internal/src/components/ui-graphic/illustration.tsx
import React5 from "react";
import { gql as gql3 } from "@apollo/client";
import { UitkIllustrations } from "uitk-react-illustrations";
var IllustrationFragment = gql3(_templateObject2());
var Illustration = function(param) {
    var data = param.data;
    return /* @__PURE__ */ React5.createElement(UitkIllustrations, {
        alt: data.description,
        url: data.link
    });
};
Illustration.displayName = "Illustration";
Illustration.fragment = IllustrationFragment;
// ../internal/src/components/ui-graphic/ui-graphic.tsx
import React6 from "react";
import { gql as gql4 } from "@apollo/client";
var __UIGraphicFragment = gql4(_templateObject3(), Icon.fragment, Mark.fragment, Illustration.fragment);
var UiGraphic = function(param) {
    var className = param.className, data = param.data;
    switch(data.__typename){
        case "Icon":
            return /* @__PURE__ */ React6.createElement(Icon, {
                className: className,
                data: data
            });
        case "Mark":
            return /* @__PURE__ */ React6.createElement(Mark, {
                className: className,
                data: data
            });
        case "Illustration":
            return /* @__PURE__ */ React6.createElement(Illustration, {
                data: data
            });
        default:
            return null;
    }
};
UiGraphic.displayName = "UiGraphic";
UiGraphic.fragment = __UIGraphicFragment;
// ../internal/src/components/egds-list/egds-text-icon-list-item.tsx
var fragment = gql5(_templateObject4(), Icon.fragment);
var EGDSTextIconListItem = function(param) {
    var data = param.data;
    var text = data.text, icon = data.icon;
    return /* @__PURE__ */ React7.createElement(UitkListItem, null, /* @__PURE__ */ React7.createElement(Icon, {
        data: icon
    }), text);
};
EGDSTextIconListItem.fragment = fragment;
EGDSTextIconListItem.displayName = "EGDSTextListItem";
// ../internal/src/components/egds-list/egds-text-standard-list-item.tsx
import React10 from "react";
import { gql as gql8 } from "@apollo/client";
import { UitkListItem as UitkListItem3 } from "uitk-react-list";
// ../internal/src/components/egds-list/egds-nested-level-one-list.tsx
import React9 from "react";
import { gql as gql7 } from "@apollo/client";
import { UitkList as UitkList2 } from "uitk-react-list";
// ../internal/src/components/egds-list/egds-nested-level-one-list-item.tsx
import React8 from "react";
import { gql as gql6 } from "@apollo/client";
import { UitkListItem as UitkListItem2 } from "uitk-react-list";
var fragment2 = gql6(_templateObject5());
var EGDSNestedLevelOneListItem = function(param) {
    var data = param.data;
    var text = data.text;
    return /* @__PURE__ */ React8.createElement(UitkListItem2, null, text);
};
EGDSNestedLevelOneListItem.fragment = fragment2;
EGDSNestedLevelOneListItem.displayName = "EGDSNestedLevelOneListItem";
// ../internal/src/components/egds-list/egds-nested-level-one-list.tsx
var fragment3 = gql7(_templateObject6(), EGDSNestedLevelOneListItem.fragment);
var EGDSNestedLevelOneList = function(param) {
    var data = param.data;
    var _items;
    var items = data.items;
    return /* @__PURE__ */ React9.createElement(UitkList2, null, (_items = items) === null || _items === void 0 ? void 0 : _items.map(function(item, index) {
        return /* @__PURE__ */ React9.createElement(EGDSNestedLevelOneListItem, {
            data: item,
            key: "nested-list-item-".concat(index)
        });
    }), " ");
};
EGDSNestedLevelOneList.fragment = fragment3;
EGDSNestedLevelOneList.displayName = "EGDSNestedLevelOneList";
// ../internal/src/components/egds-list/egds-text-standard-list-item.tsx
var fragment4 = gql8(_templateObject7(), EGDSNestedLevelOneList.fragment);
var EGDSTextStandardListItem = function(param) {
    var data = param.data;
    var text = data.text, nestedLevelOneList = data.nestedLevelOneList;
    return /* @__PURE__ */ React10.createElement(UitkListItem3, null, text, nestedLevelOneList && /* @__PURE__ */ React10.createElement(EGDSNestedLevelOneList, {
        data: nestedLevelOneList
    }));
};
EGDSTextStandardListItem.fragment = fragment4;
EGDSTextStandardListItem.displayName = "EGDSTextListItem";
// ../internal/src/components/egds-list/flights-text-container-list-item.tsx
import React22 from "react";
import { gql as gql21 } from "@apollo/client";
import { UitkListItem as UitkListItem4 } from "uitk-react-list";
// ../internal/src/components/egds-text/egds-heading.tsx
import React11 from "react";
import { gql as gql9 } from "@apollo/client";
import { UitkHeading } from "uitk-react-text";
var _obj1;
// ../internal/src/components/egds-text/__private/heading-map.ts
var headingTagMapper = (_obj1 = {}, _define_property(_obj1, "H1" /* H1 */ , "h1"), _define_property(_obj1, "H2" /* H2 */ , "h2"), _define_property(_obj1, "H3" /* H3 */ , "h3"), _define_property(_obj1, "H4" /* H4 */ , "h4"), _define_property(_obj1, "H5" /* H5 */ , "h5"), _define_property(_obj1, "H6" /* H6 */ , "h6"), _define_property(_obj1, "H7" /* H7 */ , "h6"), _define_property(_obj1, "H8" /* H8 */ , "h6"), _obj1);
// ../internal/src/components/egds-text/egds-heading.tsx
var fragment5 = gql9(_templateObject8());
var EGDSHeading = function(param) {
    var className = param.className, size = param.size, align = param.align, data = param.data, tag = param.tag;
    var headingType = data.headingType, text = data.text;
    var getHeadingTag = function() {
        if (headingType) {
            return headingTagMapper[headingType];
        }
        if (tag) {
            return tag;
        }
        return void 0;
    };
    return /* @__PURE__ */ React11.createElement(UitkHeading, {
        className: className,
        tag: getHeadingTag(),
        size: size,
        align: align
    }, text);
};
EGDSHeading.fragment = fragment5;
EGDSHeading.displayName = "EGDSHeading";
// ../internal/src/components/egds-text/egds-paragraph.tsx
import React12 from "react";
import { gql as gql10 } from "@apollo/client";
import { UitkParagraph } from "uitk-react-text";
var _obj2;
// ../internal/src/components/egds-text/__private/paragraph-style-size-map.ts
var paragraphStyleSizeMap = (_obj2 = {}, _define_property(_obj2, "P1" /* P1 */ , 1), _define_property(_obj2, "P2" /* P2 */ , 2), _define_property(_obj2, "P3" /* P3 */ , 3), _obj2);
// ../internal/src/components/egds-text/egds-paragraph.tsx
var fragment6 = gql10(_templateObject9());
var EGDSParagraph = function(param) {
    var className = param.className, data = param.data;
    var text = data.text, style = data.style;
    return /* @__PURE__ */ React12.createElement(UitkParagraph, {
        className: className,
        size: paragraphStyleSizeMap[style]
    }, text);
};
EGDSParagraph.fragment = fragment6;
EGDSParagraph.displayName = "EGDSParagraph";
// ../internal/src/components/egds-text/egds-standard-link.tsx
import React13 from "react";
import { gql as gql12 } from "@apollo/client";
import { useClickTracker } from "@shared-ui/clickstream-analytics-context";
import { UitkLink } from "uitk-react-link";
// ../internal/src/components/common/link-action.tsx
import { gql as gql11 } from "@apollo/client";
var linkActionFragment = gql11(_templateObject10());
var _obj3;
// ../internal/src/components/egds-text/__private/link-map.ts
var linkSizeMapper = (_obj3 = {}, _define_property(_obj3, "SMALL" /* SMALL */ , "small"), _define_property(_obj3, "MEDIUM" /* MEDIUM */ , "medium"), _define_property(_obj3, "LARGE" /* LARGE */ , "medium"), _obj3);
var _obj4;
var UILinkTargetMap = (_obj4 = {}, _define_property(_obj4, "EXTERNAL" /* EXTERNAL */ , "_blank"), _define_property(_obj4, "INTERNAL" /* INTERNAL */ , "_self"), _obj4);
// ../internal/src/components/egds-text/egds-standard-link.tsx
var fragment7 = gql12(_templateObject11(), linkActionFragment, Icon.fragment);
var IconPlacement = function(param) {
    var icon = param.icon, iconPosition = param.iconPosition, iconPositionToMatch = param.iconPositionToMatch;
    if (icon && iconPosition === iconPositionToMatch) {
        return /* @__PURE__ */ React13.createElement(Icon, {
            data: icon
        });
    }
    return null;
};
var EGDSStandardLink = function(param) {
    var className = param.className, inline = param.inline, align = param.align, _param_data = param.data, _param_data_action = _param_data.action, analytics = _param_data_action.analytics, resource = _param_data_action.resource, target = _param_data_action.target, useRelativePath = _param_data_action.useRelativePath, iconPosition = _param_data.iconPosition, standardLinkIcon = _param_data.standardLinkIcon, size = _param_data.size, text = _param_data.text;
    var clickTracker = useClickTracker();
    var url = React13.useMemo(function() {
        if (resource.__typename === "HttpURI" && (useRelativePath !== null && useRelativePath !== void 0 ? useRelativePath : true)) {
            return resource.relativePath || resource.value;
        }
        return resource.value;
    }, [
        resource,
        useRelativePath
    ]);
    var onClick = React13.useCallback(function() {
        clickTracker(analytics.referrerId, analytics.linkName);
    }, [
        clickTracker,
        analytics
    ]);
    return /* @__PURE__ */ React13.createElement(UitkLink, {
        className: className,
        size: linkSizeMapper[size],
        onClickCapture: onClick,
        inline: inline,
        align: align
    }, /* @__PURE__ */ React13.createElement("a", {
        target: UILinkTargetMap[target],
        href: url
    }, /* @__PURE__ */ React13.createElement(IconPlacement, {
        icon: standardLinkIcon,
        iconPosition: iconPosition,
        iconPositionToMatch: "LEADING" /* LEADING */ 
    }), text, /* @__PURE__ */ React13.createElement(IconPlacement, {
        icon: standardLinkIcon,
        iconPosition: iconPosition,
        iconPositionToMatch: "TRAILING" /* TRAILING */ 
    })));
};
EGDSStandardLink.fragment = fragment7;
EGDSStandardLink.displayName = "EGDSStandardLink";
// ../internal/src/components/egds-text/egds-text.tsx
import React21 from "react";
import { gql as gql20 } from "@apollo/client";
// ../internal/src/components/egds-text/egds-graphic-text.tsx
import React14 from "react";
import { gql as gql13 } from "@apollo/client";
import { UitkLayoutFlex as UitkLayoutFlex2, UitkLayoutFlexItem } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing2 } from "uitk-react-spacing";
import { UitkText } from "uitk-react-text";
var fragment8 = gql13(_templateObject12(), UiGraphic.fragment);
var EGDSGraphicText = function(param) {
    var className = param.className, inline = param.inline, size = param.size, textOnTop = param.textOnTop, shouldWrapInFlex = param.shouldWrapInFlex, data = param.data;
    var _trailingGraphics;
    var text = data.text, textGraphic = data.textGraphic, trailingGraphics = data.trailingGraphics;
    if (shouldWrapInFlex) {
        var _data_trailingGraphics;
        return /* @__PURE__ */ React14.createElement("div", null, /* @__PURE__ */ React14.createElement(UitkLayoutFlex2, {
            space: "three"
        }, /* @__PURE__ */ React14.createElement(UitkLayoutFlexItem, {
            alignSelf: "center"
        }, /* @__PURE__ */ React14.createElement(UiGraphic, {
            data: data.textGraphic
        })), /* @__PURE__ */ React14.createElement(UitkLayoutFlexItem, {
            alignSelf: "center"
        }, /* @__PURE__ */ React14.createElement(UitkText, {
            inline: true,
            className: className,
            size: size,
            weight: "regular"
        }, text)), (_data_trailingGraphics = data.trailingGraphics) === null || _data_trailingGraphics === void 0 ? void 0 : _data_trailingGraphics.map(function(graphicItem, index) {
            return /* @__PURE__ */ React14.createElement(UitkLayoutFlexItem, {
                key: "addon-icon-".concat(index)
            }, /* @__PURE__ */ React14.createElement(UitkSpacing2, {
                padding: {
                    inlinestart: "two"
                }
            }, /* @__PURE__ */ React14.createElement(UiGraphic, {
                data: graphicItem
            })));
        })));
    }
    if (textOnTop) {
        var _data_trailingGraphics1;
        return /* @__PURE__ */ React14.createElement(React14.Fragment, null, /* @__PURE__ */ React14.createElement(UitkSpacing2, {
            padding: {
                blockend: "one"
            }
        }, /* @__PURE__ */ React14.createElement(UitkText, {
            size: size,
            align: "center",
            weight: "regular"
        }, data.text)), /* @__PURE__ */ React14.createElement(UitkLayoutFlex2, {
            justifyContent: "center"
        }, /* @__PURE__ */ React14.createElement(UiGraphic, {
            data: data.textGraphic
        }), (_data_trailingGraphics1 = data.trailingGraphics) === null || _data_trailingGraphics1 === void 0 ? void 0 : _data_trailingGraphics1.map(function(graphicItem, index) {
            return /* @__PURE__ */ React14.createElement(UitkSpacing2, {
                padding: {
                    inlinestart: "two"
                },
                key: "addon-icon-".concat(index)
            }, /* @__PURE__ */ React14.createElement(UiGraphic, {
                data: graphicItem
            }));
        })));
    }
    return /* @__PURE__ */ React14.createElement(UitkText, {
        inline: inline
    }, /* @__PURE__ */ React14.createElement(UiGraphic, {
        data: textGraphic
    }), /* @__PURE__ */ React14.createElement(UitkSpacing2, {
        padding: {
            inline: "one"
        }
    }, /* @__PURE__ */ React14.createElement(UitkText, {
        className: className,
        inline: true,
        size: size
    }, text)), (_trailingGraphics = trailingGraphics) === null || _trailingGraphics === void 0 ? void 0 : _trailingGraphics.map(function(graphicItem, index) {
        return /* @__PURE__ */ React14.createElement(UiGraphic, {
            data: graphicItem,
            key: "trailing-graphic-".concat(index)
        });
    }));
};
EGDSGraphicText.fragment = fragment8;
EGDSGraphicText.displayName = "EGDSGraphicText";
// ../internal/src/components/egds-text/egds-icon-text.tsx
import React15 from "react";
import { gql as gql14 } from "@apollo/client";
import { UitkSpacing as UitkSpacing3 } from "uitk-react-spacing";
import { UitkText as UitkText2 } from "uitk-react-text";
var fragment9 = gql14(_templateObject13(), Icon.fragment);
var EGDSIconText = function(param) {
    var className = param.className, data = param.data, iconSpacing5 = param.iconSpacing, inline = param.inline, size = param.size, spacing3 = param.spacing, align = param.align;
    var _spacing3, _spacing31;
    var icon = data.icon, text = data.text;
    return /* @__PURE__ */ React15.createElement(UitkSpacing3, {
        margin: (_spacing3 = spacing3) === null || _spacing3 === void 0 ? void 0 : _spacing3.margin,
        padding: (_spacing31 = spacing3) === null || _spacing31 === void 0 ? void 0 : _spacing31.padding
    }, /* @__PURE__ */ React15.createElement(UitkText2, {
        inline: inline,
        className: className,
        size: size,
        align: align
    }, iconSpacing5 ? /* @__PURE__ */ React15.createElement(UitkSpacing3, {
        margin: iconSpacing5.margin,
        padding: iconSpacing5.padding
    }, /* @__PURE__ */ React15.createElement(Icon, {
        data: icon
    })) : /* @__PURE__ */ React15.createElement(Icon, {
        data: icon
    }), text));
};
EGDSIconText.fragment = fragment9;
EGDSIconText.displayName = "EGDSIconText";
// ../internal/src/components/egds-text/egds-inline-link.tsx
import React16 from "react";
import { gql as gql15 } from "@apollo/client";
import { useClickTracker as useClickTracker2 } from "@shared-ui/clickstream-analytics-context";
import { UitkLink as UitkLink2 } from "uitk-react-link";
var fragment10 = gql15(_templateObject14(), linkActionFragment);
var EGDSInlineLink = function(param) {
    var className = param.className, _param_data = param.data, _param_data_action = _param_data.action, analytics = _param_data_action.analytics, resource = _param_data_action.resource, target = _param_data_action.target, accessibility = _param_data_action.accessibility, size = _param_data.size, text = _param_data.text;
    var clickTracker = useClickTracker2();
    var url = resource.__typename === "HttpURI" ? resource.relativePath || resource.value : resource.value;
    var onClick = React16.useCallback(function() {
        clickTracker(analytics.referrerId, analytics.linkName);
    }, [
        clickTracker,
        analytics
    ]);
    return /* @__PURE__ */ React16.createElement(UitkLink2, {
        className: className,
        size: linkSizeMapper[size],
        onClickCapture: onClick,
        inline: true
    }, /* @__PURE__ */ React16.createElement("a", {
        href: url,
        target: UILinkTargetMap[target]
    }, text, accessibility && /* @__PURE__ */ React16.createElement("span", {
        className: "is-visually-hidden"
    }, accessibility)));
};
EGDSInlineLink.fragment = fragment10;
EGDSInlineLink.displayName = "EGDSInlineLink";
// ../internal/src/components/egds-text/egds-plain-text.tsx
import React17 from "react";
import { gql as gql16 } from "@apollo/client";
import { UitkText as UitkText3 } from "uitk-react-text";
var fragment11 = gql16(_templateObject15());
var EGDSPlainText = function(param) {
    var className = param.className, inline = param.inline, size = param.size, align = param.align, overflow = param.overflow, data = param.data, dataStid = param.dataStid;
    var text = data.text;
    return /* @__PURE__ */ React17.createElement(UitkText3, {
        "data-stid": dataStid,
        overflow: overflow,
        className: className,
        inline: inline,
        size: size,
        align: align
    }, text);
};
EGDSPlainText.fragment = fragment11;
EGDSPlainText.displayName = "EGDSPlainText";
// ../internal/src/components/egds-text/egds-spannable-text/egds-spannable-text.tsx
import React20 from "react";
import { gql as gql19 } from "@apollo/client";
import { UitkText as UitkText5 } from "uitk-react-text";
// ../internal/src/components/egds-text/egds-spannable-text/egds-spannable-text-content.tsx
import React19 from "react";
import { gql as gql18 } from "@apollo/client";
// ../internal/src/components/egds-text/egds-stylized-text.tsx
import React18 from "react";
import { gql as gql17 } from "@apollo/client";
import { UitkText as UitkText4 } from "uitk-react-text";
// ../internal/src/components/egds-text/__private/text-size.ts
var textSizeMapper = {
    "100": 100,
    "200": 200,
    "300": 300,
    "400": 400,
    "500": 500,
    "600": 600,
    "700": 700,
    "800": 800,
    "900": 900
};
var _obj5;
// ../internal/src/components/egds-text/__private/text-theme.ts
var textThemeMapper = (_obj5 = {}, _define_property(_obj5, "EMPHASIS" /* EMPHASIS */ , "emphasis"), _define_property(_obj5, "LOYALTY" /* LOYALTY */ , "loyalty"), _define_property(_obj5, "INVERSE" /* INVERSE */ , "inverse"), _define_property(_obj5, "NEGATIVE" /* NEGATIVE */ , "negative"), _define_property(_obj5, "POSITIVE" /* POSITIVE */ , "positive"), _define_property(_obj5, "PRIMARY" /* PRIMARY */ , "emphasis"), _define_property(_obj5, "SECONDARY" /* SECONDARY */ , "default"), _define_property(_obj5, "INVERSE" /* INVERSE */ , "inverse"), _define_property(_obj5, "EMPHASIS" /* EMPHASIS */ , "emphasis"), _obj5);
var _obj6;
// ../internal/src/components/egds-text/__private/text-weight.ts
var textWeightMapper = (_obj6 = {}, _define_property(_obj6, "BOLD" /* BOLD */ , "bold"), _define_property(_obj6, "MEDIUM" /* MEDIUM */ , "medium"), _define_property(_obj6, "REGULAR" /* REGULAR */ , "regular"), _obj6);
// ../internal/src/components/egds-text/egds-stylized-text.tsx
var fragment12 = gql17(_templateObject16());
var EGDSStylizedText = function(param) {
    var className = param.className, inline = param.inline, size = param.size, align = param.align, data = param.data;
    var decorative = data.decorative, stylizedSize = data.stylizedSize, text = data.text, theme = data.theme, weight = data.weight;
    var sizeProps = size !== null && size !== void 0 ? size : stylizedSize ? textSizeMapper[stylizedSize] : void 0;
    var themeProps = theme ? textThemeMapper[theme] : void 0;
    var weightProps = weight ? textWeightMapper[weight] : void 0;
    var RenderText = function(param) {
        var defaultSize = param.size;
        return /* @__PURE__ */ React18.createElement(UitkText4, {
            className: className,
            inline: inline,
            size: sizeProps !== null && sizeProps !== void 0 ? sizeProps : defaultSize,
            theme: themeProps,
            weight: weightProps,
            align: align
        }, text);
    };
    switch(decorative){
        case "LINE_THROUGH" /* LINE_THROUGH */ :
            return /* @__PURE__ */ React18.createElement("s", null, /* @__PURE__ */ React18.createElement(RenderText, null));
        case "SUPERSCRIPT" /* SUPERSCRIPT */ :
            return /* @__PURE__ */ React18.createElement("sup", null, /* @__PURE__ */ React18.createElement(RenderText, {
                size: 100
            }));
        default:
            return /* @__PURE__ */ React18.createElement(RenderText, null);
    }
};
EGDSStylizedText.fragment = fragment12;
EGDSStylizedText.displayName = "EGDSStylizedText";
// ../internal/src/components/egds-text/egds-spannable-text/egds-spannable-text-content.tsx
var fragment13 = gql18(_templateObject17(), EGDSStylizedText.fragment, EGDSPlainText.fragment, EGDSGraphicText.fragment, EGDSIconText.fragment, EGDSStandardLink.fragment, EGDSHeading.fragment);
var EGDSSpannableTextContent = function(param) {
    var className = param.className, size = param.size, headingSize = param.headingSize, headingTag = param.headingTag, align = param.align, data = param.data, iconSpacing5 = param.iconSpacing;
    switch(data.__typename){
        case "EGDSHeading":
            return /* @__PURE__ */ React19.createElement(EGDSHeading, {
                className: className,
                data: data,
                size: headingSize,
                tag: headingTag
            });
        case "EGDSStylizedText":
            return /* @__PURE__ */ React19.createElement(EGDSStylizedText, {
                className: className,
                data: data,
                size: size,
                inline: true
            });
        case "EGDSPlainText":
            return /* @__PURE__ */ React19.createElement(EGDSPlainText, {
                className: className,
                data: data,
                size: size,
                align: align,
                inline: true
            });
        case "EGDSGraphicText":
            return /* @__PURE__ */ React19.createElement(EGDSGraphicText, {
                className: className,
                data: data,
                size: size,
                inline: true
            });
        case "EGDSIconText":
            return /* @__PURE__ */ React19.createElement(EGDSIconText, {
                className: className,
                data: data,
                size: size,
                iconSpacing: iconSpacing5,
                inline: true
            });
        case "EGDSStandardLink":
            return /* @__PURE__ */ React19.createElement(EGDSStandardLink, {
                className: className,
                data: data,
                inline: true
            });
        default:
            return /* @__PURE__ */ React19.createElement(React19.Fragment, null);
    }
};
EGDSSpannableTextContent.fragment = fragment13;
EGDSSpannableTextContent.displayName = "EGDSSpannableTextContent";
// ../internal/src/components/egds-text/egds-spannable-text/egds-spannable-text.tsx
var fragment14 = gql19(_templateObject18(), EGDSSpannableTextContent.fragment);
var EGDSSpannableText = function(props) {
    var _data_inlineContent, _data_inlineContent1;
    var align = props.align, headingSize = props.headingSize, headingTag = props.headingTag, data = props.data, styleProps = _object_without_properties(props, [
        "align",
        "headingSize",
        "headingTag",
        "data"
    ]);
    if (data.contents.length === 0 && !((_data_inlineContent = data.inlineContent) === null || _data_inlineContent === void 0 ? void 0 : _data_inlineContent.length)) {
        return /* @__PURE__ */ React20.createElement(UitkText5, _object_spread_props(_object_spread({}, styleProps), {
            inline: true,
            align: align
        }), data.text);
    }
    if ((_data_inlineContent1 = data.inlineContent) === null || _data_inlineContent1 === void 0 ? void 0 : _data_inlineContent1.length) {
        return /* @__PURE__ */ React20.createElement(React20.Fragment, null, data.inlineContent.map(function(item, index) {
            return /* @__PURE__ */ React20.createElement(React20.Fragment, {
                key: "spannable-item-".concat(index)
            }, /* @__PURE__ */ React20.createElement(EGDSSpannableTextContent, _object_spread({
                align: align,
                data: item,
                headingSize: headingSize,
                headingTag: headingTag
            }, styleProps)), " ");
        }));
    }
    return /* @__PURE__ */ React20.createElement(React20.Fragment, null, data.contents.map(function(item, index) {
        return /* @__PURE__ */ React20.createElement(React20.Fragment, {
            key: "spannable-item-".concat(index)
        }, /* @__PURE__ */ React20.createElement(EGDSSpannableTextContent, _object_spread_props(_object_spread({
            data: item
        }, styleProps), {
            headingSize: headingSize
        })), " ");
    }));
};
EGDSSpannableText.fragment = fragment14;
EGDSSpannableText.displayName = "EGDSSpannableText";
// ../internal/src/components/egds-text/egds-text.tsx
var fragment15 = gql20(_templateObject19(), EGDSHeading.fragment, EGDSPlainText.fragment, EGDSStylizedText.fragment, EGDSIconText.fragment, EGDSParagraph.fragment, EGDSStandardLink.fragment, EGDSInlineLink.fragment, EGDSGraphicText.fragment, EGDSSpannableText.fragment, EGDSTextStandardListItem.fragment);
var EGDSText = function(param) {
    var className = param.className, inline = param.inline, headingSize = param.headingSize, headingTag = param.headingTag, textSize = param.textSize, align = param.align, overflow = param.overflow, data = param.data, dataStid = param.dataStid, shouldWrapGraphicTextInFlex = param.shouldWrapGraphicTextInFlex;
    switch(data.__typename){
        case "EGDSHeading":
            return /* @__PURE__ */ React21.createElement(EGDSHeading, {
                className: className,
                size: headingSize,
                data: data,
                align: align,
                tag: headingTag
            });
        case "EGDSPlainText":
            return /* @__PURE__ */ React21.createElement(EGDSPlainText, {
                dataStid: dataStid,
                overflow: overflow,
                className: className,
                size: textSize,
                data: data,
                inline: inline,
                align: align
            });
        case "EGDSStylizedText":
            return /* @__PURE__ */ React21.createElement(EGDSStylizedText, {
                className: className,
                size: textSize,
                data: data,
                inline: inline,
                align: align
            });
        case "EGDSIconText":
            return /* @__PURE__ */ React21.createElement(EGDSIconText, {
                className: className,
                size: textSize,
                data: data,
                align: align
            });
        case "EGDSParagraph":
            return /* @__PURE__ */ React21.createElement(EGDSParagraph, {
                className: className,
                data: data
            });
        case "EGDSStandardLink":
            return /* @__PURE__ */ React21.createElement(EGDSStandardLink, {
                className: className,
                data: data,
                inline: inline
            });
        case "EGDSInlineLink":
            return /* @__PURE__ */ React21.createElement(EGDSInlineLink, {
                className: className,
                data: data
            });
        case "EGDSSpannableText":
            return /* @__PURE__ */ React21.createElement(EGDSSpannableText, {
                className: className,
                size: textSize,
                headingSize: headingSize,
                data: data,
                align: align
            });
        case "EGDSGraphicText":
            return /* @__PURE__ */ React21.createElement(EGDSGraphicText, {
                className: className,
                data: data,
                inline: inline,
                shouldWrapInFlex: shouldWrapGraphicTextInFlex
            });
        case "EGDSTextStandardListItem":
            return /* @__PURE__ */ React21.createElement(EGDSTextStandardListItem, {
                data: data
            });
        default:
            return null;
    }
};
EGDSText.fragment = fragment15;
EGDSText.displayName = "EGDSText";
// ../internal/src/components/egds-list/flights-text-container-list-item.tsx
var fragment16 = gql21(_templateObject20(), EGDSText.fragment);
var FlightsTextContainerListItem = function(param) {
    var className = param.className, textSize = param.textSize, data = param.data, inline = param.inline;
    return /* @__PURE__ */ React22.createElement(UitkListItem4, null, /* @__PURE__ */ React22.createElement(EGDSText, {
        className: className,
        textSize: textSize,
        data: data.content,
        inline: inline
    }));
};
FlightsTextContainerListItem.fragment = fragment16;
FlightsTextContainerListItem.displayName = "FlightsTextContainerListItem";
// ../internal/src/components/egds-list/egds-text-list-item.tsx
var fragment17 = gql22(_templateObject21(), EGDSTextStandardListItem.fragment, EGDSTextIconListItem.fragment, FlightsTextContainerListItem.fragment);
var EGDSTextListItem = function(param) {
    var data = param.data, textSize = param.textSize, inline = param.inline;
    switch(data.__typename){
        case "EGDSTextStandardListItem":
            return /* @__PURE__ */ React23.createElement(EGDSTextStandardListItem, {
                data: data
            });
        case "EGDSTextIconListItem":
            return /* @__PURE__ */ React23.createElement(EGDSTextIconListItem, {
                data: data
            });
        case "FlightsTextContainerListItem":
            return /* @__PURE__ */ React23.createElement(FlightsTextContainerListItem, {
                data: data,
                textSize: textSize,
                inline: inline
            });
        default:
            return null;
    }
};
EGDSTextListItem.fragment = fragment17;
EGDSTextListItem.displayName = "EGDSTextListItem";
// ../internal/src/components/egds-bulleted-list/egds-bulleted-list.tsx
var fragment18 = gql23(_templateObject22(), EGDSTextListItem.fragment);
var EGDSBulletedList = function(param) {
    var data = param.data;
    if (data.listItems.length === 0) {
        return null;
    }
    return /* @__PURE__ */ React24.createElement(UitkList3, null, data.listItems.map(function(item, key) {
        return /* @__PURE__ */ React24.createElement(EGDSTextListItem, {
            data: item,
            key: key
        });
    }));
};
EGDSBulletedList.displayName = "EGDSBulletedList";
EGDSBulletedList.fragment = fragment18;
// ../internal/src/components/egds-list/egds-unordered-list.tsx
import React25 from "react";
import { gql as gql24 } from "@apollo/client";
import { UitkList as UitkList4 } from "uitk-react-list";
var _obj7;
// ../internal/src/components/egds-list/__private/text-list-size.ts
var textListSizeMapper = (_obj7 = {}, _define_property(_obj7, "LIST_1" /* LIST_1 */ , 1), _define_property(_obj7, "LIST_2" /* LIST_2 */ , 2), _define_property(_obj7, "LIST_3" /* LIST_3 */ , 3), _obj7);
// ../internal/src/components/egds-list/egds-unordered-list.tsx
var fragment19 = gql24(_templateObject23(), EGDSTextListItem.fragment);
var EGDSUnorderedList = function(param) {
    var className = param.className, bullet = param.bullet, orientation = param.orientation, data = param.data, textSize = param.textSize, inline = param.inline;
    var listItems = data.listItems, textListSize = data.textListSize;
    if (!listItems.length) {
        return null;
    }
    var sizeProps = textListSize ? textListSizeMapper[textListSize] : void 0;
    return /* @__PURE__ */ React25.createElement(UitkList4, {
        spacing: false,
        className: className,
        bullet: bullet,
        size: sizeProps,
        type: "unordered",
        orientation: orientation
    }, listItems.map(function(item, index) {
        return /* @__PURE__ */ React25.createElement(EGDSTextListItem, {
            key: index,
            data: item,
            textSize: textSize,
            inline: inline
        });
    }));
};
EGDSUnorderedList.fragment = fragment19;
EGDSUnorderedList.displayName = "EGDSUnorderedList";
// ../internal/src/components/flights-action-button/flights-action-button.tsx
import React27 from "react";
import { gql as gql28 } from "@apollo/client";
import { useClickstreamAnalytics } from "@shared-ui/clickstream-analytics-context";
import { UitkPrimaryButton, UitkSecondaryButton, UitkTertiaryButton } from "uitk-react-button";
import { Level, liveAnnounce } from "uitk-react-utils";
// ../internal/src/components/client-side-analytics/client-side-analytics.ts
import { gql as gql25 } from "@apollo/client";
import { ITrackType } from "@shared-ui/clickstream-analytics-context";
var clientSideAnalyticsFragment = gql25(_templateObject24());
var trackAnalyticsList = function(clickstreamAnalytics, analyticsList) {
    var track = clickstreamAnalytics.track;
    analyticsList.forEach(function(analytic) {
        var _analytic_uisPrimeMessages, _analytic, _uisPrimeMessages;
        var uisPrimeMessages = (_analytic = analytic) === null || _analytic === void 0 ? void 0 : (_analytic_uisPrimeMessages = _analytic.uisPrimeMessages) === null || _analytic_uisPrimeMessages === void 0 ? void 0 : _analytic_uisPrimeMessages.map(function(value) {
            return {
                schemaName: value.schemaName,
                messageContent: JSON.parse(value.messageContent)
            };
        });
        var referrerId = analytic.referrerId, linkName = analytic.linkName;
        var referrerMessageContent = {
            schemaName: "referrer",
            messageContent: {
                referrerId: referrerId,
                linkName: linkName,
                eventType: "click"
            }
        };
        var messages = [
            referrerMessageContent
        ];
        if ((_uisPrimeMessages = uisPrimeMessages) === null || _uisPrimeMessages === void 0 ? void 0 : _uisPrimeMessages.length) {
            var uisPrimeMsg = uisPrimeMessages[0];
            messages.push(uisPrimeMsg);
        }
        track(ITrackType.EVENT, {
            data: messages
        });
    });
};
var trackDisplayAnalyticsList = function(clickstreamAnalytics, analyticsList) {
    var track = clickstreamAnalytics.track;
    analyticsList.forEach(function(analytic) {
        var _analytic_uisPrimeMessages, _analytic, _uisPrimeMessages;
        var uisPrimeMessages = (_analytic = analytic) === null || _analytic === void 0 ? void 0 : (_analytic_uisPrimeMessages = _analytic.uisPrimeMessages) === null || _analytic_uisPrimeMessages === void 0 ? void 0 : _analytic_uisPrimeMessages.map(function(value) {
            return {
                messageContent: JSON.parse(value.messageContent),
                schemaName: value.schemaName
            };
        });
        var referrerId = analytic.referrerId, linkName = analytic.linkName;
        var referrerMessageContent = {
            schemaName: "referrer",
            messageContent: {
                referrerId: referrerId,
                linkName: linkName,
                eventType: "impression"
            }
        };
        var messages = [
            referrerMessageContent
        ];
        if ((_uisPrimeMessages = uisPrimeMessages) === null || _uisPrimeMessages === void 0 ? void 0 : _uisPrimeMessages.length) {
            var uisPrimeMsg = uisPrimeMessages[0];
            messages.push(uisPrimeMsg);
        }
        track(ITrackType.EVENT, {
            data: messages
        });
    });
};
// ../internal/src/components/client-side-analytics/client-side-impression-event-analytics.tsx
import React26 from "react";
import { gql as gql26 } from "@apollo/client";
import { IntersectionTracker } from "@shared-ui/clickstream-analytics-context";
var fragment20 = gql26(_templateObject25());
var ClientSideImpressionEventAnalytics = function(param) {
    var content = param.content, data = param.data;
    var _data_uisPrimeMessages;
    var uisPrimeMessages = (_data_uisPrimeMessages = data.uisPrimeMessages) === null || _data_uisPrimeMessages === void 0 ? void 0 : _data_uisPrimeMessages.map(function(value) {
        return {
            schemaName: value.schemaName,
            messageContent: JSON.parse(value.messageContent)
        };
    });
    if (data.linkName) {
        return /* @__PURE__ */ React26.createElement(IntersectionTracker, {
            referrerId: data.referrerId,
            linkName: data.linkName,
            additionalUisPrimeMicroMessages: uisPrimeMessages
        }, /* @__PURE__ */ React26.createElement("div", {
            "data-test-id": "impression-event-intersection-tracker"
        }, content));
    }
    return /* @__PURE__ */ React26.createElement(React26.Fragment, null, content);
};
ClientSideImpressionEventAnalytics.displayName = "ClientSideImpressionEventAnalytics";
ClientSideImpressionEventAnalytics.fragment = fragment20;
// ../internal/src/components/common/client-action.ts
import { gql as gql27 } from "@apollo/client";
var clientActionFragment = gql27(_templateObject26(), clientSideAnalyticsFragment);
// ../internal/src/components/flights-action-button/flights-action-button.tsx
var fragment21 = gql28(_templateObject27(), clientSideAnalyticsFragment, Icon.fragment, clientActionFragment);
var FlightsActionButton = function(param) {
    var ButtonWrapper = param.ButtonWrapper, callback = param.callback, dataStid = param.dataStid, dataTestId = param.dataTestId, data = param.data, disabled = param.disabled, isFullWidth = param.isFullWidth, size = param.size, className = param.className, domRef = param.domRef;
    var Button = UitkPrimaryButton;
    if (data.buttonStyle === "SECONDARY" /* SECONDARY */ ) {
        Button = UitkSecondaryButton;
    } else if (data.buttonStyle === "TERTIARY" /* TERTIARY */ ) {
        Button = UitkTertiaryButton;
    }
    var clickstreamAnalytics = useClickstreamAnalytics();
    var handleClick = React27.useCallback(function() {
        var _callback;
        if (data.clientAction.analyticsList.length > 0) {
            trackAnalyticsList(clickstreamAnalytics, data.clientAction.analyticsList);
        }
        setTimeout(function() {
            if (data.clientAction.accessibility) {
                liveAnnounce(data.clientAction.accessibility, Level.POLITE);
            }
        }, 100);
        (_callback = callback) === null || _callback === void 0 ? void 0 : _callback(data.clientAction);
    }, [
        data.clientAction,
        callback,
        clickstreamAnalytics
    ]);
    var isDisabled = disabled !== void 0 ? disabled : data.disabled;
    var primary = data.primary, icon = data.icon;
    React27.useEffect(function() {
        if (data.analytics) {
            trackDisplayAnalyticsList(clickstreamAnalytics, [
                data.analytics
            ]);
        }
    }, [
        clickstreamAnalytics,
        data.analytics
    ]);
    var buttonProps = {
        disabled: isDisabled,
        onClick: handleClick,
        stid: dataStid,
        "data-test-id": dataTestId,
        // TODO: CLean up once CP is updated
        "data-stid": dataStid,
        isFullWidth: isFullWidth,
        size: size,
        className: className,
        domRef: domRef
    };
    if (ButtonWrapper) {
        return /* @__PURE__ */ React27.createElement(ButtonWrapper, null, /* @__PURE__ */ React27.createElement("button", _object_spread_props(_object_spread({}, buttonProps), {
            type: "button"
        }), data.primary));
    }
    return /* @__PURE__ */ React27.createElement(Button, _object_spread({}, buttonProps), icon && /* @__PURE__ */ React27.createElement(Icon, {
        data: icon
    }), primary);
};
FlightsActionButton.displayName = "FlightsActionButton";
FlightsActionButton.fragment = fragment21;
// ../internal/src/components/flights-action-link/flights-action-link.tsx
import React28 from "react";
import { gql as gql29 } from "@apollo/client";
import { useClickstreamAnalytics as useClickstreamAnalytics2 } from "@shared-ui/clickstream-analytics-context";
import { UitkLink as UitkLink3 } from "uitk-react-link";
var fragment22 = gql29(_templateObject28(), clientSideAnalyticsFragment, clientActionFragment, Icon.fragment);
var FlightsActionLink = function(param) {
    var callback = param.callback, size = param.size, data = param.data, className = param.className, dataStid = param.dataStid, dataTestId = param.dataTestId;
    var clickstreamAnalytics = useClickstreamAnalytics2();
    React28.useEffect(function() {
        if (data.analytics) {
            trackDisplayAnalyticsList(clickstreamAnalytics, [
                data.analytics
            ]);
        }
    }, [
        clickstreamAnalytics,
        data.analytics
    ]);
    var handleClick = React28.useCallback(function() {
        var _callback;
        if (data.clientAction.analyticsList.length > 0) {
            trackAnalyticsList(clickstreamAnalytics, data.clientAction.analyticsList);
        }
        (_callback = callback) === null || _callback === void 0 ? void 0 : _callback(data.clientAction);
    }, [
        data.clientAction,
        callback,
        clickstreamAnalytics
    ]);
    var _data_accessibility;
    return /* @__PURE__ */ React28.createElement(UitkLink3, {
        "data-stid": dataStid,
        disabled: data.disabled,
        size: size,
        className: className,
        "data-test-id": dataTestId
    }, /* @__PURE__ */ React28.createElement("button", {
        type: "button",
        onClick: handleClick,
        "aria-label": (_data_accessibility = data.accessibility) !== null && _data_accessibility !== void 0 ? _data_accessibility : void 0
    }, data.icon && /* @__PURE__ */ React28.createElement(Icon, {
        data: data.icon
    }), data.primary));
};
FlightsActionLink.displayName = "FlightsActionLink";
FlightsActionLink.fragment = fragment22;
// ../internal/src/components/flights-dialog-trigger/flights-dialog-trigger.tsx
import React29 from "react";
import { gql as gql30 } from "@apollo/client";
import { useDialog } from "@shared-ui/dialog-context";
var fragment23 = gql30(_templateObject29(), FlightsActionButton.fragment, FlightsActionLink.fragment);
var FlightsDialogTrigger = function(param) {
    var className = param.className, data = param.data, isNested = param.isNested, onClick = param.onClick, Wrapper = param.Wrapper, dataTestId = param.dataTestId, isFullWidth = param.isFullWidth, linkSize = param.linkSize;
    var nestedDialogKey = isNested ? "pwaDialogNested" : void 0;
    var _data_dynamicDialogId;
    var dialogId = (_data_dynamicDialogId = data.dynamicDialogId) !== null && _data_dynamicDialogId !== void 0 ? _data_dynamicDialogId : data.dialogId;
    var _useDialog = _sliced_to_array(useDialog(dialogId, nestedDialogKey), 2), dialogActions = _useDialog[1];
    var onTriggerClicked = React29.useCallback(function() {
        var _onClick;
        (_onClick = onClick) === null || _onClick === void 0 ? void 0 : _onClick();
        return data.dialogAction === "OPEN" /* OPEN */  ? dialogActions.openDialog() : dialogActions.closeDialog();
    }, [
        dialogActions,
        data.dialogAction,
        onClick
    ]);
    var dataStid = "".concat(dialogId, "-").concat(data.trigger.__typename);
    var _ref, _ref1;
    return /* @__PURE__ */ React29.createElement(React29.Fragment, null, data.trigger.__typename === "FlightsActionButton" && /* @__PURE__ */ React29.createElement(FlightsActionButton, {
        data: data.trigger,
        callback: onTriggerClicked,
        className: className,
        ButtonWrapper: Wrapper,
        isFullWidth: isFullWidth,
        dataStid: dataStid,
        dataTestId: (_ref = dataTestId !== null && dataTestId !== void 0 ? dataTestId : dataStid) !== null && _ref !== void 0 ? _ref : null
    }), data.trigger.__typename === "FlightsActionLink" && /* @__PURE__ */ React29.createElement(FlightsActionLink, {
        data: data.trigger,
        callback: onTriggerClicked,
        className: className,
        dataStid: dataStid,
        dataTestId: (_ref1 = dataTestId !== null && dataTestId !== void 0 ? dataTestId : dataStid) !== null && _ref1 !== void 0 ? _ref1 : null,
        size: linkSize
    }));
};
FlightsDialogTrigger.displayName = "FlightsDialogTrigger";
FlightsDialogTrigger.fragment = fragment23;
// ../internal/src/components/ui-messaging-card/ui-messaging-card.tsx
import React30 from "react";
import { gql as gql31 } from "@apollo/client";
import { UitkCard as UitkCard3 } from "uitk-react-cards";
import { UitkLayoutFlex as UitkLayoutFlex3, UitkLayoutFlexItem as UitkLayoutFlexItem2 } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing4 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading2, UitkText as UitkText6 } from "uitk-react-text";
var fragment24 = gql31(_templateObject30(), UiGraphic.fragment);
var paddingUIMessagingContent = {
    blockstart: "six",
    blockend: "three"
};
var spacingHeadingContent = {
    margin: "unset"
};
var spacingTextContent = {
    margin: "unset"
};
var UIMessagingCard = function(param) {
    var className = param.className, headingSize = param.headingSize, headingTag = param.headingTag, textSize = param.textSize, headingSpacing = param.headingSpacing, textSpacing2 = param.textSpacing, data = param.data;
    var _data_secondaries, _data_secondaries1, _data_secondaries2;
    return /* @__PURE__ */ React30.createElement(React30.Fragment, null, (data.graphic || data.primary || ((_data_secondaries = data.secondaries) === null || _data_secondaries === void 0 ? void 0 : _data_secondaries.length)) && /* @__PURE__ */ React30.createElement(UitkSpacing4, {
        margin: paddingUIMessagingContent
    }, /* @__PURE__ */ React30.createElement(UitkCard3, null, /* @__PURE__ */ React30.createElement(UitkLayoutFlex3, {
        alignItems: "center",
        space: "two"
    }, data.graphic && /* @__PURE__ */ React30.createElement(UitkLayoutFlexItem2, null, /* @__PURE__ */ React30.createElement(UiGraphic, {
        data: data.graphic,
        className: className
    })), (data.primary || ((_data_secondaries1 = data.secondaries) === null || _data_secondaries1 === void 0 ? void 0 : _data_secondaries1.length)) && /* @__PURE__ */ React30.createElement(UitkLayoutFlexItem2, null, /* @__PURE__ */ React30.createElement("div", null, data.primary && /* @__PURE__ */ React30.createElement(UitkSpacing4, {
        margin: headingSpacing || spacingHeadingContent.margin
    }, /* @__PURE__ */ React30.createElement(UitkHeading2, {
        tag: headingTag,
        size: headingSize
    }, data.primary)), (_data_secondaries2 = data.secondaries) === null || _data_secondaries2 === void 0 ? void 0 : _data_secondaries2.map(function(content, index) {
        return /* @__PURE__ */ React30.createElement(UitkSpacing4, {
            key: "secondaries-".concat(index),
            margin: textSpacing2 || spacingTextContent.margin
        }, /* @__PURE__ */ React30.createElement(UitkText6, {
            size: textSize
        }, content));
    })))))));
};
UIMessagingCard.fragment = fragment24;
UIMessagingCard.displayName = "UIMessagingCard";
// ../internal/src/components/egds-element/egds-element.tsx
var fragment25 = gql32(_templateObject31(), EGDSHeading.fragment, EGDSParagraph.fragment, EGDSStandardLink.fragment, FlightsActionButton.fragment, FlightsActionLink.fragment, FlightsDialogTrigger.fragment, EGDSBulletedList.fragment, EGDSSpannableText.fragment, EGDSUnorderedList.fragment, UIMessagingCard.fragment, Illustration.fragment);
var EGDSElement = function(param) {
    var callback = param.callback, className = param.className, headingSize = param.headingSize, data = param.data, inline = param.inline, bullet = param.bullet, isNested = param.isNested, headingTag = param.headingTag, textSize = param.textSize, textAlign = param.textAlign, dataStid = param.dataStid;
    switch(data.__typename){
        case "EGDSHeading":
            return /* @__PURE__ */ React31.createElement(EGDSHeading, {
                className: className,
                size: headingSize,
                align: textAlign,
                data: data
            });
        case "EGDSParagraph":
            return /* @__PURE__ */ React31.createElement(EGDSParagraph, {
                className: className,
                data: data
            });
        case "EGDSStandardLink":
            return /* @__PURE__ */ React31.createElement(EGDSStandardLink, {
                className: className,
                data: data,
                align: textAlign
            });
        case "FlightsActionButton":
            return /* @__PURE__ */ React31.createElement(FlightsActionButton, {
                data: data,
                callback: callback
            });
        case "FlightsActionLink":
            return /* @__PURE__ */ React31.createElement(FlightsActionLink, {
                className: className,
                data: data,
                callback: callback,
                dataStid: dataStid
            });
        case "FlightsDialogTrigger":
            return /* @__PURE__ */ React31.createElement(FlightsDialogTrigger, {
                className: className,
                data: data,
                isNested: isNested
            });
        case "EGDSBulletedList":
            return /* @__PURE__ */ React31.createElement(EGDSBulletedList, {
                data: data
            });
        case "EGDSSpannableText":
            return /* @__PURE__ */ React31.createElement(EGDSSpannableText, {
                data: data
            });
        case "EGDSUnorderedList":
            return /* @__PURE__ */ React31.createElement(EGDSUnorderedList, {
                className: className,
                bullet: bullet,
                data: data,
                inline: inline
            });
        case "UIMessagingCard":
            return /* @__PURE__ */ React31.createElement(UIMessagingCard, {
                data: data,
                className: className,
                textSize: textSize,
                headingSize: headingSize,
                headingTag: headingTag
            });
        case "Illustration":
            return /* @__PURE__ */ React31.createElement(Illustration, {
                data: data
            });
        default:
            return null;
    }
};
EGDSElement.fragment = fragment25;
EGDSElement.displayName = "EGDSElement";
// ../internal/src/components/egds-list/egds-text-list.tsx
import React32 from "react";
import { gql as gql33 } from "@apollo/client";
var fragment26 = gql33(_templateObject32(), EGDSUnorderedList.fragment);
var EGDSTextList = function(param) {
    var className = param.className, bullet = param.bullet, orientation = param.orientation, data = param.data, textSize = param.textSize, inline = param.inline;
    switch(data.__typename){
        case "EGDSUnorderedList":
            return /* @__PURE__ */ React32.createElement(EGDSUnorderedList, {
                className: className,
                bullet: bullet,
                orientation: orientation,
                data: data,
                textSize: textSize,
                inline: inline
            });
        default:
            return null;
    }
};
EGDSTextList.fragment = fragment26;
EGDSTextList.displayName = "EGDSTextList";
// ../internal/src/components/egds-list/egds-link-list.tsx
import React33 from "react";
import { gql as gql34 } from "@apollo/client";
import { UitkList as UitkList5, UitkListItem as UitkListItem5 } from "uitk-react-list";
var fragment27 = gql34(_templateObject33(), EGDSStandardLink.fragment);
var EGDSLinkList = function(param) {
    var className = param.className, orientation = param.orientation, data = param.data, bullet = param.bullet;
    var listItems = data.listItems;
    return /* @__PURE__ */ React33.createElement(UitkList5, {
        spacing: false,
        className: className,
        bullet: bullet,
        orientation: orientation
    }, listItems.map(function(item, index) {
        return /* @__PURE__ */ React33.createElement(UitkListItem5, {
            key: "egds-link-list-".concat(index)
        }, /* @__PURE__ */ React33.createElement(EGDSStandardLink, {
            key: index,
            data: item
        }));
    }));
};
EGDSLinkList.fragment = fragment27;
EGDSLinkList.displayName = "EGDSLinkList";
// ../internal/src/components/egds-price-lockup/egds-price-lockup.tsx
import React34 from "react";
import { gql as gql35 } from "@apollo/client";
import { UitkPriceLockup } from "uitk-react-price-lockup";
var fragment28 = gql35(_templateObject34());
var _data_lockupPrice, _data_lockupFormattedPoints, _data_isPointsFirst, _data_leadingCaption, _data_priceSubtextBold, _data_priceSubtextFirst, _data_priceSubtextStandard, _data_strikeThroughPrice;
var EGDSPriceLockup = function(param) {
    var align = param.align, data = param.data;
    return /* @__PURE__ */ React34.createElement(UitkPriceLockup, {
        align: align,
        a11yPrice: data.accessibilityPrice,
        lockupPrice: (_data_lockupPrice = data.lockupPrice) !== null && _data_lockupPrice !== void 0 ? _data_lockupPrice : void 0,
        lockupFormattedPoints: (_data_lockupFormattedPoints = data.lockupFormattedPoints) !== null && _data_lockupFormattedPoints !== void 0 ? _data_lockupFormattedPoints : void 0,
        isPointsFirst: (_data_isPointsFirst = data.isPointsFirst) !== null && _data_isPointsFirst !== void 0 ? _data_isPointsFirst : false,
        leadingCaption: (_data_leadingCaption = data.leadingCaption) !== null && _data_leadingCaption !== void 0 ? _data_leadingCaption : void 0,
        priceSubtextBold: (_data_priceSubtextBold = data.priceSubtextBold) !== null && _data_priceSubtextBold !== void 0 ? _data_priceSubtextBold : void 0,
        priceSubtextFirst: (_data_priceSubtextFirst = data.priceSubtextFirst) !== null && _data_priceSubtextFirst !== void 0 ? _data_priceSubtextFirst : void 0,
        priceSubtextStandard: (_data_priceSubtextStandard = data.priceSubtextStandard) !== null && _data_priceSubtextStandard !== void 0 ? _data_priceSubtextStandard : void 0,
        strikeThroughPrice: (_data_strikeThroughPrice = data.strikeThroughPrice) !== null && _data_strikeThroughPrice !== void 0 ? _data_strikeThroughPrice : void 0
    });
};
EGDSPriceLockup.fragment = fragment28;
EGDSPriceLockup.displayName = "EGDSPriceLockup";
// ../internal/src/components/egds-section-heading/egds-section-heading.tsx
import React36 from "react";
import { gql as gql37 } from "@apollo/client";
import { UitkLayoutFlex as UitkLayoutFlex5, UitkLayoutFlexItem as UitkLayoutFlexItem4 } from "uitk-react-layout-flex";
import { UitkText as UitkText7 } from "uitk-react-text";
// ../internal/src/components/egds-section-heading/egds-basic-section-heading.tsx
import React35 from "react";
import { gql as gql36 } from "@apollo/client";
import { UitkLayoutFlex as UitkLayoutFlex4, UitkLayoutFlexItem as UitkLayoutFlexItem3 } from "uitk-react-layout-flex";
var fragment29 = gql36(_templateObject35(), EGDSHeading.fragment, UiGraphic.fragment);
var EGDSBasicSectionHeading = function(param) {
    var data = param.data, headingSize = param.headingSize;
    return /* @__PURE__ */ React35.createElement(UitkLayoutFlex4, {
        alignContent: "center",
        alignItems: "center",
        space: "one"
    }, data.graphic && /* @__PURE__ */ React35.createElement(UitkLayoutFlexItem3, null, /* @__PURE__ */ React35.createElement(UiGraphic, {
        data: data.graphic
    })), /* @__PURE__ */ React35.createElement(UitkLayoutFlexItem3, null, /* @__PURE__ */ React35.createElement(EGDSHeading, {
        data: data.heading,
        size: headingSize
    }), ";"));
};
EGDSBasicSectionHeading.fragment = fragment29;
EGDSBasicSectionHeading.displayName = "EGDSSectionHeading";
// ../internal/src/components/egds-section-heading/egds-section-heading.tsx
var fragment30 = gql37(_templateObject36(), EGDSHeading.fragment, Mark.fragment, UiGraphic.fragment);
var EGDSSectionHeading = function(param) {
    var data = param.data, headingSize = param.headingSize;
    var HeadingMemo = React36.useMemo(function() {
        if (data.__typename === "FlightsOfferSectionHeading" && data.mark) {
            return /* @__PURE__ */ React36.createElement(UitkLayoutFlex5, {
                alignContent: "center",
                alignItems: "center",
                space: "one"
            }, /* @__PURE__ */ React36.createElement(UitkLayoutFlexItem4, null, /* @__PURE__ */ React36.createElement(Mark, {
                data: data.mark
            })), /* @__PURE__ */ React36.createElement(UitkLayoutFlexItem4, null, /* @__PURE__ */ React36.createElement(EGDSHeading, {
                data: data.heading,
                size: headingSize
            }), ";"));
        }
        if (data.__typename === "EGDSBasicSectionHeading") {
            return /* @__PURE__ */ React36.createElement(EGDSBasicSectionHeading, {
                data: data,
                headingSize: headingSize
            });
        }
        return /* @__PURE__ */ React36.createElement(EGDSHeading, {
            data: data.heading,
            size: headingSize
        });
    }, [
        data,
        headingSize
    ]);
    return /* @__PURE__ */ React36.createElement(React36.Fragment, null, HeadingMemo, data.subheading && /* @__PURE__ */ React36.createElement(UitkText7, {
        size: 200
    }, data.subheading));
};
EGDSSectionHeading.fragment = fragment30;
EGDSSectionHeading.displayName = "EGDSSectionHeading";
// ../internal/src/components/egds-text-section/egds-text-section.tsx
import React37 from "react";
import { gql as gql38 } from "@apollo/client";
import { UitkSpacing as UitkSpacing5 } from "uitk-react-spacing";
var fragment31 = gql38(_templateObject37(), EGDSSectionHeading.fragment, EGDSText.fragment);
var EGDSTextSection = function(param) {
    var data = param.data, headingSize = param.headingSize, headingPadding = param.headingPadding, textSize = param.textSize, contentOverflow = param.contentOverflow, inline = param.inline, contentMargin = param.contentMargin, shouldWrapGraphicTextInFlex = param.shouldWrapGraphicTextInFlex;
    return /* @__PURE__ */ React37.createElement(React37.Fragment, null, data.heading && /* @__PURE__ */ React37.createElement(UitkSpacing5, {
        padding: headingPadding
    }, /* @__PURE__ */ React37.createElement("div", null, /* @__PURE__ */ React37.createElement(EGDSSectionHeading, {
        data: data.heading,
        headingSize: headingSize
    }))), data.contents.map(function(content, key) {
        return /* @__PURE__ */ React37.createElement(UitkSpacing5, {
            padding: contentMargin,
            key: "content-".concat(key)
        }, /* @__PURE__ */ React37.createElement("div", null, /* @__PURE__ */ React37.createElement(EGDSText, {
            overflow: contentOverflow,
            data: content,
            key: key,
            textSize: textSize,
            inline: inline,
            shouldWrapGraphicTextInFlex: shouldWrapGraphicTextInFlex
        })));
    }));
};
EGDSTextSection.fragment = fragment31;
EGDSTextSection.displayName = "EGDSTextSection";
// ../internal/src/components/phrase/flights-phrase.tsx
import React41 from "react";
import { gql as gql43 } from "@apollo/client";
import { UitkText as UitkText10 } from "uitk-react-text";
// ../internal/src/components/phrase/__private/__fragments/flights-phrase-part.tsx
import React40 from "react";
import { gql as gql42 } from "@apollo/client";
// ../internal/src/components/phrase/__private/__fragments/flights-phrase-link-node.tsx
import React38 from "react";
import { gql as gql40 } from "@apollo/client";
import { useClickTracker as useClickTracker3 } from "@shared-ui/clickstream-analytics-context";
import { UitkIcon as UitkIcon2 } from "uitk-react-icons";
import { UitkLink as UitkLink4 } from "uitk-react-link";
import { UitkSpacing as UitkSpacing6 } from "uitk-react-spacing";
import { UitkText as UitkText8 } from "uitk-react-text";
// ../internal/src/utils/text-icon-size-map.ts
import { UitkIconSize as UitkIconSize2 } from "uitk-react-icons";
var TextIconSizeMap = [
    [
        200,
        UitkIconSize2.EXTRA_SMALL
    ],
    [
        300,
        UitkIconSize2.SMALL
    ],
    [
        400,
        UitkIconSize2.MEDIUM
    ]
];
var UitkIconSizes = new Map(TextIconSizeMap);
// ../internal/src/components/phrase/__private/__fragments/flights-analytics.ts
import { gql as gql39 } from "@apollo/client";
var flightsAnalyticsFragment = gql39(_templateObject38());
// ../internal/src/components/phrase/__private/__fragments/flights-phrase-link-node.tsx
var fragment32 = gql40(_templateObject39(), flightsAnalyticsFragment);
var iconSpacing = {
    margin: {
        blockend: "one"
    }
};
var FlightsPhraseLinkNode = function(param) {
    var data = param.data, size = param.size;
    var analytics = data.analytics, accessibility = data.accessibility, icon = data.icon, link = data.link, styles = data.styles, text = data.text;
    var clickTracker = useClickTracker3();
    var textProps = {
        inline: true,
        size: size,
        weight: styles.find(function(style) {
            return style === "IMPORTANT" /* IMPORTANT */ ;
        }) ? "bold" : void 0
    };
    var onClick = React38.useCallback(function() {
        clickTracker(analytics.referrerId, analytics.linkName);
    }, [
        analytics.linkName,
        analytics.referrerId,
        clickTracker
    ]);
    return /* @__PURE__ */ React38.createElement(UitkLink4, {
        noWrap: true,
        inline: true,
        onClick: onClick
    }, /* @__PURE__ */ React38.createElement("a", {
        target: "_blank",
        rel: "noopener noreferrer",
        href: link,
        "aria-label": accessibility !== null && accessibility !== void 0 ? accessibility : void 0
    }, /* @__PURE__ */ React38.createElement(UitkText8, _object_spread({}, textProps), text, icon && /* @__PURE__ */ React38.createElement(UitkSpacing6, {
        margin: iconSpacing.margin
    }, /* @__PURE__ */ React38.createElement(UitkIcon2, {
        name: icon,
        size: UitkIconSizes.get(size)
    })))));
};
FlightsPhraseLinkNode.fragment = fragment32;
FlightsPhraseLinkNode.displayName = "FlightsPhraseLinkNode";
// ../internal/src/components/phrase/__private/__fragments/flights-phrase-text-node.tsx
import React39 from "react";
import { gql as gql41 } from "@apollo/client";
import { UitkText as UitkText9 } from "uitk-react-text";
var fragment33 = gql41(_templateObject40());
var FlightsPhraseTextNode = function(param) {
    var data = param.data, size = param.size;
    var styles = data.styles, text = data.text;
    var textProps = {
        inline: true,
        weight: styles.find(function(style) {
            return style === "IMPORTANT" /* IMPORTANT */ ;
        }) ? "bold" : void 0,
        size: size
    };
    return /* @__PURE__ */ React39.createElement(UitkText9, _object_spread({}, textProps), text);
};
FlightsPhraseTextNode.fragment = fragment33;
FlightsPhraseTextNode.displayName = "FlightsPhraseTextNode";
// ../internal/src/components/phrase/__private/__fragments/flights-phrase-part.tsx
var fragment34 = gql42(_templateObject41(), FlightsPhraseTextNode.fragment, FlightsPhraseLinkNode.fragment);
var FlightsPhrasePart = function(param) {
    var data = param.data, size = param.size;
    switch(data.__typename){
        case "FlightsPhraseTextNode":
            return /* @__PURE__ */ React40.createElement(FlightsPhraseTextNode, {
                size: size,
                data: data
            });
        case "FlightsPhraseLinkNode":
            return /* @__PURE__ */ React40.createElement(FlightsPhraseLinkNode, {
                size: size,
                data: data
            });
        default:
            return null;
    }
};
FlightsPhrasePart.fragment = fragment34;
FlightsPhrasePart.displayName = "FlightsPhrasePart";
// ../internal/src/components/phrase/flights-phrase.tsx
var fragment35 = gql43(_templateObject42(), FlightsPhrasePart.fragment);
var FlightsPhrase = function(param) {
    var data = param.data, size = param.size;
    var completeText = data.completeText, items = data.items;
    if (items.length) {
        return /* @__PURE__ */ React41.createElement("div", null, items.map(function(item, index) {
            return /* @__PURE__ */ React41.createElement(FlightsPhrasePart, {
                key: index,
                size: size,
                data: item
            });
        }));
    }
    return /* @__PURE__ */ React41.createElement(UitkText10, {
        size: size
    }, completeText);
};
FlightsPhrase.fragment = fragment35;
FlightsPhrase.displayName = "FlightsPhrase";
// ../internal/src/components/price-presentation/price-presentation.tsx
import React42 from "react";
import { PricePresentation } from "@shared-ui/pricing-price-details";
// ../internal/src/components/price-presentation/__private/__fragments/price-presentation-fragment.ts
import { gql as gql44 } from "@apollo/client";
var PricePresentationFragment = gql44(_templateObject43(), EGDSStandardLink.fragment);
// ../internal/src/components/price-presentation/price-presentation.tsx
var FlightsPricePresentation = function(param) {
    var data = param.data, isRenderedInDialog = param.isRenderedInDialog, loading = param.loading;
    return /* @__PURE__ */ React42.createElement(PricePresentation, {
        "data-stid": "price-summary",
        data: data,
        isRenderedInDialog: isRenderedInDialog,
        loading: loading
    });
};
FlightsPricePresentation.fragment = PricePresentationFragment;
FlightsPricePresentation.fragment.__typename = "PricePresentation";
FlightsPricePresentation.displayName = "FlightsPricePresentation";
// ../internal/src/components/trip-total-details/trip-total-details.tsx
import React44 from "react";
import { gql as gql46 } from "@apollo/client";
import { UitkLayoutFlex as UitkLayoutFlex6 } from "uitk-react-layout-flex";
import { UitkPriceLockup as UitkPriceLockup2, UitkPriceLockupAlign as UitkPriceLockupAlign2 } from "uitk-react-price-lockup";
import { UitkSpacing as UitkSpacing7 } from "uitk-react-spacing";
import { UitkText as UitkText11 } from "uitk-react-text";
// ../internal/src/components/egds-badge/egds-badge.tsx
import React43 from "react";
import { gql as gql45 } from "@apollo/client";
import { UitkBadgeStandard } from "uitk-react-badge";
// ../internal/src/components/egds-badge/__private/egds-standard-badge-theme.ts
var standardBadgeThemes = {
    standard: "standard",
    emphasis: "emphasis",
    info: "info",
    featured: "featured",
    brand: "brand",
    warning: "warning",
    positive: "positive"
};
// ../internal/src/components/egds-badge/egds-badge.tsx
var fragment36 = gql45(_templateObject44(), UiGraphic.fragment);
var EGDSBadge = function(props) {
    var data = props.data, size = props.size;
    if (!data.text) {
        return null;
    }
    var _data_theme;
    var selectedTheme = standardBadgeThemes[(_data_theme = data.theme) !== null && _data_theme !== void 0 ? _data_theme : "standard"];
    var _data_accessibility;
    return /* @__PURE__ */ React43.createElement(UitkBadgeStandard, {
        a11yText: (_data_accessibility = data.accessibility) !== null && _data_accessibility !== void 0 ? _data_accessibility : void 0,
        text: data.text,
        size: size,
        theme: selectedTheme
    }, data.graphic && /* @__PURE__ */ React43.createElement(UiGraphic, {
        data: data.graphic
    }));
};
EGDSBadge.fragment = fragment36;
EGDSBadge.displayName = "EGDSBadge";
// ../internal/src/components/trip-total-details/trip-total-details.tsx
var lockupTestID = {
    wrapperId: "trip-total-price"
};
var fragment37 = gql46(_templateObject45());
var TripTotalsDetail = function(param) {
    var data = param.data, label = param.label, badge = param.badge;
    var _data_tripTotal = data.tripTotal, roundedPrice = _data_tripTotal.roundedPrice, price = _data_tripTotal.price;
    return /* @__PURE__ */ React44.createElement(React44.Fragment, null, badge && /* @__PURE__ */ React44.createElement(UitkSpacing7, {
        padding: {
            blockend: "one"
        }
    }, /* @__PURE__ */ React44.createElement(UitkLayoutFlex6, {
        justifyContent: "start"
    }, /* @__PURE__ */ React44.createElement(EGDSBadge, {
        "data-stid": "urgency-badge-trigger",
        data: badge,
        size: "small"
    }))), /* @__PURE__ */ React44.createElement(UitkText11, {
        "data-stid": "trip-total-label",
        size: 100
    }, label), /* @__PURE__ */ React44.createElement(UitkPriceLockup2, {
        align: UitkPriceLockupAlign2.LEFT,
        lockupPrice: roundedPrice || price,
        a11yPrice: price,
        stids: lockupTestID
    }), data.ancillaryIncludesText && /* @__PURE__ */ React44.createElement(UitkText11, {
        "data-stid": "includes-add-ons",
        size: 200
    }, data.ancillaryIncludesText));
};
TripTotalsDetail.fragment = fragment37;
TripTotalsDetail.fragment.__typename = "FlightsPriceSummaryTripTotalItem";
TripTotalsDetail.displayName = "TripTotalsDetail";
// ../internal/src/components/flights-details-and-fares/__private/flights-details-and-fares-content.tsx
import React100 from "react";
import { gql as gql99 } from "@apollo/client";
import { useDialog as useDialog5 } from "@shared-ui/dialog-context";
// ../internal/src/components/flights-dialog/flights-dialog.tsx
import React49, { useEffect } from "react";
import { gql as gql51 } from "@apollo/client";
import { useClickstreamAnalytics as useClickstreamAnalytics4 } from "@shared-ui/clickstream-analytics-context";
import { useDialog as useDialog4 } from "@shared-ui/dialog-context";
// ../internal/src/components/egds-dialog/egds-dialog.tsx
import React48 from "react";
import { gql as gql50 } from "@apollo/client";
import { useDialog as useDialog3 } from "@shared-ui/dialog-context";
// ../internal/src/components/egds-dialog/__fragments/egds-action-dialog.tsx
import React46 from "react";
import { gql as gql48 } from "@apollo/client";
import { useClickstreamAnalytics as useClickstreamAnalytics3 } from "@shared-ui/clickstream-analytics-context";
import { useDialog as useDialog2 } from "@shared-ui/dialog-context";
import { UitkDialog, UitkDialogContent, UitkDialogFooter } from "uitk-react-dialog";
// ../internal/src/components/egds-dialog/__fragments/utils/generate-utik-buttons-prop.ts
var generateUitkButtonsProps = function(buttons, callback, closeDialog, nestedDialogActions, isNestedDialogOpen, clickstreamAnalytics, actionButtonStid) {
    var uitkButtons = [];
    var handleActionButtonClick = function(button) {
        if (button.clientAction.analyticsList.length > 0) {
            trackAnalyticsList(clickstreamAnalytics, button.clientAction.analyticsList);
        }
        if (callback) {
            callback(button.clientAction, closeDialog);
        }
    };
    var handleDialogTriggerClick = function(button) {
        if (button.trigger.clientAction.analyticsList.length > 0) {
            trackAnalyticsList(clickstreamAnalytics, button.trigger.clientAction.analyticsList);
        }
        closeDialog();
        setTimeout(function() {
            if (button.dialogAction === "OPEN" /* OPEN */ ) {
                nestedDialogActions.openDialog();
            }
            if (button.dialogAction === "CLOSE" /* CLOSE */  && isNestedDialogOpen) {
                nestedDialogActions.closeDialog();
            }
        }, 50);
    };
    buttons.map(function(button) {
        if (button.__typename === "FlightsActionButton") {
            var type = button.buttonStyle === "PRIMARY" /* PRIMARY */  ? "primary" : "tertiary";
            uitkButtons.push({
                text: button.primary || "",
                type: type,
                onClick: function() {
                    return handleActionButtonClick(button);
                },
                stid: actionButtonStid !== null && actionButtonStid !== void 0 ? actionButtonStid : "".concat(type, "-").concat(button.__typename)
            });
        }
        if (button.__typename === "FlightsDialogTrigger" && button.trigger.__typename === "FlightsActionButton") {
            var type1 = button.trigger.buttonStyle === "PRIMARY" /* PRIMARY */  ? "primary" : "tertiary";
            uitkButtons.push({
                text: button.trigger.primary || "",
                type: type1,
                onClick: function() {
                    return handleDialogTriggerClick(button);
                },
                stid: "".concat(type1, "-").concat(button.trigger.__typename)
            });
        }
        return null;
    });
    return uitkButtons;
};
// ../internal/src/components/egds-button/egds-button.tsx
import React45 from "react";
import { gql as gql47 } from "@apollo/client";
var fragment38 = gql47(_templateObject46(), FlightsActionButton.fragment, FlightsDialogTrigger.fragment);
var EGDSButton = function(param) {
    var callback = param.callback, data = param.data, disabled = param.disabled;
    return /* @__PURE__ */ React45.createElement(React45.Fragment, null, data.__typename === "FlightsActionButton" && /* @__PURE__ */ React45.createElement(FlightsActionButton, {
        data: data,
        disabled: disabled,
        callback: callback
    }), data.__typename === "FlightsDialogTrigger" && /* @__PURE__ */ React45.createElement(FlightsDialogTrigger, {
        data: data
    }));
};
EGDSButton.displayName = "UitkPrimaryButton";
EGDSButton.fragment = fragment38;
// ../internal/src/components/egds-dialog/__fragments/egds-action-dialog.tsx
var fragment39 = gql48(_templateObject47(), EGDSButton.fragment);
var EGDSActionDialog = function(param) {
    var actionsCallback = param.actionsCallback, content = param.content, closeDialog = param.closeDialog, data = param.data, actionButtonStid = param.actionButtonStid;
    var _nestedDialog;
    var clickstreamAnalytics = useClickstreamAnalytics3();
    var nestedDialog = data.footer.buttons.find(function(button) {
        return button.__typename === "FlightsDialogTrigger" && button.dialogAction === "OPEN" /* OPEN */ ;
    });
    var dialogId = (_nestedDialog = nestedDialog) === null || _nestedDialog === void 0 ? void 0 : _nestedDialog.dialogId;
    var _useDialog2 = _sliced_to_array(useDialog2(dialogId !== null && dialogId !== void 0 ? dialogId : ""), 2), isNestedDialogOpen = _useDialog2[0], nestedDialogActions = _useDialog2[1];
    var buttonsProps = React46.useMemo(function() {
        return generateUitkButtonsProps(data.footer.buttons, actionsCallback, closeDialog, nestedDialogActions, isNestedDialogOpen, clickstreamAnalytics, actionButtonStid);
    }, [
        data.footer.buttons,
        actionsCallback,
        closeDialog,
        nestedDialogActions,
        isNestedDialogOpen,
        clickstreamAnalytics,
        actionButtonStid
    ]);
    var _buttonsProps_, _buttonsProps_1, _buttonsProps_2;
    return /* @__PURE__ */ React46.createElement(UitkDialog, {
        dialogShow: true,
        returnFocusOnClose: true
    }, /* @__PURE__ */ React46.createElement(UitkDialogContent, null, content, data.footer.buttons.length > 0 && /* @__PURE__ */ React46.createElement(UitkDialogFooter, {
        stacked: data.footer.__typename === "EGDSStackedDialogFooter",
        buttonOne: (_buttonsProps_ = buttonsProps[0]) !== null && _buttonsProps_ !== void 0 ? _buttonsProps_ : void 0,
        buttonTwo: (_buttonsProps_1 = buttonsProps[1]) !== null && _buttonsProps_1 !== void 0 ? _buttonsProps_1 : void 0,
        buttonThree: (_buttonsProps_2 = buttonsProps[2]) !== null && _buttonsProps_2 !== void 0 ? _buttonsProps_2 : void 0
    })));
};
EGDSActionDialog.displayName = "EGDSActionDialog";
EGDSActionDialog.fragment = fragment39;
// ../internal/src/components/egds-dialog/__fragments/egds-fullscreen-dialog.tsx
import React47 from "react";
import { gql as gql49 } from "@apollo/client";
import { UitkDialogContent as UitkDialogContent2 } from "uitk-react-dialog";
import { UitkSheet } from "uitk-react-sheet";
import { UitkSpacing as UitkSpacing8 } from "uitk-react-spacing";
import { UitkSticky } from "uitk-react-sticky";
import { UitkToolbar } from "uitk-react-toolbar";
var fragment40 = gql49(_templateObject48());
var spacingDialogContent = {
    margin: "six"
};
var _data_toolbar_closeText;
var EGDSFullScreenDialog = function(param) {
    var closeDialog = param.closeDialog, header = param.header, content = param.content, footer = param.footer, data = param.data, spacing3 = param.spacing, overlayContent = param.overlayContent;
    return /* @__PURE__ */ React47.createElement(UitkSheet, {
        type: "full",
        isVisible: true,
        returnFocusOnClose: true,
        triggerRef: null
    }, /* @__PURE__ */ React47.createElement(UitkToolbar, {
        key: "UitkToolbar",
        navigationContent: {
            onClick: closeDialog,
            navIconLabel: (_data_toolbar_closeText = data.toolbar.closeText) !== null && _data_toolbar_closeText !== void 0 ? _data_toolbar_closeText : void 0
        },
        toolbarTitle: data.toolbar.title
    }), header && /* @__PURE__ */ React47.createElement(UitkSticky, null, header), /* @__PURE__ */ React47.createElement(UitkDialogContent2, {
        zeroPadding: true
    }, /* @__PURE__ */ React47.createElement(React47.Fragment, null, /* @__PURE__ */ React47.createElement(UitkSpacing8, {
        margin: spacing3 || spacingDialogContent.margin
    }, /* @__PURE__ */ React47.createElement("div", null, content)), footer && /* @__PURE__ */ React47.createElement(UitkSheet, {
        isVisible: true,
        triggerRef: null
    }, footer))), overlayContent);
};
EGDSFullScreenDialog.displayName = "EGDSFullScreenDialog";
EGDSFullScreenDialog.fragment = fragment40;
// ../internal/src/components/egds-dialog/egds-dialog.tsx
var fragment41 = gql50(_templateObject49(), clientSideAnalyticsFragment, EGDSFullScreenDialog.fragment, EGDSActionDialog.fragment);
var EGDSDialog = function(param) {
    var actionsCallback = param.actionsCallback, header = param.header, content = param.content, data = param.data, dialogId = param.dialogId, footer = param.footer, isNested = param.isNested, spacing3 = param.spacing, actionButtonStid = param.actionButtonStid, handleCloseCallback = param.handleCloseCallback, overlayContent = param.overlayContent;
    var nestedDialogKey = isNested ? "pwaDialogNested" : void 0;
    var _useDialog3 = _sliced_to_array(useDialog3(dialogId, nestedDialogKey), 3), dialogActions = _useDialog3[1], DialogComponent = _useDialog3[2];
    var closeDialog = React48.useCallback(function() {
        if (handleCloseCallback) {
            handleCloseCallback();
        } else {
            dialogActions.closeDialog();
        }
    }, [
        dialogActions,
        handleCloseCallback
    ]);
    return /* @__PURE__ */ React48.createElement("div", {
        "data-stid": dialogId
    }, /* @__PURE__ */ React48.createElement(DialogComponent, null, data.__typename === "EGDSFullScreenDialog" && /* @__PURE__ */ React48.createElement(EGDSFullScreenDialog, {
        data: data,
        header: header,
        footer: footer,
        closeDialog: closeDialog,
        content: content,
        spacing: spacing3,
        overlayContent: overlayContent
    }), data.__typename === "EGDSActionDialog" && /* @__PURE__ */ React48.createElement(EGDSActionDialog, {
        data: data,
        content: content,
        actionsCallback: actionsCallback,
        closeDialog: closeDialog,
        actionButtonStid: actionButtonStid
    })));
};
EGDSDialog.displayName = "EGDSDialog";
EGDSDialog.fragment = fragment41;
// ../internal/src/components/flights-dialog/flights-dialog.tsx
var fragment42 = gql51(_templateObject50(), EGDSDialog.fragment, EGDSElement.fragment, clientSideAnalyticsFragment, EGDSElement.fragment);
var FlightsDialog = function(param) {
    var actionsCallback = param.actionsCallback, header = param.header, content = param.content, data = param.data, footer = param.footer, isNested = param.isNested, headingSize = param.headingSize, headingTag = param.headingTag, textSize = param.textSize, spacing3 = param.spacing, actionButtonStid = param.actionButtonStid, handleCloseCallback = param.handleCloseCallback, overlayContent = param.overlayContent;
    var nestedDialogKey = isNested ? "pwaDialogNested" : void 0;
    var _data_dynamicDialogId;
    var dialogId = (_data_dynamicDialogId = data.dynamicDialogId) !== null && _data_dynamicDialogId !== void 0 ? _data_dynamicDialogId : data.dialogId;
    var _useDialog4 = _sliced_to_array(useDialog4(dialogId, nestedDialogKey), 2), isOpen = _useDialog4[0], dialogActions = _useDialog4[1];
    var trackAnalytics = useClickstreamAnalytics4();
    useEffect(function() {
        if (isOpen && data.displayAnalytics) {
            trackDisplayAnalyticsList(trackAnalytics, [
                data.displayAnalytics
            ]);
        }
    }, [
        isOpen,
        data.displayAnalytics,
        trackAnalytics
    ]);
    useEffect(function() {
        if (data.initialState === "OPEN" /* OPEN */ ) {
            dialogActions.openDialog();
        }
    }, []);
    var dialogContent = React49.useMemo(function() {
        if (content) {
            return content;
        }
        return /* @__PURE__ */ React49.createElement(React49.Fragment, null, data.dialogContent && data.dialogContent.length > 0 && data.dialogContent.map(function(element, key) {
            return /* @__PURE__ */ React49.createElement(EGDSElement, {
                data: element,
                key: key,
                callback: actionsCallback,
                headingSize: headingSize,
                headingTag: headingTag,
                textSize: textSize
            });
        }));
    }, [
        data.dialogContent,
        actionsCallback,
        content,
        headingSize,
        headingTag,
        textSize
    ]);
    return /* @__PURE__ */ React49.createElement(EGDSDialog, {
        actionsCallback: actionsCallback,
        header: header,
        content: dialogContent,
        footer: footer,
        data: data.dialog,
        dialogId: dialogId,
        isNested: isNested,
        spacing: spacing3,
        actionButtonStid: actionButtonStid,
        handleCloseCallback: handleCloseCallback,
        overlayContent: overlayContent
    });
};
FlightsDialog.displayName = "FlightsDialog";
FlightsDialog.fragment = fragment42;
// ../internal/src/components/flights-information-text/__private/__fragments/text-wrapper.tsx
import React50 from "react";
import { gql as gql52 } from "@apollo/client";
import { UitkSpacing as UitkSpacing9 } from "uitk-react-spacing";
var fragment43 = gql52(_templateObject51(), EGDSText.fragment, EGDSStylizedText.fragment);
var TextWrapper = function(param) {
    var data = param.data, inline = param.inline, size = param.size, spacing3 = param.spacing;
    var TextMemo = React50.useMemo(function() {
        var _data_textA11yMessage;
        var disableAriaHidden = !!((_data_textA11yMessage = data.textA11yMessage) === null || _data_textA11yMessage === void 0 ? void 0 : _data_textA11yMessage.length);
        return /* @__PURE__ */ React50.createElement(React50.Fragment, null, disableAriaHidden && /* @__PURE__ */ React50.createElement("span", {
            className: "is-visually-hidden"
        }, data.textA11yMessage), /* @__PURE__ */ React50.createElement("span", {
            "aria-hidden": disableAriaHidden
        }, /* @__PURE__ */ React50.createElement(EGDSText, {
            data: data.text,
            headingSize: size,
            inline: inline
        })));
    }, [
        data,
        size,
        inline
    ]);
    return /* @__PURE__ */ React50.createElement(React50.Fragment, null, spacing3 ? /* @__PURE__ */ React50.createElement(UitkSpacing9, {
        margin: spacing3.margin,
        padding: spacing3.padding
    }, /* @__PURE__ */ React50.createElement("div", null, TextMemo)) : /* @__PURE__ */ React50.createElement(React50.Fragment, null, TextMemo));
};
TextWrapper.fragment = fragment43;
TextWrapper.displayName = "TextWrapper";
// ../internal/src/components/flights-journey-header/flights-journey-header.tsx
import React57 from "react";
import { gql as gql59 } from "@apollo/client";
import { UitkLayoutFlex as UitkLayoutFlex8, UitkLayoutFlexItem as UitkLayoutFlexItem6 } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing12 } from "uitk-react-spacing";
// ../internal/src/components/flights-information-text/flights-information-text.tsx
import React56 from "react";
import { gql as gql58 } from "@apollo/client";
import { UitkLayoutFlex as UitkLayoutFlex7, UitkLayoutFlexItem as UitkLayoutFlexItem5 } from "uitk-react-layout-flex";
// ../internal/src/components/flights-information-text/__private/flights-information-text-item.tsx
import React55 from "react";
import { gql as gql57 } from "@apollo/client";
// ../internal/src/components/flights-information-text/__private/__fragments/icon-wrapper.tsx
import React51 from "react";
import { gql as gql53 } from "@apollo/client";
import { UitkIcon as UitkIcon3, UitkIconSize as UitkIconSize3 } from "uitk-react-icons";
import { UitkSpacing as UitkSpacing10 } from "uitk-react-spacing";
var fragment44 = gql53(_templateObject52(), Icon.fragment);
var spacing = {
    margin: {
        inlinestart: "one"
    }
};
var IconWrapper = function(param) {
    var data = param.data;
    var icons = data.icons, iconA11yMessage = data.iconA11yMessage;
    if (icons.length === 0) {
        return null;
    }
    return /* @__PURE__ */ React51.createElement(React51.Fragment, null, icons.map(function(icon, index) {
        return /* @__PURE__ */ React51.createElement(UitkSpacing10, {
            margin: spacing.margin,
            key: "".concat(icon.id, "-").concat(index)
        }, /* @__PURE__ */ React51.createElement(UitkIcon3, {
            name: icon.id,
            size: icon.size ? UitkIconSize3[icon.size] : void 0
        }));
    }), iconA11yMessage && /* @__PURE__ */ React51.createElement("span", {
        className: "is-visually-hidden"
    }, iconA11yMessage));
};
IconWrapper.fragment = fragment44;
IconWrapper.displayName = "IconWrapper";
// ../internal/src/components/flights-information-text/__private/__fragments/mark-wrapper.tsx
import React52 from "react";
import { gql as gql54 } from "@apollo/client";
var fragment45 = gql54(_templateObject53(), Mark.fragment);
var MarkWrapper = function(param) {
    var data = param.data;
    return /* @__PURE__ */ React52.createElement(Mark, {
        data: data.mark
    });
};
MarkWrapper.fragment = fragment45;
MarkWrapper.displayName = "MarkWrapper";
// ../internal/src/components/flights-information-text/__private/__fragments/superlative-text.tsx
import React53 from "react";
import { gql as gql55 } from "@apollo/client";
var fragment46 = gql55(_templateObject54(), EGDSStylizedText.fragment);
var SuperlativeText = function(param) {
    var data = param.data;
    var text = data.text, superlativeTextA11yMessage = data.superlativeTextA11yMessage;
    return /* @__PURE__ */ React53.createElement(React53.Fragment, null, superlativeTextA11yMessage && /* @__PURE__ */ React53.createElement("span", {
        className: "is-visually-hidden"
    }, superlativeTextA11yMessage), /* @__PURE__ */ React53.createElement("sup", {
        "aria-hidden": !!superlativeTextA11yMessage
    }, /* @__PURE__ */ React53.createElement(EGDSStylizedText, {
        data: text,
        size: 100
    })));
};
SuperlativeText.fragment = fragment46;
SuperlativeText.displayName = "SuperlativeText";
// ../internal/src/components/flights-information-text/__private/__fragments/badge-wrapper.tsx
import React54 from "react";
import { gql as gql56 } from "@apollo/client";
import { UitkSpacing as UitkSpacing11 } from "uitk-react-spacing";
var fragment47 = gql56(_templateObject55(), EGDSBadge.fragment);
var badgeSpacing = {
    margin: {
        inlinestart: "two"
    }
};
var BadgeWrapper = function(param) {
    var data = param.data;
    return /* @__PURE__ */ React54.createElement(UitkSpacing11, {
        margin: badgeSpacing.margin
    }, /* @__PURE__ */ React54.createElement("div", null, /* @__PURE__ */ React54.createElement(EGDSBadge, {
        data: data.badge
    })));
};
BadgeWrapper.fragment = fragment47;
BadgeWrapper.displayName = "BadgeWrapper";
// ../internal/src/components/flights-information-text/__private/flights-information-text-item.tsx
var fragment48 = gql57(_templateObject56(), MarkWrapper.fragment, TextWrapper.fragment, IconWrapper.fragment, SuperlativeText.fragment, BadgeWrapper.fragment);
var FlightsInformationTextItem = function(param) {
    var data = param.data, size = param.size;
    switch(data.__typename){
        case "MarkWrapper":
            return /* @__PURE__ */ React55.createElement(MarkWrapper, {
                data: data
            });
        case "TextWrapper":
            return /* @__PURE__ */ React55.createElement(TextWrapper, {
                data: data,
                size: size
            });
        case "SuperlativeText":
            return /* @__PURE__ */ React55.createElement(SuperlativeText, {
                data: data
            });
        case "IconWrapper":
            return /* @__PURE__ */ React55.createElement(IconWrapper, {
                data: data
            });
        case "BadgeWrapper":
            return /* @__PURE__ */ React55.createElement(BadgeWrapper, {
                data: data
            });
        default:
            return null;
    }
};
FlightsInformationTextItem.fragment = fragment48;
FlightsInformationTextItem.displayName = "FlightsInformationTextItem";
// ../internal/src/components/flights-information-text/flights-information-text.tsx
var fragment49 = gql58(_templateObject57(), FlightsInformationTextItem.fragment);
var FlightsInformationText = function(param) {
    var data = param.data, size = param.size;
    return /* @__PURE__ */ React56.createElement(UitkLayoutFlex7, {
        space: "one",
        wrap: "wrap"
    }, data.content.map(function(item, index) {
        return /* @__PURE__ */ React56.createElement(UitkLayoutFlexItem5, {
            alignSelf: item.__typename === "SuperlativeText" ? "start" : "center",
            key: "flight-information-text-".concat(index)
        }, /* @__PURE__ */ React56.createElement("div", null, /* @__PURE__ */ React56.createElement(FlightsInformationTextItem, {
            data: item,
            size: size,
            key: "flights-information-text-".concat(index)
        })));
    }));
};
FlightsInformationText.fragment = fragment49;
FlightsInformationText.displayName = "FlightsInformationText";
// ../internal/src/components/flights-journey-header/flights-journey-header.tsx
var fragment50 = gql59(_templateObject58(), FlightsInformationText.fragment);
var spacing2 = {
    margin: {
        blockend: "one"
    }
};
var flightsJourneyHeaderSpacing = {
    padding: {
        inline: "six",
        blockstart: "six"
    }
};
var FlightsJourneyHeader = function(param) {
    var data = param.data, size = param.size;
    if (data.content.length === 0) {
        return null;
    }
    return /* @__PURE__ */ React57.createElement(UitkSpacing12, {
        padding: flightsJourneyHeaderSpacing.padding
    }, /* @__PURE__ */ React57.createElement(UitkLayoutFlex8, {
        alignContent: "center",
        direction: "column"
    }, data.content.map(function(item, index) {
        return /* @__PURE__ */ React57.createElement(UitkSpacing12, {
            margin: spacing2.margin,
            key: "journey-header-information-text-".concat(index)
        }, /* @__PURE__ */ React57.createElement("span", null, /* @__PURE__ */ React57.createElement(UitkLayoutFlexItem6, null, /* @__PURE__ */ React57.createElement(FlightsInformationText, {
            data: item,
            size: size
        }))));
    })));
};
FlightsJourneyHeader.fragment = fragment50;
FlightsJourneyHeader.displayName = "FlightsJourneyHeader";
// ../internal/src/components/flights-details-and-fares/__private/__fragments/flights-fares-information.tsx
import React81, { useEffect as useEffect3, useRef } from "react";
import { gql as gql81 } from "@apollo/client";
import { useClickstreamAnalytics as useClickstreamAnalytics7 } from "@shared-ui/clickstream-analytics-context";
import { UitkSpacing as UitkSpacing23 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading5, UitkSubheading } from "uitk-react-text";
// ../internal/src/components/egds-carousel/egds-carousel.tsx
import React58 from "react";
import { gql as gql60 } from "@apollo/client";
import { useClickTracker as useClickTracker4 } from "@shared-ui/clickstream-analytics-context";
import { UitkCarousel } from "uitk-react-carousel";
import { UitkLayoutFlex as UitkLayoutFlex9 } from "uitk-react-layout-flex";
var fragment51 = gql60(_templateObject59(), EGDSButton.fragment);
var defaultItemsVisible = {
    sm: 1,
    md: 2,
    lg: 3,
    xl: 4
};
var EGDSCarousel = function(param) {
    var analytics = param.analytics, attachItemsToSameSize = param.attachItemsToSameSize, carouselName = param.carouselName, content = param.content, data = param.data, itemsVisible = param.itemsVisible, pageBy = param.pageBy, peek = param.peek, wrapItems = param.wrapItems, scrollTo = param.scrollTo;
    var _analytics, _analytics1;
    var carouselRef = React58.useRef();
    var _data_nextButton_accessibility, _data_previousButton_accessibility;
    var buttonTextMemo = React58.useMemo(function() {
        return {
            nextButton: (_data_nextButton_accessibility = data.nextButton.accessibility) !== null && _data_nextButton_accessibility !== void 0 ? _data_nextButton_accessibility : "",
            prevButton: (_data_previousButton_accessibility = data.previousButton.accessibility) !== null && _data_previousButton_accessibility !== void 0 ? _data_previousButton_accessibility : ""
        };
    }, [
        data
    ]);
    var CarouselContentMemo = React58.useMemo(function() {
        return content.map(function(element, key) {
            if (attachItemsToSameSize) {
                return /* @__PURE__ */ React58.createElement(UitkLayoutFlex9, {
                    tag: "li",
                    key: "uitk-carousel-element-".concat(key)
                }, element);
            }
            return /* @__PURE__ */ React58.createElement(React58.Fragment, null, element);
        });
    }, [
        attachItemsToSameSize,
        content
    ]);
    var trackClick = useClickTracker4();
    var analyticsCarouselTracker = analytics ? {
        callback: function(referrerId, linkName) {
            trackClick(referrerId, linkName);
        },
        description: (_analytics = analytics) === null || _analytics === void 0 ? void 0 : _analytics.linkName,
        id: (_analytics1 = analytics) === null || _analytics1 === void 0 ? void 0 : _analytics1.referrerId
    } : void 0;
    React58.useEffect(function() {
        if (scrollTo) {
            setTimeout(function() {
                var _carouselRef_current, _carouselRef;
                (_carouselRef = carouselRef) === null || _carouselRef === void 0 ? void 0 : (_carouselRef_current = _carouselRef.current) === null || _carouselRef_current === void 0 ? void 0 : _carouselRef_current.changeIndex(scrollTo);
            }, 100);
        }
    }, [
        carouselRef,
        scrollTo
    ]);
    if (content.length === 0) {
        return null;
    }
    return /* @__PURE__ */ React58.createElement(UitkCarousel, {
        analytics: analyticsCarouselTracker,
        carouselName: carouselName !== null && carouselName !== void 0 ? carouselName : void 0,
        buttonText: buttonTextMemo,
        itemsVisible: itemsVisible !== null && itemsVisible !== void 0 ? itemsVisible : defaultItemsVisible,
        pageBy: pageBy !== null && pageBy !== void 0 ? pageBy : 0,
        peek: peek !== null && peek !== void 0 ? peek : true,
        wrapItems: wrapItems,
        carouselRef: carouselRef
    }, CarouselContentMemo);
};
EGDSCarousel.displayName = "EGDSCarousel";
EGDSCarousel.fragment = fragment51;
// ../internal/src/components/flights-details-and-fares/__private/__fragments/__fragments/fare-information-card.tsx
import React79 from "react";
import { gql as gql80 } from "@apollo/client";
import { useClickTracker as useClickTracker10 } from "@shared-ui/clickstream-analytics-context";
import { Experiment, ExperimentControl, ExperimentVariant } from "@shared-ui/experiment-context";
import { UitkCard as UitkCard4, UitkCardFeaturedHeader } from "uitk-react-cards";
import { UitkLayoutFlex as UitkLayoutFlex16, UitkLayoutFlexItem as UitkLayoutFlexItem13 } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing21, UitkSpacingHr } from "uitk-react-spacing";
import { UitkTab as UitkTab2, UitkTabs as UitkTabs2, UitkTabsType as UitkTabsType2 } from "uitk-react-tabs";
// ../internal/src/components/flights-details-and-fares/__private/utils/is-selected.ts
var isSelected = function(state) {
    return state === "SELECTED" /* SELECTED */  || state === "SELECTED_PMP_SELECTED" /* SELECTED_PMP_SELECTED */ ;
};
// ../internal/src/components/egds-basic-tabs/egds-basic-tabs.tsx
import React59, { useEffect as useEffect2 } from "react";
import { gql as gql61 } from "@apollo/client";
import { useClickTracker as useClickTracker5 } from "@shared-ui/clickstream-analytics-context";
import { UitkTab, UitkTabs } from "uitk-react-tabs";
var fragment52 = gql61(_templateObject60(), clientSideAnalyticsFragment);
var EGDSBasicTabs = function(param) {
    var data = param.data, type = param.type, onClickCallback = param.onClickCallback, selectedTab = param.selectedTab;
    var egdsElementId = data.egdsElementId, tabs = data.tabs;
    var analyticsTracker = useClickTracker5();
    var _React59_useState = _sliced_to_array(React59.useState(0), 2), selectedTabDefault = _React59_useState[0], setSelectedTabDefault = _React59_useState[1];
    var handleOnClick = React59.useCallback(function(selectedIndex) {
        var _clickAnalytics, _clickAnalytics1, _onClickCallback;
        var clickAnalytics = tabs[selectedIndex].clickAnalytics;
        setSelectedTabDefault(selectedIndex);
        if (((_clickAnalytics = clickAnalytics) === null || _clickAnalytics === void 0 ? void 0 : _clickAnalytics.referrerId) && ((_clickAnalytics1 = clickAnalytics) === null || _clickAnalytics1 === void 0 ? void 0 : _clickAnalytics1.linkName)) {
            analyticsTracker(clickAnalytics.referrerId, clickAnalytics.linkName);
        }
        (_onClickCallback = onClickCallback) === null || _onClickCallback === void 0 ? void 0 : _onClickCallback(selectedIndex);
    }, [
        analyticsTracker,
        onClickCallback,
        tabs
    ]);
    var TabsWrapper = React59.useMemo(function() {
        var _tab_accessibility;
        return tabs.map(function(tab, index) {
            return /* @__PURE__ */ React59.createElement(UitkTab, {
                name: tab.label,
                id: "tab-".concat(tab.tabId),
                key: "tab-key-".concat(tab.tabId, "-").concat(index),
                targetURI: "#".concat(tab.tabId),
                "aria-label": (_tab_accessibility = tab.accessibility) !== null && _tab_accessibility !== void 0 ? _tab_accessibility : void 0
            });
        });
    }, [
        tabs
    ]);
    useEffect2(function() {
        setSelectedTabDefault(selectedTab !== null && selectedTab !== void 0 ? selectedTab : 0);
    }, [
        selectedTab
    ]);
    return /* @__PURE__ */ React59.createElement(UitkTabs, {
        selectedTab: selectedTabDefault,
        onTabSelect: handleOnClick,
        tabsType: type,
        id: "tabs-".concat(egdsElementId)
    }, TabsWrapper);
};
EGDSBasicTabs.displayName = "EGDSBasicTabs";
EGDSBasicTabs.fragment = fragment52;
// ../internal/src/components/flights-categorized-list/flights-categorized-list.tsx
import React62 from "react";
import { gql as gql64 } from "@apollo/client";
import { UitkList as UitkList7, UitkListItem as UitkListItem6 } from "uitk-react-list";
import { UitkSpacing as UitkSpacing15 } from "uitk-react-spacing";
// ../internal/src/components/flights-categorized-list/__fragments/flights-categorized-list-section.tsx
import React61 from "react";
import { gql as gql63 } from "@apollo/client";
import { UitkList as UitkList6 } from "uitk-react-list";
import { UitkSpacing as UitkSpacing14 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading3, UitkText as UitkText13 } from "uitk-react-text";
// ../internal/src/components/flights-categorized-list/__fragments/flights-categorized-list-item.tsx
import React60 from "react";
import { gql as gql62 } from "@apollo/client";
import { UitkLayoutFlex as UitkLayoutFlex10, UitkLayoutFlexItem as UitkLayoutFlexItem7 } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing13 } from "uitk-react-spacing";
import { UitkText as UitkText12 } from "uitk-react-text";
var fragment53 = gql62(_templateObject61(), EGDSSpannableText.fragment);
var iconSpacing2 = {
    margin: {
        inlineend: "two"
    }
};
var tertiaryTextSpacing = {
    padding: {
        inlinestart: "six"
    },
    margin: {
        inlinestart: "half"
    }
};
var shouldAddTertiarySpacing = function(primary) {
    return primary.contents.some(function(content) {
        return content.__typename === "EGDSGraphicText" || content.__typename === "EGDSIconText";
    });
};
var FlightsCategorizedListItem = function(param) {
    var data = param.data, isSmartShoppingExperience = param.isSmartShoppingExperience;
    var tableCellSpacing = isSmartShoppingExperience ? {
        padding: {
            blockstart: "unset"
        }
    } : {
        padding: {
            blockstart: "two"
        }
    };
    return /* @__PURE__ */ React60.createElement(UitkLayoutFlex10, {
        direction: "column"
    }, /* @__PURE__ */ React60.createElement(UitkLayoutFlexItem7, null, /* @__PURE__ */ React60.createElement(UitkLayoutFlex10, {
        justifyContent: "space-between"
    }, /* @__PURE__ */ React60.createElement(UitkLayoutFlexItem7, null, /* @__PURE__ */ React60.createElement(UitkSpacing13, _object_spread({}, tableCellSpacing), /* @__PURE__ */ React60.createElement("div", null, /* @__PURE__ */ React60.createElement(EGDSSpannableText, {
        data: data.primary,
        iconSpacing: iconSpacing2,
        headingSize: isSmartShoppingExperience ? 7 : void 0,
        headingTag: isSmartShoppingExperience ? "h6" : void 0
    })))), (data.secondaryContent || data.secondary) && /* @__PURE__ */ React60.createElement(UitkLayoutFlexItem7, null, /* @__PURE__ */ React60.createElement(UitkSpacing13, _object_spread({}, tableCellSpacing), data.secondaryContent ? /* @__PURE__ */ React60.createElement(EGDSSpannableText, {
        data: data.secondaryContent
    }) : /* @__PURE__ */ React60.createElement(UitkText12, null, data.secondary))))), data.tertiary && /* @__PURE__ */ React60.createElement(UitkLayoutFlexItem7, null, shouldAddTertiarySpacing(data.primary) ? /* @__PURE__ */ React60.createElement(UitkSpacing13, _object_spread({}, tertiaryTextSpacing), /* @__PURE__ */ React60.createElement(UitkText12, {
        size: 200
    }, data.tertiary)) : /* @__PURE__ */ React60.createElement(UitkText12, {
        size: 200
    }, data.tertiary)));
};
FlightsCategorizedListItem.displayName = "FlightsCategorizedListItem";
FlightsCategorizedListItem.fragment = fragment53;
// ../internal/src/components/flights-categorized-list/__fragments/flights-categorized-list-section.tsx
var fragment54 = gql63(_templateObject62(), EGDSPlainText.fragment, FlightsCategorizedListItem.fragment);
var additionalInfoSpacing = {
    padding: {
        blockstart: "two"
    }
};
var FlightsCategorizedListSpacing = {
    margin: {
        blockstart: "four"
    }
};
var FlightsCategorizedListSection = function(param) {
    var data = param.data, footnoteSpacing = param.footnoteSpacing, headingSize = param.headingSize, flightsListSpacing = param.flightsListSpacing, isSmartShoppingExperience = param.isSmartShoppingExperience;
    var _data_footnote, _data_additionalInfo;
    return /* @__PURE__ */ React61.createElement(UitkSpacing14, {
        margin: flightsListSpacing || FlightsCategorizedListSpacing.margin
    }, /* @__PURE__ */ React61.createElement("div", null, data.heading && /* @__PURE__ */ React61.createElement(UitkHeading3, {
        size: headingSize !== null && headingSize !== void 0 ? headingSize : 6
    }, data.heading), data.items.map(function(item, key) {
        return /* @__PURE__ */ React61.createElement(FlightsCategorizedListItem, {
            data: item,
            key: "flights-categorized-list-item-".concat(key),
            isSmartShoppingExperience: isSmartShoppingExperience
        });
    }), ((_data_footnote = data.footnote) === null || _data_footnote === void 0 ? void 0 : _data_footnote.length) ? /* @__PURE__ */ React61.createElement(UitkSpacing14, _object_spread({}, footnoteSpacing), /* @__PURE__ */ React61.createElement("div", null, data.footnote.map(function(note, key) {
        return /* @__PURE__ */ React61.createElement(UitkText13, {
            size: isSmartShoppingExperience ? 100 : 200,
            key: "footnote-".concat(key),
            spacing: isSmartShoppingExperience ? void 0 : "half"
        }, note);
    }))) : null, ((_data_additionalInfo = data.additionalInfo) === null || _data_additionalInfo === void 0 ? void 0 : _data_additionalInfo.length) ? /* @__PURE__ */ React61.createElement(UitkSpacing14, {
        padding: additionalInfoSpacing.padding
    }, /* @__PURE__ */ React61.createElement(UitkList6, {
        bullet: "no-bullet",
        data: data.additionalInfo
    })) : null));
};
FlightsCategorizedListSection.displayName = "FlightsCategorizedListSection";
FlightsCategorizedListSection.fragment = fragment54;
// ../internal/src/components/flights-categorized-list/flights-categorized-list.tsx
var fragment55 = gql64(_templateObject63(), FlightsCategorizedListSection.fragment);
var smartShoppingCategorizedListSpacing = {
    blockstart: "three"
};
var FlightsCategorizedList = function(param) {
    var data = param.data, footnoteSpacing = param.footnoteSpacing, headingSize = param.headingSize, isSmartShoppingExperience = param.isSmartShoppingExperience;
    var topListSpacing = isSmartShoppingExperience ? {
        margin: {
            blockstart: "two"
        }
    } : {
        margin: {
            blockstart: "unset"
        }
    };
    return /* @__PURE__ */ React62.createElement(UitkSpacing15, {
        margin: topListSpacing.margin
    }, /* @__PURE__ */ React62.createElement(UitkList7, {
        bullet: "no-bullet",
        spacing: false
    }, data.sections.map(function(section, key) {
        return /* @__PURE__ */ React62.createElement(UitkListItem6, {
            key: "listitem-".concat(key)
        }, /* @__PURE__ */ React62.createElement(FlightsCategorizedListSection, {
            data: section,
            key: "flights-categorized-list-section-".concat(key),
            footnoteSpacing: footnoteSpacing,
            flightsListSpacing: smartShoppingCategorizedListSpacing,
            headingSize: headingSize,
            isSmartShoppingExperience: isSmartShoppingExperience
        }));
    })));
};
FlightsCategorizedList.displayName = "FlightsCategorizedList";
FlightsCategorizedList.fragment = fragment55;
// ../internal/src/components/flights-details-and-fares/__private/__fragments/__fragments/__fragments/fare-action.tsx
import React63 from "react";
import { gql as gql65 } from "@apollo/client";
// ../internal/src/components/flights-details-and-fares/__private/utils/is-state-visible.ts
var isStateVisible = function(currentState, possibleStates) {
    var matchState = possibleStates.filter(function(state) {
        return state === currentState;
    });
    return matchState.length > 0;
};
// ../internal/src/components/flights-details-and-fares/__private/__fragments/__fragments/__fragments/fare-action.tsx
var fragment56 = gql65(_templateObject64(), FlightsActionButton.fragment);
var FareAction = function(param) {
    var data = param.data, onFareApplied = param.onFareApplied, state = param.state, size = param.size;
    if (!isStateVisible(state, data.states)) {
        return null;
    }
    return /* @__PURE__ */ React63.createElement(React63.Fragment, null, /* @__PURE__ */ React63.createElement(FlightsActionButton, {
        data: data.action,
        dataStid: "select-button",
        isFullWidth: true,
        callback: onFareApplied,
        size: size,
        dataTestId: "select-button"
    }));
};
FareAction.displayName = "FareAction";
FareAction.fragment = fragment56;
// ../internal/src/components/flights-details-and-fares/__private/__fragments/__fragments/__fragments/fare-heading.tsx
import React66, { useMemo } from "react";
import { gql as gql68 } from "@apollo/client";
import { UitkLayoutFlex as UitkLayoutFlex12, UitkLayoutFlexItem as UitkLayoutFlexItem9 } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing16 } from "uitk-react-spacing";
// ../internal/src/components/flights-details-and-fares/__private/__fragments/__fragments/__fragments/__fragments/fare-pricing.tsx
import React65 from "react";
import { gql as gql67 } from "@apollo/client";
import { UitkPriceLockupAlign as UitkPriceLockupAlign3 } from "uitk-react-price-lockup";
// ../internal/src/components/flights-details-and-fares/__private/__fragments/__fragments/__fragments/__fragments/__fragments/flights-details-and-fares-price-section.tsx
import React64 from "react";
import { gql as gql66 } from "@apollo/client";
import { UitkLayoutFlex as UitkLayoutFlex11, UitkLayoutFlexItem as UitkLayoutFlexItem8 } from "uitk-react-layout-flex";
var fragment57 = gql66(_templateObject65(), EGDSSpannableText.fragment);
var FlightsDetailsAndFaresPriceSection = function(param) {
    var data = param.data;
    return /* @__PURE__ */ React64.createElement(React64.Fragment, null, /* @__PURE__ */ React64.createElement(UitkLayoutFlex11, {
        justifyContent: "end"
    }, /* @__PURE__ */ React64.createElement(UitkLayoutFlexItem8, null, /* @__PURE__ */ React64.createElement(UitkLayoutFlex11, {
        justifyContent: "end",
        space: "two",
        wrap: "wrap"
    }, data.leadingPrice && /* @__PURE__ */ React64.createElement(UitkLayoutFlexItem8, null, /* @__PURE__ */ React64.createElement(EGDSSpannableText, {
        data: data.leadingPrice
    })), /* @__PURE__ */ React64.createElement(UitkLayoutFlexItem8, null, /* @__PURE__ */ React64.createElement("h5", null, /* @__PURE__ */ React64.createElement(EGDSSpannableText, {
        data: data.price,
        size: 500
    })))))), data.secondaryTexts && /* @__PURE__ */ React64.createElement(UitkLayoutFlex11, {
        wrap: "wrap"
    }, /* @__PURE__ */ React64.createElement(UitkLayoutFlexItem8, null, data.secondaryTexts.map(function(text, index) {
        return /* @__PURE__ */ React64.createElement(EGDSSpannableText, {
            data: text,
            key: "price-secondary-text-".concat(index),
            size: 100,
            align: "right"
        });
    }))));
};
FlightsDetailsAndFaresPriceSection.displayName = "FlightsDetailsAndFaresPriceSection";
FlightsDetailsAndFaresPriceSection.fragment = fragment57;
// ../internal/src/components/flights-details-and-fares/__private/__fragments/__fragments/__fragments/__fragments/fare-pricing.tsx
var fragment58 = gql67(_templateObject66(), EGDSPriceLockup.fragment, FlightsDetailsAndFaresPriceSection.fragment);
var FarePricing = function(param) {
    var data = param.data, state = param.state;
    if (!isStateVisible(state, data.states)) {
        return null;
    }
    return data.priceSection ? /* @__PURE__ */ React65.createElement(FlightsDetailsAndFaresPriceSection, {
        data: data.priceSection
    }) : /* @__PURE__ */ React65.createElement(EGDSPriceLockup, {
        data: data.priceLockup,
        align: UitkPriceLockupAlign3.LEFT
    });
};
FarePricing.displayName = "FarePricing";
FarePricing.fragment = fragment58;
// ../internal/src/components/flights-details-and-fares/__private/__fragments/__fragments/__fragments/fare-heading.tsx
var fragment59 = gql68(_templateObject67(), EGDSBadge.fragment, EGDSText.fragment, FarePricing.fragment);
var badgeSpacing2 = {
    margin: {
        blockstart: "two"
    }
};
var badgeSpacer = {
    margin: {
        blockend: "one"
    }
};
var FareHeading = function(param) {
    var state = param.state, data = param.data, goodValue = param.goodValue, goodValueAvailable = param.goodValueAvailable, badgesAvailable = param.badgesAvailable, isSmartShoppingExperience = param.isSmartShoppingExperience;
    var _data_fareDetails;
    var badge = data.badge, farePricing = data.farePricing, fareDetails = data.fareDetails;
    var selectHeaderSpacing = React66.useCallback(function() {
        var spacingProps2 = {};
        if (goodValue) {
            spacingProps2.padding = {
                blockend: "six"
            };
            return spacingProps2;
        }
        if (!badge && (badgesAvailable || goodValueAvailable)) {
            spacingProps2.margin = {
                blockstart: "one"
            };
            spacingProps2.padding = {
                blockstart: "six"
            };
        }
        return spacingProps2;
    }, [
        goodValue,
        badgesAvailable,
        goodValueAvailable,
        badge
    ]);
    var smartShoppingHeadingMemo = useMemo(function() {
        var _fareDetails;
        return /* @__PURE__ */ React66.createElement(React66.Fragment, null, badge && /* @__PURE__ */ React66.createElement(UitkSpacing16, {
            margin: badgeSpacer.margin
        }, /* @__PURE__ */ React66.createElement("div", null, /* @__PURE__ */ React66.createElement(EGDSBadge, {
            data: badge
        }))), /* @__PURE__ */ React66.createElement(UitkSpacing16, _object_spread({}, selectHeaderSpacing()), /* @__PURE__ */ React66.createElement(UitkLayoutFlex12, {
            space: "two",
            justifyContent: "space-between"
        }, /* @__PURE__ */ React66.createElement(UitkLayoutFlexItem9, null, /* @__PURE__ */ React66.createElement("div", null, (_fareDetails = fareDetails) === null || _fareDetails === void 0 ? void 0 : _fareDetails.map(function(fareDetail, keyValue) {
            return /* @__PURE__ */ React66.createElement(EGDSText, {
                data: fareDetail,
                key: "fare-card-details-".concat(keyValue),
                headingSize: 5,
                headingTag: isSmartShoppingExperience ? "h5" : void 0
            });
        }))), /* @__PURE__ */ React66.createElement(UitkLayoutFlexItem9, {
            maxWidth: "half_width"
        }, /* @__PURE__ */ React66.createElement("div", null, farePricing.map(function(farePrice, key) {
            return /* @__PURE__ */ React66.createElement(FarePricing, {
                data: farePrice,
                key: "fare-card-pricing-".concat(key),
                state: state
            });
        }))))));
    }, [
        fareDetails,
        farePricing,
        badge,
        state,
        goodValue
    ]);
    var contentHierarchyHeadingMemo = useMemo(function() {
        return /* @__PURE__ */ React66.createElement(UitkLayoutFlex12, {
            space: "one",
            alignContent: "space-between"
        }, /* @__PURE__ */ React66.createElement(UitkLayoutFlexItem9, {
            grow: 1
        }, /* @__PURE__ */ React66.createElement("div", null, farePricing.map(function(farePrice, key) {
            return /* @__PURE__ */ React66.createElement(FarePricing, {
                data: farePrice,
                key: "fare-card-pricing-".concat(key),
                state: state
            });
        }))), badge && /* @__PURE__ */ React66.createElement(UitkLayoutFlexItem9, null, /* @__PURE__ */ React66.createElement("div", null, /* @__PURE__ */ React66.createElement(UitkSpacing16, {
            margin: badgeSpacing2.margin
        }, /* @__PURE__ */ React66.createElement("div", null, /* @__PURE__ */ React66.createElement(EGDSBadge, {
            data: badge
        }))))));
    }, [
        farePricing,
        badge,
        state
    ]);
    return data.fareDetails && ((_data_fareDetails = data.fareDetails) === null || _data_fareDetails === void 0 ? void 0 : _data_fareDetails.length) > 0 ? smartShoppingHeadingMemo : contentHierarchyHeadingMemo;
};
FareHeading.displayName = "FareHeading";
FareHeading.fragment = fragment59;
// ../internal/src/components/flights-details-and-fares/__private/__fragments/__fragments/__fragments/flights-sponsored-fare-information.tsx
import React71 from "react";
import { gql as gql73 } from "@apollo/client";
import { useClickstreamAnalytics as useClickstreamAnalytics5, useClickTracker as useClickTracker9 } from "@shared-ui/clickstream-analytics-context";
import { UitkExpandoPeek as UitkExpandoPeek2 } from "uitk-react-expando";
import { UitkFigure, UitkFigureAspectRatioType, UitkImage } from "uitk-react-images";
import { UitkLayoutFlex as UitkLayoutFlex13, UitkLayoutFlexItem as UitkLayoutFlexItem10 } from "uitk-react-layout-flex";
import { UitkLayoutPosition } from "uitk-react-layout-position";
import { UitkSpacing as UitkSpacing17 } from "uitk-react-spacing";
import { UitkText as UitkText14 } from "uitk-react-text";
// ../internal/src/components/uitk-badge-size-mapper.tsx
import { UitkBadgeSize } from "uitk-react-badge";
var _obj8;
var UitkBadgeSizeMapper = (_obj8 = {}, _define_property(_obj8, UitkBadgeSize.SMALL, "small"), _define_property(_obj8, UitkBadgeSize.LARGE, "large"), _obj8);
// ../internal/src/components/egds-expando/egds-expando-peek.tsx
import React67 from "react";
import { gql as gql69 } from "@apollo/client";
import { useClickTracker as useClickTracker6 } from "@shared-ui/clickstream-analytics-context";
import { UitkExpandoPeek } from "uitk-react-expando";
var fragment60 = gql69(_templateObject68());
var EGDSExpandoPeek = function(param) {
    var className = param.className, data = param.data, children = param.children, lines = param.lines, items = param.items;
    var _expandAnalytics, _expandAnalytics1;
    var expandAnalytics = data.expandAnalytics, expandedLabel = data.expandedLabel, collapsedLabel = data.collapsedLabel;
    var _React67_useState = _sliced_to_array(React67.useState(false), 2), isVisible = _React67_useState[0], setIsVisible = _React67_useState[1];
    var handleClickAction = React67.useCallback(function() {
        setIsVisible(!isVisible);
    }, [
        isVisible
    ]);
    var clickTracker = useClickTracker6();
    var _expandAnalytics_referrerId, _expandAnalytics_linkName;
    var expandoAnalytics = {
        id: (_expandAnalytics_referrerId = (_expandAnalytics = expandAnalytics) === null || _expandAnalytics === void 0 ? void 0 : _expandAnalytics.referrerId) !== null && _expandAnalytics_referrerId !== void 0 ? _expandAnalytics_referrerId : "",
        description: (_expandAnalytics_linkName = (_expandAnalytics1 = expandAnalytics) === null || _expandAnalytics1 === void 0 ? void 0 : _expandAnalytics1.linkName) !== null && _expandAnalytics_linkName !== void 0 ? _expandAnalytics_linkName : "",
        callback: function(referrerId, linkName) {
            clickTracker(referrerId, linkName);
        }
    };
    return /* @__PURE__ */ React67.createElement(UitkExpandoPeek, {
        items: items,
        lines: lines,
        expandLabel: expandedLabel,
        collapseLabel: collapsedLabel,
        analytics: expandoAnalytics,
        className: className,
        isVisible: isVisible,
        handleClick: handleClickAction
    }, children);
};
EGDSExpandoPeek.fragment = fragment60;
EGDSExpandoPeek.displayName = "EGDSExpandoPeek";
// ../internal/src/components/egds-expando/egds-expando-list-item.tsx
import React68, { useState } from "react";
import { gql as gql70 } from "@apollo/client";
import { useClickTracker as useClickTracker7 } from "@shared-ui/clickstream-analytics-context";
import { UitkExpandoListItem } from "uitk-react-expando";
import { UitkHeading as UitkHeading4 } from "uitk-react-text";
var fragment61 = gql70(_templateObject69());
var EGDSExpandoListItem = function(param) {
    var className = param.className, titleHeadingTag = param.titleHeadingTag, titleHeadingSize = param.titleHeadingSize, triggerPosition = param.triggerPosition, _param_data = param.data, expandAnalytics = _param_data.expandAnalytics, expandedLabel = _param_data.expandedLabel, collapseAnalytics = _param_data.collapseAnalytics, collapsedLabel = _param_data.collapsedLabel, expanded = _param_data.expanded, children = param.children;
    var clickTracker = useClickTracker7();
    var _useState = _sliced_to_array(useState(expanded), 2), visible = _useState[0], setVisible = _useState[1];
    var _useState1 = _sliced_to_array(useState(expanded ? expandedLabel : collapsedLabel), 2), label = _useState1[0], setLabel = _useState1[1];
    var expandoTitle;
    if (titleHeadingTag && titleHeadingSize) {
        expandoTitle = /* @__PURE__ */ React68.createElement(UitkHeading4, {
            tag: titleHeadingTag,
            size: titleHeadingSize
        }, label);
    }
    var onToggle = React68.useCallback(function() {
        if (visible) {
            setLabel(collapsedLabel);
            if (collapseAnalytics) {
                clickTracker(collapseAnalytics.referrerId, collapseAnalytics.linkName);
            }
        } else {
            setLabel(expandedLabel);
            if (expandAnalytics) {
                clickTracker(expandAnalytics.referrerId, expandAnalytics.linkName);
            }
        }
        setVisible(function(isVisible) {
            return !isVisible;
        });
    }, [
        visible,
        collapsedLabel,
        collapseAnalytics,
        expandedLabel,
        expandAnalytics,
        clickTracker
    ]);
    return /* @__PURE__ */ React68.createElement(UitkExpandoListItem, {
        className: className,
        isVisible: visible,
        expandoTitle: expandoTitle !== null && expandoTitle !== void 0 ? expandoTitle : label,
        expandoDescription: children,
        onToggle: onToggle,
        triggerPosition: triggerPosition || "leading"
    });
};
EGDSExpandoListItem.fragment = fragment61;
EGDSExpandoListItem.displayName = "EGDSExpandoListItem";
// ../internal/src/components/egds-expando/egds-expando-link.tsx
import React69 from "react";
import { gql as gql71 } from "@apollo/client";
import { useClickTracker as useClickTracker8 } from "@shared-ui/clickstream-analytics-context";
import { UitkExpandoLink } from "uitk-react-expando";
var fragment62 = gql71(_templateObject70());
var EGDSExpandoLink = function(param) {
    var className = param.className, data = param.data, children = param.children;
    var collapseAnalytics = data.collapseAnalytics, collapsedLabel = data.collapsedLabel, expandAnalytics = data.expandAnalytics, expanded = data.expanded, expandedLabel = data.expandedLabel;
    var clickTracker = useClickTracker8();
    var _React69_useState = _sliced_to_array(React69.useState(expanded), 2), isVisible = _React69_useState[0], setIsVisible = _React69_useState[1];
    var handleClickAction = React69.useCallback(function() {
        if (isVisible) {
            collapseAnalytics && clickTracker(collapseAnalytics.referrerId, collapseAnalytics.linkName);
        } else {
            expandAnalytics && clickTracker(expandAnalytics.referrerId, expandAnalytics.linkName);
        }
        setIsVisible(!isVisible);
    }, [
        isVisible,
        collapsedLabel,
        collapseAnalytics,
        clickTracker,
        expandAnalytics
    ]);
    return /* @__PURE__ */ React69.createElement(UitkExpandoLink, {
        isVisible: isVisible,
        className: className,
        expandedLabel: expandedLabel,
        expandoTitle: collapsedLabel,
        onToggle: handleClickAction,
        size: "medium"
    }, children);
};
EGDSExpandoLink.fragment = fragment62;
EGDSExpandoLink.displayName = "EGDSExpandoLink";
// ../internal/src/components/egds-expando/egds-expando.tsx
import React70 from "react";
import { gql as gql72 } from "@apollo/client";
var fragment63 = gql72(_templateObject71(), EGDSExpandoPeek.fragment, EGDSExpandoListItem.fragment, EGDSExpandoLink.fragment);
var EGDSExpando = function(param) {
    var className = param.className, data = param.data, children = param.children, expandoPeekLines = param.expandoPeekLines, expandoPeekItems = param.expandoPeekItems, titleHeadingSize = param.titleHeadingSize, titleHeadingTag = param.titleHeadingTag, triggerPosition = param.triggerPosition;
    var _data;
    switch((_data = data) === null || _data === void 0 ? void 0 : _data.__typename){
        case "EGDSExpandoPeek":
            return /* @__PURE__ */ React70.createElement(EGDSExpandoPeek, {
                className: className,
                data: data,
                items: expandoPeekItems,
                lines: expandoPeekLines
            }, children);
        case "EGDSExpandoListItem":
            return /* @__PURE__ */ React70.createElement(EGDSExpandoListItem, {
                className: className,
                data: data,
                titleHeadingSize: titleHeadingSize,
                titleHeadingTag: titleHeadingTag,
                triggerPosition: triggerPosition
            }, children);
        case "EGDSExpandoLink":
            return /* @__PURE__ */ React70.createElement(EGDSExpandoLink, {
                className: className,
                data: data
            }, children);
        default:
            return null;
    }
};
EGDSExpando.fragment = fragment63;
EGDSExpando.displayName = "EGDSExpando";
// ../internal/src/components/flights-details-and-fares/__private/__fragments/__fragments/__fragments/flights-sponsored-fare-information.tsx
var fragment64 = gql73(_templateObject72(), EGDSBadge.fragment, EGDSTextList.fragment, EGDSPriceLockup.fragment, clientSideAnalyticsFragment, EGDSExpandoPeek.fragment);
var sectionsPadding = {
    padding: {
        block: "four",
        inline: "four"
    }
};
var fareActionSpacing = {
    margin: {
        blockstart: "four"
    }
};
var bulletpointsSpacing = {
    margin: {
        blockstart: "two"
    }
};
var FlightsSponsoredFareInformation = function(param) {
    var data = param.data, fareAction = param.fareAction, actionData = param.actionData, resetVisibleTrigger = param.resetVisibleTrigger;
    var _showMoreExpando, _showMoreExpando_expandAnalytics, _showMoreExpando1, _showMoreExpando_expandAnalytics1, _showMoreExpando2, _showMoreExpando_collapseAnalytics, _showMoreExpando3, _showMoreExpando_collapseAnalytics1, _showMoreExpando4;
    var clickstreamAnalytics = useClickstreamAnalytics5();
    var mediaSection = data.mediaSection, heading = data.heading, description = data.description, bulletpoints = data.bulletpoints, sponsoredFareAnalyticsList = data.sponsoredFareAnalyticsList, onClickAnalyticsList = data.onClickAnalyticsList, showMoreExpando = data.showMoreExpando;
    var _React71_useState = _sliced_to_array(React71.useState(((_showMoreExpando = showMoreExpando) === null || _showMoreExpando === void 0 ? void 0 : _showMoreExpando.expanded) === true), 2), isVisible = _React71_useState[0], setIsVisible = _React71_useState[1];
    var _React71_useState1 = _sliced_to_array(React71.useState(false), 2), isAnalyticsFired = _React71_useState1[0], setAnalyticsFired = _React71_useState1[1];
    React71.useEffect(function() {
        setIsVisible(false);
    }, [
        resetVisibleTrigger
    ]);
    React71.useEffect(function() {
        var _sponsoredFareAnalyticsList;
        if (((_sponsoredFareAnalyticsList = sponsoredFareAnalyticsList) === null || _sponsoredFareAnalyticsList === void 0 ? void 0 : _sponsoredFareAnalyticsList.length) && !isAnalyticsFired) {
            setAnalyticsFired(true);
            trackDisplayAnalyticsList(clickstreamAnalytics, sponsoredFareAnalyticsList);
        }
    }, [
        clickstreamAnalytics,
        sponsoredFareAnalyticsList,
        isAnalyticsFired
    ]);
    var trackClickAnalytics = React71.useCallback(function() {
        var _onClickAnalyticsList;
        if ((_onClickAnalyticsList = onClickAnalyticsList) === null || _onClickAnalyticsList === void 0 ? void 0 : _onClickAnalyticsList.length) {
            trackAnalyticsList(clickstreamAnalytics, onClickAnalyticsList);
        }
    }, [
        trackAnalyticsList,
        clickstreamAnalytics,
        onClickAnalyticsList
    ]);
    var handlePeekClick = function() {
        return setIsVisible(function(prevIsVisible) {
            return !prevIsVisible;
        });
    };
    var clickTracker = useClickTracker9();
    var _showMoreExpando_expandAnalytics_referrerId, _showMoreExpando_expandAnalytics_linkName;
    var expandedAnalytics = {
        id: (_showMoreExpando_expandAnalytics_referrerId = (_showMoreExpando1 = showMoreExpando) === null || _showMoreExpando1 === void 0 ? void 0 : (_showMoreExpando_expandAnalytics = _showMoreExpando1.expandAnalytics) === null || _showMoreExpando_expandAnalytics === void 0 ? void 0 : _showMoreExpando_expandAnalytics.referrerId) !== null && _showMoreExpando_expandAnalytics_referrerId !== void 0 ? _showMoreExpando_expandAnalytics_referrerId : "",
        description: (_showMoreExpando_expandAnalytics_linkName = (_showMoreExpando2 = showMoreExpando) === null || _showMoreExpando2 === void 0 ? void 0 : (_showMoreExpando_expandAnalytics1 = _showMoreExpando2.expandAnalytics) === null || _showMoreExpando_expandAnalytics1 === void 0 ? void 0 : _showMoreExpando_expandAnalytics1.linkName) !== null && _showMoreExpando_expandAnalytics_linkName !== void 0 ? _showMoreExpando_expandAnalytics_linkName : "",
        callback: function(referrerId, linkName) {
            clickTracker(referrerId, linkName);
        }
    };
    var _showMoreExpando_collapseAnalytics_referrerId, _showMoreExpando_collapseAnalytics_linkName;
    var collapsedAnalytics = {
        id: (_showMoreExpando_collapseAnalytics_referrerId = (_showMoreExpando3 = showMoreExpando) === null || _showMoreExpando3 === void 0 ? void 0 : (_showMoreExpando_collapseAnalytics = _showMoreExpando3.collapseAnalytics) === null || _showMoreExpando_collapseAnalytics === void 0 ? void 0 : _showMoreExpando_collapseAnalytics.referrerId) !== null && _showMoreExpando_collapseAnalytics_referrerId !== void 0 ? _showMoreExpando_collapseAnalytics_referrerId : "",
        description: (_showMoreExpando_collapseAnalytics_linkName = (_showMoreExpando4 = showMoreExpando) === null || _showMoreExpando4 === void 0 ? void 0 : (_showMoreExpando_collapseAnalytics1 = _showMoreExpando4.collapseAnalytics) === null || _showMoreExpando_collapseAnalytics1 === void 0 ? void 0 : _showMoreExpando_collapseAnalytics1.linkName) !== null && _showMoreExpando_collapseAnalytics_linkName !== void 0 ? _showMoreExpando_collapseAnalytics_linkName : "",
        callback: function(referrerId, linkName) {
            clickTracker(referrerId, linkName);
        }
    };
    var getUpsellMediaSection = function() {
        return /* @__PURE__ */ React71.createElement(UitkLayoutPosition, {
            type: "relative",
            position: {
                top: "zero",
                left: "zero"
            }
        }, /* @__PURE__ */ React71.createElement(UitkLayoutFlex13, {
            blockSize: "full_size",
            "data-stid": "vbs-media"
        }, /* @__PURE__ */ React71.createElement(UitkFigure, {
            imageFit: "cover",
            ratio: UitkFigureAspectRatioType.R16_9
        }, /* @__PURE__ */ React71.createElement(UitkImage, {
            alt: "",
            src: mediaSection.featureImage.url
        })), mediaSection.badge && /* @__PURE__ */ React71.createElement(UitkLayoutPosition, {
            type: "absolute",
            position: {
                bottom: "three",
                left: "three",
                zindex: "layer2"
            }
        }, /* @__PURE__ */ React71.createElement(EGDSBadge, {
            data: mediaSection.badge,
            "data-stid": "vbs-badge",
            size: mediaSection.badge.size ? UitkBadgeSizeMapper[mediaSection.badge.size] : void 0
        }))));
    };
    var getUpsellHeadingAndDescriptionSection = function() {
        return (heading || description) && /* @__PURE__ */ React71.createElement("div", {
            "data-stid": "vbs-heading-description"
        }, heading && /* @__PURE__ */ React71.createElement(EGDSText, {
            data: _object_spread_props(_object_spread({}, heading), {
                headingType: null
            })
        }), description && /* @__PURE__ */ React71.createElement(UitkSpacing17, {
            margin: {
                blockstart: "one"
            }
        }, /* @__PURE__ */ React71.createElement(UitkText14, {
            size: 300
        }, description)));
    };
    var getUpsellBulletpointsSection = function() {
        return bulletpoints && /* @__PURE__ */ React71.createElement(UitkSpacing17, _object_spread({}, bulletpointsSpacing), /* @__PURE__ */ React71.createElement("div", {
            "data-stid": "vbs-bulletpoints"
        }, /* @__PURE__ */ React71.createElement(EGDSTextList, {
            data: bulletpoints,
            orientation: "stacked"
        })));
    };
    var getShowMoreExpandoSection = function() {
        return showMoreExpando && /* @__PURE__ */ React71.createElement(UitkExpandoPeek2, {
            isVisible: isVisible,
            handleClick: handlePeekClick,
            items: 1,
            analytics: isVisible ? collapsedAnalytics : expandedAnalytics,
            expandLabel: showMoreExpando.expandedLabel,
            collapseLabel: showMoreExpando.collapsedLabel
        }, getUpsellHeadingAndDescriptionSection(), getUpsellBulletpointsSection());
    };
    var getSponsoredContent = function() {
        return /* @__PURE__ */ React71.createElement(UitkLayoutFlex13, {
            className: "link-container",
            direction: "column",
            justifyContent: "space-between"
        }, /* @__PURE__ */ React71.createElement(UitkLayoutFlexItem10, null, getUpsellMediaSection()), /* @__PURE__ */ React71.createElement(UitkSpacing17, _object_spread({}, sectionsPadding), /* @__PURE__ */ React71.createElement("div", null, getShowMoreExpandoSection(), /* @__PURE__ */ React71.createElement(UitkLayoutFlexItem10, null, /* @__PURE__ */ React71.createElement(UitkLayoutFlex13, {
            alignItems: "stretch"
        }, /* @__PURE__ */ React71.createElement(UitkLayoutFlexItem10, {
            minWidth: "full_width"
        }, /* @__PURE__ */ React71.createElement(UitkSpacing17, _object_spread({}, fareActionSpacing), /* @__PURE__ */ React71.createElement("div", null, fareAction({
            action: actionData
        }, trackClickAnalytics)))))))));
    };
    return getSponsoredContent();
};
FlightsSponsoredFareInformation.displayName = "FlightsSponsoredFareInformation";
FlightsSponsoredFareInformation.fragment = fragment64;
// ../internal/src/components/flights-details-and-fares/__private/__fragments/__fragments/price-match-promise-presentation/fare-price-match-promise-presentation.tsx
import React78 from "react";
import { gql as gql79 } from "@apollo/client";
// ../internal/src/components/flights-details-and-fares/__private/utils/get-new-fare-state.ts
var getNewFareState = function(currentFareState, pmpChecked) {
    if (pmpChecked) {
        if (currentFareState === "SELECTED" /* SELECTED */ ) {
            return "SELECTED_PMP_SELECTED" /* SELECTED_PMP_SELECTED */ ;
        }
        if (currentFareState === "UNSELECTED" /* UNSELECTED */ ) {
            return "UNSELECTED_PMP_SELECTED" /* UNSELECTED_PMP_SELECTED */ ;
        }
    } else {
        if (currentFareState === "SELECTED_PMP_SELECTED" /* SELECTED_PMP_SELECTED */ ) {
            return "SELECTED" /* SELECTED */ ;
        }
        if (currentFareState === "UNSELECTED_PMP_SELECTED" /* UNSELECTED_PMP_SELECTED */ ) {
            return "UNSELECTED" /* UNSELECTED */ ;
        }
    }
    return currentFareState;
};
// ../internal/src/components/price-match-promise/price-match-promise-presentation-wrapper.tsx
import React72 from "react";
// ../internal/src/components/price-match-promise/utils/styling-context.ts
import { createContext, useContext } from "react";
// ../internal/src/components/price-match-promise/utils/styling-map.ts
var defaultValue = {
    contentSpacing: "one",
    infoTriggerSpacing: {
        margin: {
            inlinestart: "one"
        }
    },
    contentMargin: {
        margin: {
            inlinestart: "unset",
            blockstart: "two"
        }
    },
    headingSize: 5
};
var _obj9;
var styling_map = (_obj9 = {}, _define_property(_obj9, 0 /* CARD_PRESENTATION */ , defaultValue), _define_property(_obj9, 1 /* PLACARD */ , _object_spread_props(_object_spread({}, defaultValue), {
    contentMargin: {
        margin: {
            inlinestart: "six"
        }
    },
    textSize: 200,
    linkSize: "small"
})), _obj9);
// ../internal/src/components/price-match-promise/utils/styling-context.ts
var StylingContext = createContext(defaultValue);
var useStylingContext = function() {
    return useContext(StylingContext);
};
// ../internal/src/components/price-match-promise/price-match-promise-presentation-wrapper.tsx
var PriceMatchPromisePresentationWrapper = function(param) {
    var presentationType = param.presentationType, children = param.children;
    var styling = styling_map[presentationType];
    return /* @__PURE__ */ React72.createElement(StylingContext.Provider, {
        value: styling
    }, children);
};
// ../internal/src/components/price-match-promise/price-match-promise-selectable-card.tsx
import React75 from "react";
import { gql as gql76 } from "@apollo/client";
import { UitkLayoutFlex as UitkLayoutFlex14, UitkLayoutFlexItem as UitkLayoutFlexItem11 } from "uitk-react-layout-flex";
import { UitkLayoutGrid, UitkLayoutGridItem } from "uitk-react-layout-grid";
import { UitkSpacing as UitkSpacing18 } from "uitk-react-spacing";
import { UitkText as UitkText16 } from "uitk-react-text";
import { liveAnnounce as liveAnnounce2 } from "uitk-react-utils";
// ../internal/src/components/common/utility.ts
var isNullable = function(val) {
    return val === null;
};
var isNotNullable = function(val) {
    return !isNullable(val);
};
// ../internal/src/components/flights-action-checkbox/flights-action-checkbox.tsx
import React73 from "react";
import { gql as gql74 } from "@apollo/client";
import { useClickstreamAnalytics as useClickstreamAnalytics6 } from "@shared-ui/clickstream-analytics-context";
import { UitkCheckbox } from "uitk-react-checkbox";
import { UitkText as UitkText15 } from "uitk-react-text";
var fragment65 = gql74(_templateObject73(), clientActionFragment, EGDSText.fragment, clientSideAnalyticsFragment);
var isChecked = function(checked, state) {
    return checked !== null && checked !== void 0 ? checked : state === "CHECKED" /* CHECKED */ ;
};
var getAccessibility = function(data, checked) {
    return checked ? data.checkedAccessibility : data.uncheckedAccessibility;
};
var FlightsActionCheckbox = function(param) {
    var _param_id = param.id, id = _param_id === void 0 ? "checkbox" : _param_id, data = param.data, checked = param.checked, onChange = param.onChange, size = param.size, _param_isLabelA11yDisabled = param.isLabelA11yDisabled, isLabelA11yDisabled = _param_isLabelA11yDisabled === void 0 ? false : _param_isLabelA11yDisabled;
    var _React73_useState = _sliced_to_array(React73.useState(false), 2), checkedState = _React73_useState[0], setCheckedState = _React73_useState[1];
    var _React73_useState1 = _sliced_to_array(React73.useState(null), 2), ariaLabel = _React73_useState1[0], setAriaLabel = _React73_useState1[1];
    React73.useEffect(function() {
        var isSelected2 = isChecked(checked, data.state);
        setCheckedState(isSelected2);
        setAriaLabel(getAccessibility(data, isSelected2));
    }, []);
    var clickStreamAnalytics = useClickstreamAnalytics6();
    var fireClickAnalytics = React73.useCallback(function(newCheckedState) {
        if (clickStreamAnalytics) {
            var analytics = newCheckedState ? data.checkedAnalytics : data.uncheckedAnalytics;
            if (analytics) {
                trackAnalyticsList(clickStreamAnalytics, [
                    analytics
                ]);
            }
        }
    }, [
        clickStreamAnalytics,
        checkedState,
        data
    ]);
    var onChangeWrapper = React73.useCallback(function(e) {
        var newState = !checkedState;
        setAriaLabel(getAccessibility(data, newState));
        fireClickAnalytics(newState);
        setCheckedState(newState);
        onChange(e, newState, data.clientAction);
    }, [
        checkedState,
        onChange,
        setCheckedState,
        fireClickAnalytics,
        data
    ]);
    return /* @__PURE__ */ React73.createElement(UitkCheckbox, {
        id: id,
        checked: checkedState,
        onChange: onChangeWrapper,
        "data-stid": "flight-action-checkbox",
        a11yLabel: ariaLabel !== null && ariaLabel !== void 0 ? ariaLabel : void 0
    }, /* @__PURE__ */ React73.createElement("div", {
        "aria-hidden": isLabelA11yDisabled,
        "data-stid": "checkbox-content"
    }, /* @__PURE__ */ React73.createElement(UitkText15, {
        theme: "emphasis",
        inline: true
    }, /* @__PURE__ */ React73.createElement(EGDSText, {
        data: data.label,
        textSize: size
    }))));
};
FlightsActionCheckbox.displayName = "FlightsActionCheckbox";
FlightsActionCheckbox.fragment = fragment65;
// ../internal/src/components/price-match-promise/__private/price-match-promise-heading-section.tsx
import React74 from "react";
import { gql as gql75 } from "@apollo/client";
var fragment66 = gql75(_templateObject74(), EGDSGraphicText.fragment, EGDSBasicSectionHeading.fragment);
var PriceMatchPromiseCardHeadingSection = function(param) {
    var data = param.data, headingSize = param.headingSize;
    switch(data.__typename){
        case "EGDSBasicSectionHeading":
            return /* @__PURE__ */ React74.createElement(EGDSBasicSectionHeading, {
                data: data,
                headingSize: headingSize
            });
        case "EGDSGraphicText":
            return /* @__PURE__ */ React74.createElement(EGDSGraphicText, {
                data: data,
                inline: true
            });
        default:
            return /* @__PURE__ */ React74.createElement(React74.Fragment, null);
    }
};
PriceMatchPromiseCardHeadingSection.displayName = "PriceMatchPromiseCardHeadingSection";
PriceMatchPromiseCardHeadingSection.fragment = fragment66;
// ../internal/src/components/price-match-promise/price-match-promise-selectable-card.tsx
var fragment67 = gql76(_templateObject75(), PriceMatchPromiseCardHeadingSection.fragment, FlightsActionCheckbox.fragment, FlightsDialogTrigger.fragment);
var isIconDialogTriggerType = function(data) {
    switch(data.__typename){
        case "FlightsActionLink":
            return !!data.icon;
        default:
            return false;
    }
};
var PriceMatchPromiseSelectableCard = function(param) {
    var data = param.data, checkboxId = param.checkboxId, changeState = param.changeState;
    var onChange = React75.useCallback(function(_e, checked, clientAction) {
        var _clientAction_insuranceCriteria, _clientAction_jcidValue;
        changeState({
            isChecked: checked,
            data: {
                insuranceCriteria: (_clientAction_insuranceCriteria = clientAction.insuranceCriteria) !== null && _clientAction_insuranceCriteria !== void 0 ? _clientAction_insuranceCriteria : void 0,
                jcid: (_clientAction_jcidValue = clientAction.jcidValue) !== null && _clientAction_jcidValue !== void 0 ? _clientAction_jcidValue : void 0
            }
        });
        var announcment = checked ? clientAction.checkedAccessibilityAnnouncement : clientAction.uncheckedAccessibilityAnnouncement;
        if (announcment) {
            liveAnnounce2(announcment);
        }
    }, [
        changeState
    ]);
    var isIconTrigger = isIconDialogTriggerType(data.infoTrigger.trigger);
    var isLabelA11yDisabled = isNotNullable(data.checkbox.uncheckedAccessibility);
    var styling = useStylingContext();
    return /* @__PURE__ */ React75.createElement(React75.Fragment, null, /* @__PURE__ */ React75.createElement(UitkLayoutFlex14, null, /* @__PURE__ */ React75.createElement(UitkLayoutFlexItem11, null, /* @__PURE__ */ React75.createElement(PriceMatchPromiseCardHeadingSection, {
        data: data.headingSection,
        headingSize: styling.headingSize
    })), isIconTrigger && /* @__PURE__ */ React75.createElement(UitkLayoutFlexItem11, null, /* @__PURE__ */ React75.createElement(UitkSpacing18, _object_spread({}, styling.infoTriggerSpacing), /* @__PURE__ */ React75.createElement("div", null, /* @__PURE__ */ React75.createElement(FlightsDialogTrigger, {
        data: data.infoTrigger,
        isNested: true
    }))))), /* @__PURE__ */ React75.createElement(UitkSpacing18, _object_spread({}, styling.contentMargin), /* @__PURE__ */ React75.createElement("div", null, /* @__PURE__ */ React75.createElement(UitkLayoutGrid, {
        space: styling.contentSpacing
    }, /* @__PURE__ */ React75.createElement(UitkLayoutGridItem, null, data.description && /* @__PURE__ */ React75.createElement(UitkText16, {
        size: styling.textSize
    }, data.description)), /* @__PURE__ */ React75.createElement(UitkLayoutGridItem, null, !isIconTrigger && /* @__PURE__ */ React75.createElement(FlightsDialogTrigger, {
        data: data.infoTrigger,
        isNested: true,
        linkSize: styling.linkSize
    })), /* @__PURE__ */ React75.createElement(UitkLayoutGridItem, null, /* @__PURE__ */ React75.createElement(UitkLayoutFlex14, null, /* @__PURE__ */ React75.createElement(UitkLayoutFlexItem11, {
        grow: 1
    }, /* @__PURE__ */ React75.createElement("div", null, /* @__PURE__ */ React75.createElement(FlightsActionCheckbox, {
        data: data.checkbox,
        onChange: onChange,
        id: checkboxId,
        size: styling.textSize,
        isLabelA11yDisabled: true
    }))), /* @__PURE__ */ React75.createElement(UitkLayoutFlexItem11, {
        alignSelf: "center"
    }, /* @__PURE__ */ React75.createElement(UitkSpacing18, {
        margin: {
            block: "two"
        }
    }, /* @__PURE__ */ React75.createElement("div", {
        "aria-hidden": isLabelA11yDisabled
    }, /* @__PURE__ */ React75.createElement(UitkText16, {
        size: styling.textSize,
        align: "right"
    }, data.price), data.priceInfo && /* @__PURE__ */ React75.createElement(UitkText16, {
        size: styling.textSize,
        align: "right"
    }, data.priceInfo))))))))));
};
PriceMatchPromiseSelectableCard.displayName = "PriceDropProtectionSelectableCard";
PriceMatchPromiseSelectableCard.fragment = fragment67;
// ../internal/src/components/flights-details-and-fares/__private/__fragments/__fragments/price-match-promise-presentation/__fragments/fare-price-match-promise-removable-card.tsx
import React76 from "react";
import { gql as gql77 } from "@apollo/client";
import { UitkSpacing as UitkSpacing19 } from "uitk-react-spacing";
import { UitkText as UitkText17 } from "uitk-react-text";
var fragment68 = gql77(_templateObject76(), FlightsActionLink.fragment);
var removeLinkSpacing = {
    padding: {
        blockstart: "two"
    },
    margin: {
        inlinestart: "six"
    }
};
var iconSpacing3 = {
    margin: {
        inlineend: "one"
    },
    padding: {
        inlineend: "half"
    }
};
var subheadingSpacing = {
    padding: {
        blockstart: "one"
    },
    margin: {
        inlinestart: "six"
    }
};
var FarePriceMatchPromiseRemovableCard = function(param) {
    var changeFareState = param.changeFareState, data = param.data, fareState = param.fareState, updatePmpState = param.updatePmpState;
    var onClick = React76.useCallback(function() {
        updatePmpState("SELECTABLE" /* SELECTABLE */ );
        var newFareState = getNewFareState(fareState, false);
        changeFareState(newFareState);
    }, [
        changeFareState,
        fareState,
        updatePmpState
    ]);
    return /* @__PURE__ */ React76.createElement(React76.Fragment, null, /* @__PURE__ */ React76.createElement(EGDSIconText, {
        data: data.heading,
        iconSpacing: iconSpacing3
    }), /* @__PURE__ */ React76.createElement(UitkSpacing19, {
        margin: subheadingSpacing.margin,
        padding: subheadingSpacing.padding
    }, /* @__PURE__ */ React76.createElement(UitkText17, {
        size: 200
    }, data.subHeading)), /* @__PURE__ */ React76.createElement(UitkSpacing19, {
        margin: removeLinkSpacing.margin,
        padding: removeLinkSpacing.padding
    }, /* @__PURE__ */ React76.createElement("div", null, /* @__PURE__ */ React76.createElement(FlightsActionLink, {
        data: data.removeAction,
        size: "small",
        callback: onClick
    }))));
};
FarePriceMatchPromiseRemovableCard.displayName = "FarePriceMatchPromiseRemovableCard";
FarePriceMatchPromiseRemovableCard.fragment = fragment68;
// ../internal/src/components/flights-details-and-fares/__private/__fragments/__fragments/price-match-promise-presentation/__fragments/fare-price-match-promise-static-card.tsx
import React77 from "react";
import { gql as gql78 } from "@apollo/client";
import { UitkLayoutFlex as UitkLayoutFlex15, UitkLayoutFlexItem as UitkLayoutFlexItem12 } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing20 } from "uitk-react-spacing";
import { UitkText as UitkText18 } from "uitk-react-text";
var fragment69 = gql78(_templateObject77(), EGDSIconText.fragment);
var iconSpacing4 = {
    margin: {
        inlineend: "one"
    },
    padding: {
        inlineend: "half"
    }
};
var subheadingSpacing2 = {
    padding: {
        blockstart: "one"
    },
    margin: {
        inlinestart: "six"
    }
};
var FarePriceMatchPromiseStaticCard = function(param) {
    var data = param.data;
    return /* @__PURE__ */ React77.createElement(React77.Fragment, null, /* @__PURE__ */ React77.createElement(UitkLayoutFlex15, null, /* @__PURE__ */ React77.createElement(UitkLayoutFlexItem12, null, /* @__PURE__ */ React77.createElement(EGDSIconText, {
        data: data.heading,
        iconSpacing: iconSpacing4,
        inline: true
    }))), /* @__PURE__ */ React77.createElement(UitkSpacing20, {
        margin: subheadingSpacing2.margin,
        padding: subheadingSpacing2.padding
    }, /* @__PURE__ */ React77.createElement(UitkText18, {
        size: 200
    }, data.subHeading)));
};
FarePriceMatchPromiseStaticCard.displayName = "FarePriceMatchPromiseStaticCard";
FarePriceMatchPromiseStaticCard.fragment = fragment69;
// ../internal/src/components/flights-details-and-fares/__private/__fragments/__fragments/price-match-promise-presentation/fare-price-match-promise-presentation.tsx
var fragment70 = gql79(_templateObject78(), PriceMatchPromiseSelectableCard.fragment, FarePriceMatchPromiseRemovableCard.fragment, FarePriceMatchPromiseStaticCard.fragment);
var FarePriceMatchPromisePresentation = function(param) {
    var changeFareState = param.changeFareState, data = param.data, fareState = param.fareState, checkboxId = param.checkboxId;
    var _React78_useState = _sliced_to_array(React78.useState(data.priceMatchPromiseState), 2), pmpState = _React78_useState[0], setPmpState = _React78_useState[1];
    var changeFareStateHandler = React78.useCallback(function(param) {
        var isChecked2 = param.isChecked;
        var newFareState = getNewFareState(fareState, isChecked2);
        changeFareState(newFareState);
    }, [
        changeFareState,
        fareState,
        setPmpState
    ]);
    return /* @__PURE__ */ React78.createElement(React78.Fragment, null, data.cards.map(function(card, key) {
        if (card.__typename === "FarePriceMatchPromiseSelectableCard" && pmpState === card.priceMatchPromiseState) {
            return /* @__PURE__ */ React78.createElement(PriceMatchPromisePresentationWrapper, {
                presentationType: 1 /* PLACARD */ 
            }, /* @__PURE__ */ React78.createElement(PriceMatchPromiseSelectableCard, {
                data: card,
                key: "fare-pmp-card-".concat(key),
                checkboxId: checkboxId,
                changeState: changeFareStateHandler
            }));
        }
        if (card.__typename === "FarePriceMatchPromiseRemovableCard" && pmpState === card.priceMatchPromiseState) {
            return /* @__PURE__ */ React78.createElement(FarePriceMatchPromiseRemovableCard, {
                data: card,
                key: "fare-pmp-card-".concat(key),
                updatePmpState: setPmpState,
                changeFareState: changeFareState,
                fareState: fareState
            });
        }
        if (card.__typename === "FarePriceMatchPromiseStaticCard" && pmpState === card.priceMatchPromiseState) {
            return /* @__PURE__ */ React78.createElement(FarePriceMatchPromiseStaticCard, {
                data: card,
                key: "fare-pmp-card-".concat(key)
            });
        }
        return null;
    }));
};
FarePriceMatchPromisePresentation.displayName = "FarePriceMatchPromisePresentation";
FarePriceMatchPromisePresentation.fragment = fragment70;
// ../internal/src/components/flights-details-and-fares/__private/__fragments/__fragments/fare-information-card.tsx
var fragment71 = gql80(_templateObject79(), EGDSText.fragment, EGDSBasicTabs.fragment, FareAction.fragment, FareHeading.fragment, FarePriceMatchPromisePresentation.fragment, FlightsCategorizedList.fragment, clientSideAnalyticsFragment, FlightsSponsoredFareInformation.fragment);
var fareActionSpacing2 = {
    margin: {
        blockstart: "six"
    }
};
var fareDetailsSpacing = {
    margin: {
        blockstart: "two"
    }
};
var fareDetailsWithoutSpacing = {
    margin: {
        blockstart: "unset"
    }
};
var priceMatchPromiseSpacing = {
    margin: {
        blockstart: "three"
    }
};
var defaultFootnoteSpacing = {
    padding: {
        blockstart: "unset"
    }
};
var goodValueCardSpacing = {
    blockstart: "half",
    blockend: "four",
    inline: "four"
};
var goodValueCardSmartShoppingSpacing = {
    blockstart: "three",
    blockend: "six",
    inline: "six"
};
var fareInfoSpacing = "four";
var fareInfoSmartShoppingSpacing = "six";
var FareInformationCard = function(param) {
    var data = param.data, fareCardKey = param.fareCardKey, highlightSponsored = param.highlightSponsored, onFareApplied = param.onFareApplied, fareCardRef = param.fareCardRef, goodValueAvailable = param.goodValueAvailable, badgesAvailable = param.badgesAvailable, isSmartShoppingExperience = param.isSmartShoppingExperience;
    var footnoteSpacing = isSmartShoppingExperience ? {
        padding: {
            blockstart: "half"
        }
    } : defaultFootnoteSpacing;
    var goodValueCardPaddingSpacing = isSmartShoppingExperience ? goodValueCardSmartShoppingSpacing : goodValueCardSpacing;
    var fareInfoCardPaddingSpacing = isSmartShoppingExperience ? fareInfoSmartShoppingSpacing : fareInfoSpacing;
    var _React79_useState = _sliced_to_array(React79.useState(data.state), 2), state = _React79_useState[0], setFareState = _React79_useState[1];
    var _React79_useState1 = _sliced_to_array(React79.useState(0), 2), activeTab = _React79_useState1[0], setActiveTab = _React79_useState1[1];
    var fareTabs = data.fareTabs, isSponsored = data.sponsoredContent, fareCardIdentifier = data.fareCardIdentifier;
    var clickTracker = useClickTracker10();
    var trackTabClickAnalytics = React79.useCallback(function(analytics) {
        if (analytics) {
            clickTracker(analytics.referrerId, analytics.linkName);
        }
    }, [
        clickTracker
    ]);
    var onStateChanged = React79.useCallback(function(newState) {
        setFareState(newState);
    }, [
        setFareState
    ]);
    var onFareAppliedWithExtraAction = function(clientAction, additionalAction) {
        var _additionalAction;
        (_additionalAction = additionalAction) === null || _additionalAction === void 0 ? void 0 : _additionalAction();
        onFareApplied(clientAction);
    };
    var getFareAction = function(fareInfoCardFragment, additionalAction) {
        return fareInfoCardFragment.action.map(function(action, keyValue) {
            return /* @__PURE__ */ React79.createElement(FareAction, {
                data: action,
                key: "fare-card-action-".concat(keyValue),
                state: state,
                onFareApplied: function(clientAction) {
                    return onFareAppliedWithExtraAction(clientAction, additionalAction);
                }
            });
        });
    };
    var handleTabChanges = function(tabIndex) {
        var _fareTabs;
        setActiveTab(tabIndex);
        var tabs = ((_fareTabs = fareTabs) === null || _fareTabs === void 0 ? void 0 : _fareTabs.__typename) === "EGDSBasicTabs" && fareTabs.tabs;
        trackTabClickAnalytics(tabs[tabIndex].clickAnalytics);
    };
    var selectHighlighted = highlightSponsored ? !!data.sponsoredContent : data.highlighted;
    var getFareMainCard = function(fareData) {
        return /* @__PURE__ */ React79.createElement(UitkSpacing21, {
            padding: fareData.featuredHeader ? goodValueCardPaddingSpacing : fareInfoCardPaddingSpacing,
            margin: fareData.featuredHeader ? {
                blockstart: "two"
            } : void 0
        }, /* @__PURE__ */ React79.createElement(UitkLayoutFlex16, {
            className: "link-container",
            direction: "column"
        }, /* @__PURE__ */ React79.createElement(FareHeading, {
            data: fareData.heading,
            state: state,
            goodValueAvailable: goodValueAvailable,
            goodValue: fareData.featuredHeader,
            badgesAvailable: badgesAvailable,
            isSmartShoppingExperience: isSmartShoppingExperience
        }), /* @__PURE__ */ React79.createElement(UitkSpacing21, {
            margin: isSmartShoppingExperience ? fareDetailsWithoutSpacing.margin : fareDetailsSpacing.margin
        }, /* @__PURE__ */ React79.createElement("div", null, fareData.fareDetails.map(function(fareDetail, keyValue) {
            return /* @__PURE__ */ React79.createElement(EGDSText, {
                dataStid: fareCardIdentifier,
                data: fareDetail,
                key: "fare-card-details-".concat(keyValue)
            });
        }))), /* @__PURE__ */ React79.createElement(UitkLayoutFlexItem13, {
            grow: 1
        }, /* @__PURE__ */ React79.createElement(UitkLayoutFlex16, {
            direction: "column",
            justifyContent: "space-around"
        }, /* @__PURE__ */ React79.createElement(UitkLayoutFlexItem13, {
            minWidth: "full_width"
        }, /* @__PURE__ */ React79.createElement(FlightsCategorizedList, {
            data: fareData.amenities,
            footnoteSpacing: footnoteSpacing,
            isSmartShoppingExperience: isSmartShoppingExperience
        })))), /* @__PURE__ */ React79.createElement(UitkLayoutFlexItem13, null, /* @__PURE__ */ React79.createElement(UitkLayoutFlex16, {
            direction: "column",
            alignItems: "stretch"
        }, fareData.priceMatchPromise && /* @__PURE__ */ React79.createElement(UitkLayoutFlexItem13, null, /* @__PURE__ */ React79.createElement("div", {
            "data-stid": "price-match-promise-card"
        }, /* @__PURE__ */ React79.createElement(UitkSpacingHr, {
            blockMargin: "four"
        }), /* @__PURE__ */ React79.createElement(UitkSpacing21, {
            margin: priceMatchPromiseSpacing.margin
        }, /* @__PURE__ */ React79.createElement("div", null, /* @__PURE__ */ React79.createElement(FarePriceMatchPromisePresentation, {
            changeFareState: onStateChanged,
            data: fareData.priceMatchPromise,
            fareState: state,
            checkboxId: "pmp-checkbox-".concat(fareCardKey)
        }))))), /* @__PURE__ */ React79.createElement(UitkLayoutFlexItem13, {
            minWidth: "full_width"
        }, /* @__PURE__ */ React79.createElement(UitkSpacing21, {
            margin: fareData.featuredHeader ? {
                blockstart: "six"
            } : fareActionSpacing2.margin,
            padding: fareData.featuredHeader ? {
                blockstart: "three"
            } : void 0
        }, /* @__PURE__ */ React79.createElement("div", null, getFareAction(fareData))))))));
    };
    var getTabbedFareCard = function(fareData) {
        var _fareData_fareTabs, _fareData_fareTabs1;
        return /* @__PURE__ */ React79.createElement(UitkTabs2, {
            selectedTab: activeTab,
            onTabSelect: handleTabChanges,
            tabsType: UitkTabsType2.EQUAL_WIDTH
        }, /* @__PURE__ */ React79.createElement(UitkTab2, {
            name: (_fareData_fareTabs = fareData.fareTabs) === null || _fareData_fareTabs === void 0 ? void 0 : _fareData_fareTabs.tabs[0].label,
            id: "fare-".concat(fareCardKey, "-primary"),
            key: "fare-".concat(fareCardKey, "-primary"),
            disabled: false,
            targetURI: "fare-".concat(fareCardKey, "-primary")
        }, getFareMainCard(fareData)), /* @__PURE__ */ React79.createElement(UitkTab2, {
            name: (_fareData_fareTabs1 = fareData.fareTabs) === null || _fareData_fareTabs1 === void 0 ? void 0 : _fareData_fareTabs1.tabs[1].label,
            id: "fare-".concat(fareCardKey, "-secondary"),
            key: "fare-".concat(fareCardKey, "-secondary"),
            disabled: false,
            targetURI: "fare-".concat(fareCardKey, "-secondary")
        }, /* @__PURE__ */ React79.createElement(FlightsSponsoredFareInformation, {
            data: fareData.sponsoredContent,
            actionData: data.action,
            fareAction: getFareAction,
            resetVisibleTrigger: activeTab
        })));
    };
    return /* @__PURE__ */ React79.createElement(UitkLayoutFlexItem13, {
        grow: 1
    }, /* @__PURE__ */ React79.createElement(UitkCard4, {
        selected: selectHighlighted || isSelected(data.state),
        border: true
    }, data.featuredHeader && /* @__PURE__ */ React79.createElement(UitkCardFeaturedHeader, {
        title: {
            text: data.featuredHeader
        }
    }), /* @__PURE__ */ React79.createElement("div", {
        "data-stid": "fare-card",
        ref: data.highlighted ? fareCardRef : void 0
    }, /* @__PURE__ */ React79.createElement(Experiment, {
        name: "EGTnL_MeSo_Sidesheet_Flight_USV"
    }, /* @__PURE__ */ React79.createElement(ExperimentControl, null, getFareMainCard(data)), /* @__PURE__ */ React79.createElement(ExperimentVariant, {
        bucket: 1
    }, isSponsored ? getTabbedFareCard(data) : getFareMainCard(data))))));
};
FareInformationCard.displayName = "FareInformationCard";
FareInformationCard.fragment = fragment71;
// ../internal/src/components/flights-details-and-fares/__private/__fragments/__fragments/fare-information-card-skeleton.tsx
import React80 from "react";
import { UitkCard as UitkCard5, UitkCardContentSection as UitkCardContentSection2 } from "uitk-react-cards";
import { UitkLayoutFlex as UitkLayoutFlex17, UitkLayoutFlexItem as UitkLayoutFlexItem14 } from "uitk-react-layout-flex";
import { UitkLineSkeleton as UitkLineSkeleton2 } from "uitk-react-skeleton";
import { UitkSpacing as UitkSpacing22 } from "uitk-react-spacing";
var topSkeletons = [
    {
        margin: {
            blockstart: "four"
        },
        type: "primary"
    },
    {
        margin: {
            blockstart: "two",
            blockend: "six"
        },
        type: "secondary"
    },
    {
        margin: {
            blockstart: "two"
        },
        type: "primary"
    },
    {
        margin: {
            blockstart: "two",
            blockend: "two"
        },
        type: "secondary"
    }
];
var bottomSkeletons = [
    {
        margin: {
            blockstart: "four"
        },
        type: "primary"
    },
    {
        margin: {
            blockstart: "two",
            blockend: "six"
        },
        type: "secondary"
    }
];
var topSkeletonsOuterSpacingProps = {
    margin: {
        blockstart: "six"
    }
};
var bottomSkeletonsSpacingProps = {
    margin: {
        blockstart: "two"
    }
};
var FareTypeCardSkeleton = function() {
    var renderSkeleton = function(compProps, index) {
        var margin = compProps.margin, type = compProps.type;
        return /* @__PURE__ */ React80.createElement(UitkSpacing22, {
            margin: margin,
            key: index
        }, /* @__PURE__ */ React80.createElement(UitkLineSkeleton2, {
            animation: true,
            type: type
        }));
    };
    return /* @__PURE__ */ React80.createElement(UitkSpacing22, {
        padding: "six"
    }, /* @__PURE__ */ React80.createElement(UitkLayoutFlexItem14, {
        grow: 1
    }, /* @__PURE__ */ React80.createElement(UitkCard5, {
        border: true
    }, /* @__PURE__ */ React80.createElement(UitkLayoutFlex17, {
        className: "link-container",
        direction: "column",
        justifyContent: "space-between"
    }, /* @__PURE__ */ React80.createElement(UitkLayoutFlexItem14, null, /* @__PURE__ */ React80.createElement(UitkLayoutFlex17, {
        space: "three",
        direction: "column"
    }, /* @__PURE__ */ React80.createElement(UitkLayoutFlexItem14, null, /* @__PURE__ */ React80.createElement(UitkSpacing22, {
        margin: topSkeletonsOuterSpacingProps.margin
    }, /* @__PURE__ */ React80.createElement("section", {
        "data-stid": "fare-skeleton-loading"
    }, topSkeletons.map(function(componentProps, index) {
        return renderSkeleton(componentProps, index);
    })))))), /* @__PURE__ */ React80.createElement(UitkLayoutFlexItem14, null, /* @__PURE__ */ React80.createElement(UitkSpacing22, {
        margin: bottomSkeletonsSpacingProps.margin
    }, /* @__PURE__ */ React80.createElement(UitkCardContentSection2, {
        border: "top",
        padded: false
    }, bottomSkeletons.map(function(componentProps, index) {
        return renderSkeleton(componentProps, index);
    }))))))));
};
// ../internal/src/components/flights-details-and-fares/__private/__fragments/flights-fares-information.tsx
var fragment72 = gql81(_templateObject80(), EGDSCarousel.fragment, FareInformationCard.fragment, clientSideAnalyticsFragment);
var fightsFaresInformationSpacing = {
    padding: {
        inline: "six"
    }
};
var carouselItemsVisible = {
    lg: 3,
    md: 2,
    sm: 1
};
var headersSpacing = {
    margin: {
        blockstart: "two"
    }
};
var subHeadingSpacing = {
    margin: {
        blockstart: "one"
    }
};
var carouselSpacing = {
    margin: {
        block: "three"
    }
};
var FlightsFaresInformation = function(param) {
    var data = param.data, onFareApplied = param.onFareApplied, _param_highlightSponsored = param.highlightSponsored, highlightSponsored = _param_highlightSponsored === void 0 ? false : _param_highlightSponsored, filterPillComponent = param.filterPillComponent, headerSpacing = param.headerSpacing, isSmartShoppingExperience = param.isSmartShoppingExperience, isUpsellLoading = param.isUpsellLoading, availableFaresCount = param.availableFaresCount;
    var fareCardRef = useRef(null);
    var sponsoredUpsellAvailableAnalytics = data.sponsoredUpsellAvailableAnalytics;
    var _React81_useState = _sliced_to_array(React81.useState(false), 2), isSponsoredUpsellAvailableAnalyticsFired = _React81_useState[0], setSponsoredUpsellAvailableAnalyticsFired = _React81_useState[1];
    var clickstreamAnalytics = useClickstreamAnalytics7();
    useEffect3(function() {
        var _fareCardRef_current, _fareCardRef;
        (_fareCardRef = fareCardRef) === null || _fareCardRef === void 0 ? void 0 : (_fareCardRef_current = _fareCardRef.current) === null || _fareCardRef_current === void 0 ? void 0 : _fareCardRef_current.scrollIntoView();
    }, [
        fareCardRef
    ]);
    useEffect3(function() {
        if (sponsoredUpsellAvailableAnalytics && !isSponsoredUpsellAvailableAnalyticsFired) {
            setSponsoredUpsellAvailableAnalyticsFired(true);
            trackDisplayAnalyticsList(clickstreamAnalytics, [
                sponsoredUpsellAvailableAnalytics
            ]);
        }
    }, [
        clickstreamAnalytics,
        sponsoredUpsellAvailableAnalytics,
        isSponsoredUpsellAvailableAnalyticsFired
    ]);
    var findGoodValue = data.fares.some(function(sections) {
        var _sections;
        return (_sections = sections) === null || _sections === void 0 ? void 0 : _sections.featuredHeader;
    }) && headerSpacing;
    var findBadges = data.fares.some(function(sections) {
        var _sections;
        return (_sections = sections) === null || _sections === void 0 ? void 0 : _sections.heading.badge;
    }) && headerSpacing;
    var CarouselContent = React81.useMemo(function() {
        var carouselContentData = data.fares.map(function(fare, key) {
            return /* @__PURE__ */ React81.createElement(FareInformationCard, {
                data: fare,
                key: "fare-information-card-".concat(key),
                fareCardKey: key,
                highlightSponsored: highlightSponsored,
                onFareApplied: onFareApplied,
                fareCardRef: fareCardRef,
                goodValueAvailable: findGoodValue,
                badgesAvailable: findBadges,
                isSmartShoppingExperience: isSmartShoppingExperience
            });
        });
        if (isUpsellLoading) {
            _to_consumable_array(Array(availableFaresCount)).forEach(function(nullElem, index) {
                carouselContentData.push(/* @__PURE__ */ React81.createElement(FareTypeCardSkeleton, {
                    key: "fare-information-card-loading-".concat(index)
                }));
            });
        }
        return carouselContentData;
    }, [
        data,
        onFareApplied,
        highlightSponsored,
        isUpsellLoading,
        availableFaresCount
    ]);
    if (CarouselContent.length === 0) {
        return null;
    }
    var scrollTo = data.fares.findIndex(function(fare) {
        if (highlightSponsored) {
            return fare.sponsoredContent;
        }
        if (fare.highlighted) {
            return fare.highlighted;
        }
        return fare.featuredHeader;
    });
    return /* @__PURE__ */ React81.createElement(UitkSpacing23, {
        padding: fightsFaresInformationSpacing.padding
    }, /* @__PURE__ */ React81.createElement("div", null, data.heading && /* @__PURE__ */ React81.createElement(UitkSpacing23, {
        margin: headersSpacing.margin
    }, /* @__PURE__ */ React81.createElement(UitkHeading5, {
        tag: "h2"
    }, data.heading)), data.subheading && /* @__PURE__ */ React81.createElement(UitkSpacing23, {
        margin: subHeadingSpacing.margin
    }, /* @__PURE__ */ React81.createElement(UitkSubheading, null, data.subheading)), filterPillComponent && filterPillComponent, /* @__PURE__ */ React81.createElement(UitkSpacing23, {
        margin: carouselSpacing.margin
    }, /* @__PURE__ */ React81.createElement("div", {
        "data-test-id": "fare-types-carousel"
    }, /* @__PURE__ */ React81.createElement(EGDSCarousel, {
        attachItemsToSameSize: true,
        carouselName: "UpsellCarousel",
        content: CarouselContent,
        data: data.faresCarousel,
        itemsVisible: carouselItemsVisible,
        pageBy: 1,
        peek: true,
        wrapItems: false,
        analytics: data.scrollAnalytics[0],
        scrollTo: scrollTo
    })))));
};
FlightsFaresInformation.displayName = "FlightsFaresInformation";
FlightsFaresInformation.fragment = fragment72;
// ../internal/src/components/flights-details-and-fares/__private/__fragments/flights-hygiene-amenities-section.tsx
import React82 from "react";
import { gql as gql82 } from "@apollo/client";
import { UitkList as UitkList8, UitkListItem as UitkListItem7 } from "uitk-react-list";
import { UitkSpacing as UitkSpacing24, UitkSpacingHr as UitkSpacingHr2 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading6, UitkText as UitkText19 } from "uitk-react-text";
var fragment73 = gql82(_templateObject81(), EGDSIconText.fragment);
var footerSpacing = {
    margin: {
        blockstart: "four"
    }
};
var hygieneAmenitiesContentSpacing = {
    margin: {
        blockend: "four",
        inline: "four"
    },
    padding: {
        blockend: "three",
        inline: "three"
    }
};
var FlightsHygieneAmenities = function(param) {
    var data = param.data;
    if (data.amenities.length === 0) {
        return null;
    }
    return /* @__PURE__ */ React82.createElement(React82.Fragment, null, /* @__PURE__ */ React82.createElement(UitkSpacingHr2, {
        blockMargin: "six"
    }), /* @__PURE__ */ React82.createElement(UitkSpacing24, {
        padding: hygieneAmenitiesContentSpacing.padding,
        margin: hygieneAmenitiesContentSpacing.margin
    }, /* @__PURE__ */ React82.createElement("div", null, /* @__PURE__ */ React82.createElement(UitkSpacing24, null, /* @__PURE__ */ React82.createElement(UitkHeading6, {
        tag: "h2"
    }, data.header)), /* @__PURE__ */ React82.createElement(UitkList8, {
        bullet: "no-bullet"
    }, data.amenities.map(function(amenity, key) {
        return /* @__PURE__ */ React82.createElement(UitkListItem7, {
            key: "Hygiene-amenity-listitem-".concat(key)
        }, /* @__PURE__ */ React82.createElement(EGDSIconText, {
            data: amenity,
            inline: true
        }));
    })), /* @__PURE__ */ React82.createElement(UitkSpacing24, {
        margin: footerSpacing.margin
    }, /* @__PURE__ */ React82.createElement(UitkText19, null, data.footer)))));
};
FlightsHygieneAmenities.displayName = "FlightsHygieneAmenities";
FlightsHygieneAmenities.fragment = fragment73;
// ../internal/src/components/flights-details-and-fares/__private/__fragments/flights-journey-with-details.tsx
import React83 from "react";
import { gql as gql83 } from "@apollo/client";
import { UitkSpacing as UitkSpacing25, UitkSpacingHr as UitkSpacingHr3 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading7, UitkSubheading as UitkSubheading2 } from "uitk-react-text";
var fragment74 = gql83(_templateObject82(), EGDSText.fragment);
var flightsJourneyWithDetailsSpacing = {
    margin: {
        blockstart: "six",
        inline: "six"
    }
};
var detailsSpacing = {
    margin: {
        blockstart: "six"
    }
};
var FlightsJourneyWithDetails = function(param) {
    var data = param.data, index = param.index;
    return /* @__PURE__ */ React83.createElement(React83.Fragment, null, index > 0 && /* @__PURE__ */ React83.createElement(UitkSpacingHr3, null), /* @__PURE__ */ React83.createElement(UitkSpacing25, {
        margin: flightsJourneyWithDetailsSpacing.margin
    }, /* @__PURE__ */ React83.createElement("div", null, /* @__PURE__ */ React83.createElement(UitkHeading7, {
        size: 4
    }, data.header), /* @__PURE__ */ React83.createElement(UitkSubheading2, null, data.subheader), data.details.length > 0 && /* @__PURE__ */ React83.createElement(UitkSpacing25, {
        margin: detailsSpacing.margin
    }, /* @__PURE__ */ React83.createElement("div", null, data.details.map(function(detail, key) {
        return /* @__PURE__ */ React83.createElement(EGDSText, {
            data: detail,
            key: "journey-with-details-detail-".concat(key)
        });
    }))), data.footnotes.length > 0 && /* @__PURE__ */ React83.createElement(UitkSpacing25, {
        margin: detailsSpacing.margin
    }, /* @__PURE__ */ React83.createElement("div", null, data.footnotes.map(function(footnote, key) {
        return /* @__PURE__ */ React83.createElement(EGDSText, {
            data: footnote,
            key: "journey-with-details-footnote-".concat(key),
            textSize: 200
        });
    }))))));
};
FlightsJourneyWithDetails.displayName = "FlightsJourneyWithDetails";
FlightsJourneyWithDetails.fragment = fragment74;
// ../internal/src/components/flights-details-and-fares/__private/__fragments/flights-sustainability-card.tsx
import React84 from "react";
import { gql as gql84 } from "@apollo/client";
import { UitkCard as UitkCard6 } from "uitk-react-cards";
import { UitkLayoutFlex as UitkLayoutFlex18, UitkLayoutFlexItem as UitkLayoutFlexItem15 } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing26 } from "uitk-react-spacing";
var fragment75 = gql84(_templateObject83(), FlightsPhrase.fragment, Icon.fragment);
var sustainabilityCardSpacing = {
    margin: {
        block: "two",
        inline: "six"
    },
    padding: {
        block: "three"
    }
};
var textSpacing = {
    margin: {
        inlinestart: "two"
    }
};
var FlightsSustainabilityCard = function(param) {
    var data = param.data;
    var _data_cardContent = data.cardContent, icon = _data_cardContent.icon, text = _data_cardContent.text;
    if (text.length === 0) {
        return null;
    }
    return /* @__PURE__ */ React84.createElement(UitkSpacing26, {
        margin: sustainabilityCardSpacing.margin,
        padding: sustainabilityCardSpacing.padding
    }, /* @__PURE__ */ React84.createElement(UitkCard6, {
        padded: true,
        border: true
    }, /* @__PURE__ */ React84.createElement(UitkLayoutFlex18, {
        alignItems: "center"
    }, icon && /* @__PURE__ */ React84.createElement(UitkLayoutFlexItem15, null, /* @__PURE__ */ React84.createElement("div", {
        "data-stid": "sustainability-info-icon"
    }, /* @__PURE__ */ React84.createElement(Icon, {
        data: icon,
        spotlight: "info"
    }))), /* @__PURE__ */ React84.createElement(UitkSpacing26, {
        margin: textSpacing.margin
    }, /* @__PURE__ */ React84.createElement(UitkLayoutFlexItem15, null, /* @__PURE__ */ React84.createElement("div", null, text.map(function(info, index) {
        return /* @__PURE__ */ React84.createElement(FlightsPhrase, {
            key: "sustainability-info-".concat(index),
            data: info,
            size: 200
        });
    })))))));
};
FlightsSustainabilityCard.displayName = "FlightsSustainabilityCard";
FlightsSustainabilityCard.fragment = fragment75;
// ../internal/src/components/flights-details-and-fares/__private/__fragments/flights-journey-details-information.tsx
import React96 from "react";
import { gql as gql96 } from "@apollo/client";
import { UitkSpacing as UitkSpacing34 } from "uitk-react-spacing";
// ../internal/src/components/flights-journey-details/flights-journey-details.tsx
import React95 from "react";
import { gql as gql95 } from "@apollo/client";
import { UitkSpacing as UitkSpacing33, UitkSpacingHr as UitkSpacingHr4 } from "uitk-react-spacing";
// ../internal/src/components/flights-journey-details/_fragments/journey-amenities-with-label.tsx
import React86 from "react";
import { gql as gql87 } from "@apollo/client";
import { UitkSpacing as UitkSpacing28 } from "uitk-react-spacing";
// ../internal/src/components/flights-legacy-types/flights-icon-and-label.tsx
import React85 from "react";
import { gql as gql86 } from "@apollo/client";
import { useClickstreamAnalytics as useClickstreamAnalytics8 } from "@shared-ui/clickstream-analytics-context";
import { UitkSpacing as UitkSpacing27 } from "uitk-react-spacing";
import { UitkText as UitkText20 } from "uitk-react-text";
var _obj10;
// ../internal/src/components/common/uitk-text-theme-mapper.tsx
var UitkTextThemeMapper = (_obj10 = {}, _define_property(_obj10, "EMPHASIS" /* EMPHASIS */ , "emphasis"), _define_property(_obj10, "LOYALTY" /* LOYALTY */ , "loyalty"), _define_property(_obj10, "NEGATIVE" /* NEGATIVE */ , "negative"), _define_property(_obj10, "POSITIVE" /* POSITIVE */ , "positive"), _define_property(_obj10, "PRIMARY" /* PRIMARY */ , "emphasis"), _define_property(_obj10, "SECONDARY" /* SECONDARY */ , "default"), _define_property(_obj10, "INVERSE" /* INVERSE */ , "inverse"), _define_property(_obj10, "EMPHASIS" /* EMPHASIS */ , "emphasis"), _obj10);
// ../internal/src/components/flights-legacy-types/flights-analytics.ts
import { gql as gql85 } from "@apollo/client";
import { ITrackType as ITrackType2 } from "@shared-ui/clickstream-analytics-context";
var flightsAnalyticsFragment2 = gql85(_templateObject84());
var trackDisplayAnalytics = function(clickstreamAnalytics, analyticsList) {
    var track = clickstreamAnalytics.track;
    var messages = analyticsList.map(function(analytics) {
        var referrerId = analytics.referrerId, linkName = analytics.linkName;
        return {
            schemaName: "referrer",
            messageContent: {
                referrerId: referrerId,
                linkName: linkName,
                eventType: "impression"
            }
        };
    });
    track(ITrackType2.EVENT, {
        data: messages
    });
};
// ../internal/src/components/flights-legacy-types/flights-icon-and-label.tsx
var fragment76 = gql86(_templateObject85(), Icon.fragment, flightsAnalyticsFragment2, clientSideAnalyticsFragment, EGDSStylizedText.fragment);
var subTextSpacingProps = {
    padding: {
        inlinestart: "six",
        blockstart: "one"
    }
};
var FlightsIconAndLabel = function(param) {
    var data = param.data, inline = param.inline, size = param.size, iconSpacing5 = param.iconSpacing, iconAndLabelSpacing = param.iconAndLabelSpacing, spacing3 = param.spacing;
    var accessibility = data.accessibility, icon = data.icon, label = data.label, displayAnalytics = data.displayAnalytics, displayAnalyticsList = data.displayAnalyticsList, subText = data.subText;
    var _React85_useState = _sliced_to_array(React85.useState(false), 2), hasLogged = _React85_useState[0], setHasLogged = _React85_useState[1];
    var clickstreamAnalytics = useClickstreamAnalytics8();
    React85.useEffect(function() {
        if (!hasLogged) {
            var _displayAnalyticsList;
            if ((_displayAnalyticsList = displayAnalyticsList) === null || _displayAnalyticsList === void 0 ? void 0 : _displayAnalyticsList.length) {
                trackDisplayAnalyticsList(clickstreamAnalytics, displayAnalyticsList);
            } else if (displayAnalytics) {
                trackDisplayAnalytics(clickstreamAnalytics, displayAnalytics);
            }
            setHasLogged(true);
        }
    }, [
        displayAnalytics,
        clickstreamAnalytics,
        hasLogged,
        displayAnalyticsList
    ]);
    return /* @__PURE__ */ React85.createElement(React85.Fragment, null, /* @__PURE__ */ React85.createElement("span", {
        className: "is-visually-hidden"
    }, accessibility), /* @__PURE__ */ React85.createElement(UitkText20, _object_spread_props(_object_spread({
        size: size,
        spacing: spacing3
    }, iconAndLabelSpacing), {
        "aria-hidden": true,
        inline: inline
    }), /* @__PURE__ */ React85.createElement(UitkSpacing27, _object_spread({}, iconSpacing5), /* @__PURE__ */ React85.createElement("span", null, /* @__PURE__ */ React85.createElement(Icon, {
        data: icon
    }))), /* @__PURE__ */ React85.createElement(UitkText20, {
        theme: UitkTextThemeMapper[data.theme],
        inline: true
    }, label)), subText && /* @__PURE__ */ React85.createElement(UitkSpacing27, {
        padding: subTextSpacingProps.padding
    }, /* @__PURE__ */ React85.createElement(EGDSStylizedText, {
        data: subText
    })));
};
FlightsIconAndLabel.fragment = fragment76;
FlightsIconAndLabel.displayName = "FlightsIconAndLabel";
// ../internal/src/components/flights-journey-details/_fragments/journey-amenities-with-label.tsx
var fragment77 = gql87(_templateObject86(), FlightsIconAndLabel.fragment);
var iconAndLabelSpacingProps = {
    margin: {
        inlinestart: "two",
        inlineend: "two"
    }
};
var iconSpacingProps = {
    margin: {
        inlineend: "two"
    }
};
var spacingProps = {
    margin: {
        blockstart: "six",
        blockend: "three"
    },
    padding: {
        blockstart: "half"
    }
};
var JourneyAmenitiesWithLabel = function(param) {
    var data = param.data;
    var _journeyAmenities, _data_journeyAmenities;
    var journeyAmenities = data.journeyAmenities;
    if (!journeyAmenities || ((_journeyAmenities = journeyAmenities) === null || _journeyAmenities === void 0 ? void 0 : _journeyAmenities.length) === 0) {
        return null;
    }
    return /* @__PURE__ */ React86.createElement(UitkSpacing28, _object_spread({}, spacingProps), /* @__PURE__ */ React86.createElement("div", null, (_data_journeyAmenities = data.journeyAmenities) === null || _data_journeyAmenities === void 0 ? void 0 : _data_journeyAmenities.map(function(amenity, index) {
        return /* @__PURE__ */ React86.createElement(FlightsIconAndLabel, {
            data: amenity,
            key: index,
            spacing: "one",
            iconAndLabelSpacing: iconAndLabelSpacingProps,
            iconSpacing: iconSpacingProps
        });
    })));
};
JourneyAmenitiesWithLabel.displayName = "JourneyAmenitiesWithLabel";
JourneyAmenitiesWithLabel.fragment = fragment77;
// ../internal/src/components/flights-journey-details/_fragments/journey-details-badge.tsx
import React87 from "react";
import { gql as gql88 } from "@apollo/client";
import { UitkLayoutFlex as UitkLayoutFlex19, UitkLayoutFlexItem as UitkLayoutFlexItem16 } from "uitk-react-layout-flex";
var fragment78 = gql88(_templateObject87(), EGDSBadge.fragment, EGDSStandardLink.fragment);
var JourneyDetailsBadge = function(param) {
    var data = param.data;
    return /* @__PURE__ */ React87.createElement(UitkLayoutFlex19, {
        space: "two"
    }, /* @__PURE__ */ React87.createElement(UitkLayoutFlexItem16, null, /* @__PURE__ */ React87.createElement("div", null, /* @__PURE__ */ React87.createElement(EGDSBadge, {
        data: data.badge
    }))), data.link && /* @__PURE__ */ React87.createElement(UitkLayoutFlexItem16, {
        alignSelf: "center"
    }, /* @__PURE__ */ React87.createElement(EGDSStandardLink, {
        data: data.link
    })));
};
JourneyDetailsBadge.fragment = fragment78;
JourneyDetailsBadge.displayName = "JourneyDetailsBadge";
// ../internal/src/components/flights-journey-details/_fragments/journey-section.tsx
import React94 from "react";
import { gql as gql94 } from "@apollo/client";
import { UitkSpacing as UitkSpacing32 } from "uitk-react-spacing";
// ../internal/src/components/flights-journey-details/_fragments/additional-information.tsx
import React88 from "react";
import { gql as gql89 } from "@apollo/client";
import { UitkSpacing as UitkSpacing29 } from "uitk-react-spacing";
import { UitkText as UitkText21 } from "uitk-react-text";
var fragment79 = gql89(_templateObject88(), FlightsIconAndLabel.fragment);
var nextFlightOriginAirportInfoSpacingProps = {
    padding: {
        blockstart: "two"
    }
};
var nextFlightOriginAirportInfoIconAndLabelSpacingProps = {
    margin: {
        inlineend: "two",
        blockend: "one"
    }
};
var additionalInformationSpacingProps = {
    padding: {
        block: "three"
    },
    margin: {
        inlinestart: "six",
        blockstart: "six",
        blockend: "three"
    },
    border: [
        "blockstart",
        "blockend"
    ]
};
var nextFlightOriginAirportInfoIconSpacingProps = {
    margin: {
        inlineend: "one"
    }
};
var AdditionalInformation = function(param) {
    var journeyIndex = param.journeyIndex, data = param.data;
    return /* @__PURE__ */ React88.createElement(UitkSpacing29, _object_spread({}, additionalInformationSpacingProps), /* @__PURE__ */ React88.createElement("div", {
        "data-stid": "layover-info-".concat(journeyIndex)
    }, /* @__PURE__ */ React88.createElement(UitkText21, {
        size: 300
    }, data.durationAndStop), data.nextFlightOriginAirportInfo && /* @__PURE__ */ React88.createElement(UitkSpacing29, {
        padding: nextFlightOriginAirportInfoSpacingProps.padding
    }, /* @__PURE__ */ React88.createElement("div", null, /* @__PURE__ */ React88.createElement(FlightsIconAndLabel, {
        data: data.nextFlightOriginAirportInfo,
        size: 300,
        iconAndLabelSpacing: nextFlightOriginAirportInfoIconAndLabelSpacingProps,
        iconSpacing: nextFlightOriginAirportInfoIconSpacingProps
    })))));
};
AdditionalInformation.fragment = fragment79;
AdditionalInformation.displayName = "AdditionalInformation";
// ../internal/src/components/flights-journey-details/_fragments/flights-connection-information.tsx
import React93 from "react";
import { gql as gql93 } from "@apollo/client";
import { UitkLayoutFlex as UitkLayoutFlex21, UitkLayoutFlexItem as UitkLayoutFlexItem18 } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing31 } from "uitk-react-spacing";
import { UitkText as UitkText24 } from "uitk-react-text";
// ../internal/src/components/flights-journey-details/_fragments/coordinate-information.tsx
import React91 from "react";
import { gql as gql91 } from "@apollo/client";
import { UitkLayoutFlex as UitkLayoutFlex20, UitkLayoutFlexItem as UitkLayoutFlexItem17 } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing30 } from "uitk-react-spacing";
import { UitkText as UitkText23 } from "uitk-react-text";
// ../internal/src/components/flights-legacy-types/flights-message-and-accessibility.tsx
import React89 from "react";
import { gql as gql90 } from "@apollo/client";
var fragment80 = gql90(_templateObject89());
var FlightsMessageAndAccessibility = function(param) {
    var data = param.data;
    return /* @__PURE__ */ React89.createElement(React89.Fragment, null, /* @__PURE__ */ React89.createElement("span", {
        "aria-hidden": true
    }, data.text), /* @__PURE__ */ React89.createElement("span", {
        className: "is-visually-hidden"
    }, data.flightsMessageAndAccessibilityA11yMessage));
};
FlightsMessageAndAccessibility.fragment = fragment80;
FlightsMessageAndAccessibility.displayName = "FlightsMessageAndAccessibility";
// ../internal/src/components/flights-legacy-types/flights-message-and-accessibility-text.tsx
import React90 from "react";
import { UitkText as UitkText22 } from "uitk-react-text";
var FlightsMessageAndAccessibilityText = function(_param) /* @__PURE__ */ {
    var data = _param.data, textProps = _object_without_properties(_param, [
        "data"
    ]);
    return React90.createElement(UitkText22, _object_spread({}, textProps), /* @__PURE__ */ React90.createElement(FlightsMessageAndAccessibility, {
        data: data
    }));
};
// ../internal/src/components/flights-journey-details/_fragments/coordinate-information.tsx
var fragment81 = gql91(_templateObject90(), Icon.fragment, FlightsIconAndLabel.fragment, FlightsMessageAndAccessibility.fragment);
var subtitleContainerSpacingProps = {
    margin: {
        blockstart: "half"
    },
    padding: {
        inlinestart: "six"
    }
};
var iconBlockEndHalfSpacingProps = {
    padding: {
        blockend: "half",
        inlineend: "one"
    }
};
var warningMessageOuterSpacingProps = {
    padding: {
        inlinestart: "six",
        blockstart: "one"
    }
};
var warningMessageIconAndLabelSpacingProps = {
    margin: {
        inlineend: "two",
        blockend: "one"
    }
};
var warningMessageIconSpacingProps = {
    margin: {
        inlineend: "one"
    }
};
var CoordinateInformation = function(param) {
    var dataTestId = param.dataTestId, _param_data = param.data, icon = _param_data.icon, subtitle = _param_data.subtitle, titleAndAccessibilityMessage = _param_data.titleAndAccessibilityMessage, flightDetailsWarningInfo = _param_data.flightDetailsWarningInfo;
    return /* @__PURE__ */ React91.createElement(React91.Fragment, null, /* @__PURE__ */ React91.createElement("div", {
        "data-stid": dataTestId
    }, /* @__PURE__ */ React91.createElement(UitkText23, null, /* @__PURE__ */ React91.createElement(UitkLayoutFlex20, {
        alignItems: "end"
    }, /* @__PURE__ */ React91.createElement(UitkLayoutFlexItem17, null, /* @__PURE__ */ React91.createElement(UitkSpacing30, {
        padding: iconBlockEndHalfSpacingProps.padding
    }, /* @__PURE__ */ React91.createElement("div", null, /* @__PURE__ */ React91.createElement(Icon, {
        data: icon
    })))), /* @__PURE__ */ React91.createElement(UitkLayoutFlexItem17, null, /* @__PURE__ */ React91.createElement("span", null, /* @__PURE__ */ React91.createElement(FlightsMessageAndAccessibilityText, {
        data: titleAndAccessibilityMessage,
        size: 300
    }))))), /* @__PURE__ */ React91.createElement(UitkSpacing30, {
        margin: subtitleContainerSpacingProps.margin,
        padding: subtitleContainerSpacingProps.padding
    }, /* @__PURE__ */ React91.createElement(UitkText23, {
        size: 300,
        inline: true
    }, subtitle)), flightDetailsWarningInfo && /* @__PURE__ */ React91.createElement(UitkLayoutFlexItem17, null, /* @__PURE__ */ React91.createElement(UitkSpacing30, {
        padding: warningMessageOuterSpacingProps.padding
    }, /* @__PURE__ */ React91.createElement("div", null, /* @__PURE__ */ React91.createElement(FlightsIconAndLabel, {
        data: flightDetailsWarningInfo,
        iconAndLabelSpacing: warningMessageIconAndLabelSpacingProps,
        iconSpacing: warningMessageIconSpacingProps,
        size: 300,
        inline: true
    }))))));
};
CoordinateInformation.fragment = fragment81;
CoordinateInformation.displayName = "CoordinateInformation";
// ../internal/src/components/flights-journey-details/_fragments/journey-amenities.tsx
import React92 from "react";
import { gql as gql92 } from "@apollo/client";
var fragment82 = gql92(_templateObject91(), FlightsIconAndLabel.fragment);
var iconAndLabelSpacingProps2 = {
    margin: {
        inlineend: "two"
    }
};
var iconSpacingProps2 = {
    margin: {
        inlineend: "one"
    }
};
var JourneyAmenities = function(param) {
    var data = param.data;
    return /* @__PURE__ */ React92.createElement(React92.Fragment, null, data.amenities.map(function(amenity, index) {
        return /* @__PURE__ */ React92.createElement(FlightsIconAndLabel, {
            data: amenity,
            key: index,
            iconAndLabelSpacing: iconAndLabelSpacingProps2,
            iconSpacing: iconSpacingProps2,
            inline: true
        });
    }), data.journeyAmenitiesA11yMessage && /* @__PURE__ */ React92.createElement("div", {
        className: "is-visually-hidden"
    }, data.journeyAmenitiesA11yMessage));
};
JourneyAmenities.fragment = fragment82;
JourneyAmenities.displayName = "JourneyAmenitiesFragment";
// ../internal/src/components/flights-journey-details/_fragments/flights-connection-information.tsx
var fragment83 = gql93(_templateObject92(), CoordinateInformation.fragment, JourneyAmenities.fragment);
var mainSpacingProps = {
    padding: {
        block: "six",
        inlinestart: "six"
    }
};
var aircraftModelSpacingProps = {
    margin: {
        inlineend: "three"
    }
};
var FlightsConnectionInformation = function(param) {
    var journeyIndex = param.journeyIndex, flightsConnection = param.data.flightsConnection;
    return /* @__PURE__ */ React93.createElement(React93.Fragment, null, /* @__PURE__ */ React93.createElement(CoordinateInformation, {
        data: flightsConnection.connectionDeparture,
        dataTestId: "departure-coordinate-".concat(journeyIndex)
    }), /* @__PURE__ */ React93.createElement(UitkSpacing31, {
        padding: mainSpacingProps.padding
    }, /* @__PURE__ */ React93.createElement(UitkLayoutFlex21, {
        direction: "column",
        space: "two",
        dataTestId: "additional-info-".concat(journeyIndex)
    }, /* @__PURE__ */ React93.createElement(UitkLayoutFlexItem18, null, /* @__PURE__ */ React93.createElement(UitkText24, {
        size: 300,
        inline: true
    }, flightsConnection.duration)), /* @__PURE__ */ React93.createElement(UitkLayoutFlexItem18, null, /* @__PURE__ */ React93.createElement(UitkText24, {
        size: 300,
        inline: true
    }, flightsConnection.airlineInfo)), (flightsConnection.aircraftModel || flightsConnection.journeyAmenities) && /* @__PURE__ */ React93.createElement(UitkLayoutFlexItem18, null, /* @__PURE__ */ React93.createElement("div", null, flightsConnection.aircraftModel && /* @__PURE__ */ React93.createElement(UitkSpacing31, {
        margin: aircraftModelSpacingProps.margin
    }, /* @__PURE__ */ React93.createElement(UitkText24, {
        size: 300,
        inline: true
    }, flightsConnection.aircraftModel)), flightsConnection.journeyAmenities && /* @__PURE__ */ React93.createElement(JourneyAmenities, {
        data: flightsConnection.journeyAmenities
    }))), /* @__PURE__ */ React93.createElement(UitkLayoutFlexItem18, null, /* @__PURE__ */ React93.createElement(UitkText24, {
        size: 300,
        inline: true
    }, flightsConnection.cabinClassAndBookingCode)))), /* @__PURE__ */ React93.createElement(CoordinateInformation, {
        data: flightsConnection.connectionArrival,
        dataTestId: "arrival-coordinate-".concat(journeyIndex)
    }));
};
FlightsConnectionInformation.fragment = fragment83;
FlightsConnectionInformation.displayName = "FlightsConnectionInformation";
// ../internal/src/components/flights-journey-details/_fragments/journey-section.tsx
var fragment84 = gql94(_templateObject93(), FlightsConnectionInformation.fragment, AdditionalInformation.fragment);
var mainSpacingProps2 = {
    padding: {
        inlineend: "one"
    },
    margin: {
        blockstart: "three"
    }
};
var JourneySection = function(param) {
    var journeyIndex = param.journeyIndex, data = param.data;
    return /* @__PURE__ */ React94.createElement(React94.Fragment, null, /* @__PURE__ */ React94.createElement(UitkSpacing32, _object_spread({}, mainSpacingProps2), /* @__PURE__ */ React94.createElement("div", {
        "data-test-id": "journey-part-".concat(journeyIndex)
    }, data.journeyConnectionInformation.map(function(connectionInfo) {
        switch(connectionInfo.__typename){
            case "FlightsConnectionInformation":
                return /* @__PURE__ */ React94.createElement(FlightsConnectionInformation, {
                    data: connectionInfo,
                    key: "connectionInfo-".concat(journeyIndex),
                    journeyIndex: journeyIndex
                });
            case "AdditionalInformation":
                return /* @__PURE__ */ React94.createElement(AdditionalInformation, {
                    data: connectionInfo,
                    key: "additionalInfo-".concat(journeyIndex),
                    journeyIndex: journeyIndex
                });
            default:
                return null;
        }
    }))));
};
JourneySection.fragment = fragment84;
JourneySection.displayName = "JourneySection";
// ../internal/src/components/flights-journey-details/flights-journey-details.tsx
var fragment85 = gql95(_templateObject94(), JourneySection.fragment, JourneyAmenitiesWithLabel.fragment, JourneyDetailsBadge.fragment);
var FlightsJourneyDetails = function(param) {
    var data = param.data;
    var _data_journeyAmenities;
    return /* @__PURE__ */ React95.createElement(React95.Fragment, null, data.journeySections.map(function(item, index) {
        return /* @__PURE__ */ React95.createElement(JourneySection, {
            key: index,
            data: item,
            journeyIndex: index
        });
    }), /* @__PURE__ */ React95.createElement(JourneyAmenitiesWithLabel, {
        data: data
    }), data.badge && /* @__PURE__ */ React95.createElement(UitkSpacing33, {
        padding: {
            inlinestart: "six"
        },
        margin: {
            blockstart: "three"
        }
    }, /* @__PURE__ */ React95.createElement("div", null, /* @__PURE__ */ React95.createElement(JourneyDetailsBadge, {
        data: data.badge
    }))), ((_data_journeyAmenities = data.journeyAmenities) === null || _data_journeyAmenities === void 0 ? void 0 : _data_journeyAmenities.length) && data.journeyAmenities ? /* @__PURE__ */ React95.createElement(UitkSpacingHr4, {
        blockMargin: "six"
    }) : null);
};
FlightsJourneyDetails.displayName = "FlightsJourneyDetails";
FlightsJourneyDetails.fragment = fragment85;
// ../internal/src/components/flights-details-and-fares/__private/__fragments/flights-journey-details-information.tsx
var fragment86 = gql96(_templateObject95(), EGDSExpando.fragment, FlightsJourneyDetails.fragment);
var journeyDetailsSpacing = {
    margin: {
        inlinestart: "six"
    }
};
var FlightsJourneyDetailsInformation = function(param) {
    var data = param.data;
    var content = data.content, expando = data.expando;
    if (content.length === 0) {
        return null;
    }
    return /* @__PURE__ */ React96.createElement("div", {
        "data-test-id": "show-details-link"
    }, /* @__PURE__ */ React96.createElement(UitkSpacing34, {
        margin: journeyDetailsSpacing.margin
    }, /* @__PURE__ */ React96.createElement(EGDSExpando, {
        data: expando
    }, content.map(function(item, index) {
        return /* @__PURE__ */ React96.createElement(UitkSpacing34, {
            key: "flights-journey-information-content-".concat(index)
        }, /* @__PURE__ */ React96.createElement("div", null, /* @__PURE__ */ React96.createElement(FlightsJourneyDetails, {
            data: item,
            key: "flights-journey-details-".concat(index)
        })));
    }))));
};
FlightsJourneyDetailsInformation.displayName = "FlightsJourneyDetailsInformation";
FlightsJourneyDetailsInformation.fragment = fragment86;
// ../internal/src/components/flights-details-and-fares/__private/__fragments/flights-messaging-card.tsx
import React98 from "react";
import { gql as gql98 } from "@apollo/client";
import { useClickstreamAnalytics as useClickstreamAnalytics9 } from "@shared-ui/clickstream-analytics-context";
import { UitkSpacing as UitkSpacing36 } from "uitk-react-spacing";
// ../internal/src/components/egds-standard-messaging-card/egds-standard-messaging-card.tsx
import React97, { useMemo as useMemo2 } from "react";
import { gql as gql97 } from "@apollo/client";
import { UitkCard as UitkCard7, UitkCardContentSection as UitkCardContentSection3 } from "uitk-react-cards";
import { UitkLayoutFlex as UitkLayoutFlex22, UitkLayoutFlexItem as UitkLayoutFlexItem19 } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing35 } from "uitk-react-spacing";
import { UitkText as UitkText25 } from "uitk-react-text";
var fragment87 = gql97(_templateObject96(), UiGraphic.fragment, EGDSStandardLink.fragment);
var messagingCardSpacing = {
    margin: {
        block: "two",
        inline: "six"
    },
    padding: {
        blockstart: "two"
    }
};
var linkSpacing = {
    margin: {
        block: "two"
    }
};
var EGDSStandardMessagingCard = function(param) {
    var _param_data = param.data, message = _param_data.message, links = _param_data.links, graphic = _param_data.graphic;
    var renderEGDSLinks = useMemo2(function() {
        var _links;
        return /* @__PURE__ */ React97.createElement(React97.Fragment, null, (_links = links) === null || _links === void 0 ? void 0 : _links.map(function(linkData, linkIndex) {
            return /* @__PURE__ */ React97.createElement(UitkSpacing35, {
                margin: linkSpacing.margin,
                key: linkIndex
            }, /* @__PURE__ */ React97.createElement("div", null, /* @__PURE__ */ React97.createElement(EGDSStandardLink, {
                data: linkData
            })));
        }));
    }, [
        links
    ]);
    return /* @__PURE__ */ React97.createElement(UitkSpacing35, {
        padding: messagingCardSpacing.padding
    }, /* @__PURE__ */ React97.createElement(UitkCard7, {
        border: true
    }, /* @__PURE__ */ React97.createElement(UitkLayoutFlex22, {
        alignItems: "center"
    }, graphic && /* @__PURE__ */ React97.createElement(UitkLayoutFlexItem19, null, /* @__PURE__ */ React97.createElement(UitkCardContentSection3, null, /* @__PURE__ */ React97.createElement(UiGraphic, {
        data: graphic
    }))), /* @__PURE__ */ React97.createElement(UitkLayoutFlexItem19, {
        grow: 1
    }, /* @__PURE__ */ React97.createElement(UitkCardContentSection3, {
        padded: false
    }, /* @__PURE__ */ React97.createElement(UitkLayoutFlex22, {
        direction: "column"
    }, /* @__PURE__ */ React97.createElement(UitkLayoutFlexItem19, null, /* @__PURE__ */ React97.createElement(UitkText25, null, message)), /* @__PURE__ */ React97.createElement(UitkLayoutFlexItem19, null, renderEGDSLinks)))))));
};
EGDSStandardMessagingCard.displayName = "EGDSStandardMessagingCard";
EGDSStandardMessagingCard.fragment = fragment87;
// ../internal/src/components/flights-details-and-fares/__private/__fragments/flights-messaging-card.tsx
var fragment88 = gql98(_templateObject97(), EGDSStandardMessagingCard.fragment, clientSideAnalyticsFragment);
var messagingCardSpacing2 = {
    margin: {
        blockstart: "six",
        blockend: "four",
        inline: "six"
    }
};
var FlightsMessagingCard = function(param) {
    var data = param.data;
    var clickstreamAnalytics = useClickstreamAnalytics9();
    var displayAnalytics = data.displayAnalytics, cardContent = data.cardContent;
    React98.useEffect(function() {
        if (displayAnalytics) {
            trackDisplayAnalyticsList(clickstreamAnalytics, displayAnalytics);
        }
    }, [
        clickstreamAnalytics,
        displayAnalytics
    ]);
    return /* @__PURE__ */ React98.createElement(UitkSpacing36, {
        margin: messagingCardSpacing2.margin
    }, /* @__PURE__ */ React98.createElement("div", null, /* @__PURE__ */ React98.createElement(EGDSStandardMessagingCard, {
        data: cardContent
    })));
};
FlightsMessagingCard.displayName = "FlightsMessagingCard";
FlightsMessagingCard.fragment = fragment88;
// ../internal/src/components/flights-details-and-fares/__private/dialogs/price-match-promise-dialog.tsx
import React99 from "react";
import { UitkLayoutFlex as UitkLayoutFlex23, UitkLayoutFlexItem as UitkLayoutFlexItem20 } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing37 } from "uitk-react-spacing";
var pmpInfoDialogProps = {
    headingSize: 4,
    headingTag: "h3",
    textAlign: "center",
    spacing: {
        margin: {
            blockend: "six"
        }
    },
    flexLayout: {
        direction: "column",
        alignItems: "center"
    }
};
var PMPFlightDialogContent = function(param) {
    var dialog = param.dialog;
    return /* @__PURE__ */ React99.createElement(React99.Fragment, null, dialog.dialogContent && /* @__PURE__ */ React99.createElement(UitkLayoutFlex23, {
        direction: pmpInfoDialogProps.flexLayout.direction,
        alignItems: pmpInfoDialogProps.flexLayout.alignItems
    }, dialog.dialogContent.map(function(element, key) {
        return /* @__PURE__ */ React99.createElement(UitkSpacing37, {
            key: key,
            margin: pmpInfoDialogProps.spacing.margin
        }, /* @__PURE__ */ React99.createElement(UitkLayoutFlexItem20, {
            alignSelf: element.__typename === "EGDSParagraph" ? "start" : void 0
        }, /* @__PURE__ */ React99.createElement("div", null, /* @__PURE__ */ React99.createElement(EGDSElement, {
            data: element,
            headingSize: pmpInfoDialogProps.headingSize,
            headingTag: pmpInfoDialogProps.headingTag,
            textAlign: pmpInfoDialogProps.textAlign
        }))));
    })));
};
var PriceMatchPromiseDialog = function(param) {
    var dialog = param.dialog;
    return /* @__PURE__ */ React99.createElement(FlightsDialog, {
        data: dialog,
        isNested: true,
        content: /* @__PURE__ */ React99.createElement(PMPFlightDialogContent, {
            dialog: dialog
        })
    });
};
// ../internal/src/components/flights-details-and-fares/__private/flights-details-and-fares-content.tsx
var fragment89 = gql99(_templateObject98(), FlightsDialog.fragment, FlightsJourneyHeader.fragment, FlightsJourneyDetailsInformation.fragment, FlightsJourneyWithDetails.fragment, FlightsHygieneAmenities.fragment, TextWrapper.fragment, FlightsFaresInformation.fragment, FlightsSustainabilityCard.fragment, FlightsMessagingCard.fragment);
var textWrapperSpacing = {
    padding: {
        blockend: "two",
        inline: "six"
    }
};
var FlightsDetailsAndFaresContent = function(param) {
    var data = param.data, onFareApplied = param.onFareApplied, size = param.size, _param_highlightSponsored = param.highlightSponsored, highlightSponsored = _param_highlightSponsored === void 0 ? false : _param_highlightSponsored, filterPillComponent = param.filterPillComponent, headerSpacing = param.headerSpacing, isSmartShoppingExperience = param.isSmartShoppingExperience, isUpsellLoading = param.isUpsellLoading, availableFaresCount = param.availableFaresCount;
    var _data_priceMatchPromiseNestedDialogs, _data_nestedDialogs;
    var _data_dynamicDialogId;
    var dialogId = (_data_dynamicDialogId = data.dynamicDialogId) !== null && _data_dynamicDialogId !== void 0 ? _data_dynamicDialogId : data.dialogId;
    var _useDialog5 = _sliced_to_array(useDialog5(dialogId), 2), dialogsActions = _useDialog5[1];
    var onFareAppliedWrapper = React100.useCallback(function(clientAction) {
        if (clientAction.__typename === "FlightsBoundNavigation") {
            onFareApplied(clientAction);
        } else {
            dialogsActions.closeDialog();
            onFareApplied(clientAction);
        }
    }, [
        onFareApplied,
        dialogsActions
    ]);
    return /* @__PURE__ */ React100.createElement("div", {
        "data-stid": "flights-journey-available-fares"
    }, /* @__PURE__ */ React100.createElement("div", {
        "data-stid": "flights-details-and-fares",
        "data-test-id": "details-and-fares"
    }, (_data_priceMatchPromiseNestedDialogs = data.priceMatchPromiseNestedDialogs) === null || _data_priceMatchPromiseNestedDialogs === void 0 ? void 0 : _data_priceMatchPromiseNestedDialogs.map(function(dialog, key) {
        return /* @__PURE__ */ React100.createElement(PriceMatchPromiseDialog, {
            dialog: dialog,
            key: "details-and-fares-pmp-nested-dialog-".concat(key)
        });
    }), (_data_nestedDialogs = data.nestedDialogs) === null || _data_nestedDialogs === void 0 ? void 0 : _data_nestedDialogs.map(function(dialog, key) {
        switch(dialog.dialogId){
            case "PMP_INFO_DIALOG":
                return /* @__PURE__ */ React100.createElement(PriceMatchPromiseDialog, {
                    dialog: dialog,
                    key: "details-and-fares-pmp-nested-dialog-".concat(key)
                });
            default:
                return /* @__PURE__ */ React100.createElement(FlightsDialog, {
                    data: dialog,
                    key: "details-and-fares-nested-dialog-".concat(key),
                    isNested: true
                });
        }
    }), data.sections.map(function(section, index) {
        switch(section.__typename){
            case "FlightsJourneyHeaderInformation":
                return /* @__PURE__ */ React100.createElement(FlightsJourneyHeader, {
                    data: section,
                    size: size,
                    key: "flights-details-and-fares-content-".concat(index)
                });
            case "FlightsJourneyDetailsInformation":
                return /* @__PURE__ */ React100.createElement(FlightsJourneyDetailsInformation, {
                    data: section,
                    key: "flights-journey-with-details-".concat(index)
                });
            case "FlightsJourneyWithDetails":
                return /* @__PURE__ */ React100.createElement(FlightsJourneyWithDetails, {
                    data: section,
                    key: "flights-journey-with-details-".concat(index),
                    index: index
                });
            case "FlightsFaresInformation":
                return /* @__PURE__ */ React100.createElement(FlightsFaresInformation, {
                    data: section,
                    key: "flights-fares-information-section-".concat(index),
                    onFareApplied: onFareAppliedWrapper,
                    highlightSponsored: highlightSponsored,
                    filterPillComponent: filterPillComponent,
                    headerSpacing: headerSpacing,
                    isSmartShoppingExperience: isSmartShoppingExperience,
                    isUpsellLoading: isUpsellLoading,
                    availableFaresCount: availableFaresCount
                });
            case "FlightsHygieneAmenitiesSection":
                return /* @__PURE__ */ React100.createElement(FlightsHygieneAmenities, {
                    data: section,
                    key: "flights-hygiene-amenity-section-".concat(index)
                });
            case "FlightsSustainabilityCard":
                return /* @__PURE__ */ React100.createElement(FlightsSustainabilityCard, {
                    data: section,
                    key: "flights-sustainability-card-section-".concat(index)
                });
            case "FlightsMessagingCard":
                return /* @__PURE__ */ React100.createElement(FlightsMessagingCard, {
                    data: section,
                    key: "flights-messaging-card-section-".concat(index)
                });
            case "TextWrapper":
                return /* @__PURE__ */ React100.createElement(TextWrapper, {
                    data: section,
                    inline: true,
                    key: "flights-baggage-information-section-".concat(index),
                    spacing: textWrapperSpacing
                });
            default:
                return null;
        }
    })));
};
FlightsDetailsAndFaresContent.fragment = fragment89;
FlightsDetailsAndFaresContent.displayName = "FlightsDetailsAndFaresContent";
// ../internal/src/components/flights-details-and-fares/__private/flights-details-and-fares-footer.tsx
import React101 from "react";
import { gql as gql100 } from "@apollo/client";
import { useDialog as useDialog6 } from "@shared-ui/dialog-context";
import { UitkLayoutFlex as UitkLayoutFlex24, UitkLayoutFlexItem as UitkLayoutFlexItem21 } from "uitk-react-layout-flex";
import { UitkPriceLockupAlign as UitkPriceLockupAlign4 } from "uitk-react-price-lockup";
import { UitkSpacing as UitkSpacing38 } from "uitk-react-spacing";
var fragment90 = gql100(_templateObject99(), EGDSPriceLockup.fragment, FlightsActionButton.fragment);
var mainSpacingProps3 = {
    padding: "six"
};
var FlightsDetailsAndFaresFooter = function(param) {
    var data = param.data, onFareApplied = param.onFareApplied;
    var _data_dynamicDialogId;
    var dialogId = (_data_dynamicDialogId = data.dynamicDialogId) !== null && _data_dynamicDialogId !== void 0 ? _data_dynamicDialogId : data.dialogId;
    var _useDialog6 = _sliced_to_array(useDialog6(dialogId), 2), dialogActions = _useDialog6[1];
    var actionCallback = React101.useCallback(function(clientAction) {
        dialogActions.closeDialog();
        onFareApplied(clientAction);
    }, [
        onFareApplied,
        dialogActions
    ]);
    return /* @__PURE__ */ React101.createElement(UitkSpacing38, {
        padding: mainSpacingProps3.padding
    }, /* @__PURE__ */ React101.createElement(UitkLayoutFlex24, {
        justifyContent: "space-between"
    }, /* @__PURE__ */ React101.createElement(UitkLayoutFlexItem21, null, /* @__PURE__ */ React101.createElement(EGDSPriceLockup, {
        data: data.priceLockup,
        align: UitkPriceLockupAlign4.LEFT
    })), /* @__PURE__ */ React101.createElement(UitkLayoutFlexItem21, null, /* @__PURE__ */ React101.createElement(UitkSpacing38, {
        margin: mainSpacingProps3.margin
    }, /* @__PURE__ */ React101.createElement(FlightsActionButton, {
        data: data.action,
        callback: actionCallback
    })))));
};
FlightsDetailsAndFaresFooter.fragment = fragment90;
FlightsDetailsAndFaresFooter.displayName = "FlightsDetailsAndFaresFooter";
// ../internal/src/components/flights-smart-shopping-offer-card/flights-smart-shopping-offer-card.tsx
import React107 from "react";
import { gql as gql107 } from "@apollo/client";
import { useClickstreamAnalytics as useClickstreamAnalytics11 } from "@shared-ui/clickstream-analytics-context";
import { useBeaconsWrapper, useClickBeaconWrapper } from "@shared-ui/retail-sponsored-content-use-beacons-wrapper";
import { ViewLarge as ViewLarge3, Viewport as Viewport3, ViewSmall as ViewSmall3 } from "@shared-ui/viewport-context";
import { UitkCardContentSection as UitkCardContentSection4, UitkCardFeaturedHeader as UitkCardFeaturedHeader2, UitkCardLink } from "uitk-react-cards";
import { UitkLayoutFlex as UitkLayoutFlex26, UitkLayoutFlexItem as UitkLayoutFlexItem23 } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing40 } from "uitk-react-spacing";
// ../internal/src/components/flights-experience-dialog-trigger/flights-experience-dialog-trigger.tsx
import React103 from "react";
import { gql as gql102 } from "@apollo/client";
import { useDialog as useDialog7 } from "@shared-ui/dialog-context";
// ../internal/src/components/flights-experience-action-button/flights-experience-action-button.tsx
import React102 from "react";
import { gql as gql101 } from "@apollo/client";
import { useClickstreamAnalytics as useClickstreamAnalytics10 } from "@shared-ui/clickstream-analytics-context";
import { UitkPrimaryButton as UitkPrimaryButton2, UitkSecondaryButton as UitkSecondaryButton2, UitkTertiaryButton as UitkTertiaryButton2 } from "uitk-react-button";
import { Level as Level2, liveAnnounce as liveAnnounce3 } from "uitk-react-utils";
var fragment91 = gql101(_templateObject100(), clientActionFragment, Icon.fragment, clientSideAnalyticsFragment);
var FlightsExperienceActionButton = function(param) {
    var ButtonWrapper = param.ButtonWrapper, callback = param.callback, dataStid = param.dataStid, data = param.data, disabled = param.disabled, isFullWidth = param.isFullWidth, size = param.size, className = param.className, domRef = param.domRef;
    var Button = UitkPrimaryButton2;
    if (data.buttonStyle === "SECONDARY" /* SECONDARY */ ) {
        Button = UitkSecondaryButton2;
    } else if (data.buttonStyle === "TERTIARY" /* TERTIARY */ ) {
        Button = UitkTertiaryButton2;
    }
    var clickstreamAnalytics = useClickstreamAnalytics10();
    var clientAction = data.clientAction;
    var handleClick = React102.useCallback(function() {
        var _clientAction_analyticsList, _callback;
        if (clientAction.__typename !== "FlightsClickAction" && clientAction.__typename !== "FlightsSelectionAction" && clientAction.__typename !== "FlightsResourceLinkAction") {
            return null;
        }
        if ((_clientAction_analyticsList = clientAction.analyticsList) === null || _clientAction_analyticsList === void 0 ? void 0 : _clientAction_analyticsList.length) {
            trackAnalyticsList(clickstreamAnalytics, clientAction.analyticsList);
        }
        setTimeout(function() {
            if (clientAction.accessibility) {
                liveAnnounce3(clientAction.accessibility, Level2.POLITE);
            }
        }, 100);
        (_callback = callback) === null || _callback === void 0 ? void 0 : _callback(clientAction);
    }, [
        data.clientAction,
        callback,
        clickstreamAnalytics
    ]);
    var isDisabled = disabled !== void 0 ? disabled : data.disabled;
    var primary = data.primary, icon = data.icon;
    React102.useEffect(function() {
        if (data.analytics) {
            trackDisplayAnalyticsList(clickstreamAnalytics, [
                data.analytics
            ]);
        }
    }, [
        clickstreamAnalytics,
        data.analytics
    ]);
    if (ButtonWrapper) {
        return /* @__PURE__ */ React102.createElement(ButtonWrapper, null, /* @__PURE__ */ React102.createElement("button", {
            disabled: isDisabled,
            type: "button",
            onClick: handleClick,
            "data-stid": dataStid,
            className: className
        }, data.primary));
    }
    return /* @__PURE__ */ React102.createElement(Button, {
        disabled: isDisabled,
        onClick: handleClick,
        isFullWidth: isFullWidth,
        "data-stid": dataStid,
        size: size,
        className: className,
        domRef: domRef
    }, icon && /* @__PURE__ */ React102.createElement(Icon, {
        data: icon
    }), primary);
};
FlightsExperienceActionButton.displayName = "FlightsExperienceActionButton";
FlightsExperienceActionButton.fragment = fragment91;
// ../internal/src/components/flights-experience-dialog-trigger/flights-experience-dialog-trigger.tsx
var fragment92 = gql102(_templateObject101(), FlightsExperienceActionButton.fragment);
var FlightsExperienceDialogTrigger = function(param) {
    var className = param.className, data = param.data, isNested = param.isNested, onClick = param.onClick, Wrapper = param.Wrapper, isFullWidth = param.isFullWidth;
    var nestedDialogKey = isNested ? "pwaDialogNested" : void 0;
    var _data_dynamicDialogId;
    var dialogId = (_data_dynamicDialogId = data.dynamicDialogId) !== null && _data_dynamicDialogId !== void 0 ? _data_dynamicDialogId : data.dialogId;
    var _useDialog7 = _sliced_to_array(useDialog7(dialogId, nestedDialogKey), 2), isOpen = _useDialog7[0], dialogActions = _useDialog7[1];
    var onTriggerClicked = React103.useCallback(function(clientAction) {
        var _clientAction, _onClick;
        (_onClick = onClick) === null || _onClick === void 0 ? void 0 : _onClick((_clientAction = clientAction) === null || _clientAction === void 0 ? void 0 : _clientAction.value);
        if (data.dialogAction === "OPEN" /* OPEN */ ) {
            if (!isOpen) {
                dialogActions.openDialog();
            } else {
                dialogActions.closeDialog({
                    closeAllDialogs: true
                });
                setTimeout(dialogActions.openDialog, 10);
            }
        } else {
            dialogActions.closeDialog();
        }
    }, [
        dialogActions,
        data.dialogAction,
        onClick,
        isOpen
    ]);
    var dataStid = "".concat(dialogId, "-").concat(data.trigger.__typename);
    return /* @__PURE__ */ React103.createElement(React103.Fragment, null, data.trigger.__typename === "FlightsExperienceActionButton" && /* @__PURE__ */ React103.createElement(FlightsExperienceActionButton, {
        data: data.trigger,
        callback: onTriggerClicked,
        className: className,
        ButtonWrapper: Wrapper,
        isFullWidth: isFullWidth,
        dataStid: dataStid
    }));
};
FlightsExperienceDialogTrigger.displayName = "FlightsExperienceDialogTrigger";
FlightsExperienceDialogTrigger.fragment = fragment92;
// ../internal/src/components/flights-smart-shopping-price-summary/flights-smart-shopping-price-summary.tsx
import React104 from "react";
import { gql as gql103 } from "@apollo/client";
import { ViewLarge as ViewLarge2, Viewport as Viewport2, ViewSmall as ViewSmall2 } from "@shared-ui/viewport-context";
import { UitkLayoutFlex as UitkLayoutFlex25, UitkLayoutFlexItem as UitkLayoutFlexItem22 } from "uitk-react-layout-flex";
import { UitkLayoutGrid as UitkLayoutGrid2, UitkLayoutGridItem as UitkLayoutGridItem2 } from "uitk-react-layout-grid";
import { UitkSpacing as UitkSpacing39 } from "uitk-react-spacing";
var fragment93 = gql103(_templateObject102(), EGDSSpannableText.fragment);
var creditAppliedSpacingProps = {
    margin: {
        blockstart: "half"
    }
};
var FlightsSmartShoppingPriceSummary = function(param) {
    var data = param.data, hideAddonSection = param.hideAddonSection;
    var price = data.price, leadingPrice = data.leadingPrice, primaryText = data.primaryText, secondaryText = data.secondaryText;
    var _React104_useState = _sliced_to_array(React104.useState(leadingPrice), 2), leadingContent = _React104_useState[0], setLeadingContent = _React104_useState[1];
    var abovePrimaryText = React104.useMemo(function() {
        var _primaryText;
        return (_primaryText = primaryText) === null || _primaryText === void 0 ? void 0 : _primaryText.map(function(item, index) {
            return /* @__PURE__ */ React104.createElement(UitkLayoutFlexItem22, {
                maxWidth: "full_width",
                key: "aboveTextLayout-".concat(index),
                alignSelf: "end"
            }, /* @__PURE__ */ React104.createElement(EGDSSpannableText, {
                data: item,
                size: 200
            }));
        });
    }, [
        primaryText
    ]);
    var belowSecondaryText = React104.useMemo(function() {
        var _secondaryText;
        return (_secondaryText = secondaryText) === null || _secondaryText === void 0 ? void 0 : _secondaryText.map(function(item, index) {
            return /* @__PURE__ */ React104.createElement(UitkLayoutFlexItem22, {
                key: "belowTextLayout-".concat(index),
                alignSelf: "end"
            }, /* @__PURE__ */ React104.createElement(UitkSpacing39, {
                margin: index > 0 ? creditAppliedSpacingProps.margin : void 0
            }, /* @__PURE__ */ React104.createElement(EGDSSpannableText, {
                align: "right",
                data: item
            })));
        });
    }, [
        secondaryText
    ]);
    React104.useEffect(function() {
        if (hideAddonSection && leadingPrice) {
            setLeadingContent(_object_spread_props(_object_spread({}, leadingPrice), {
                inlineContent: leadingPrice.inlineContent.filter(function(element) {
                    return element.__typename !== "EGDSGraphicText";
                })
            }));
        }
    }, [
        hideAddonSection,
        leadingPrice
    ]);
    return /* @__PURE__ */ React104.createElement(UitkLayoutGrid2, null, /* @__PURE__ */ React104.createElement(UitkLayoutGridItem2, null, /* @__PURE__ */ React104.createElement(UitkLayoutFlex25, {
        justifyContent: "end",
        space: "twelve"
    }, /* @__PURE__ */ React104.createElement(UitkLayoutFlexItem22, null, /* @__PURE__ */ React104.createElement(UitkLayoutFlex25, {
        direction: "column",
        alignContent: "end",
        alignItems: "end"
    }, abovePrimaryText, /* @__PURE__ */ React104.createElement(UitkLayoutFlexItem22, {
        alignSelf: "end"
    }, /* @__PURE__ */ React104.createElement(UitkLayoutFlex25, {
        alignItems: "center",
        justifyContent: "end",
        space: "two",
        wrap: "wrap"
    }, /* @__PURE__ */ React104.createElement(Viewport2, null, /* @__PURE__ */ React104.createElement(ViewSmall2, null, /* @__PURE__ */ React104.createElement("div", null, leadingContent && /* @__PURE__ */ React104.createElement(EGDSSpannableText, {
        data: leadingContent
    }))), /* @__PURE__ */ React104.createElement(ViewLarge2, null)), /* @__PURE__ */ React104.createElement(UitkLayoutFlexItem22, {
        alignSelf: "end"
    }, /* @__PURE__ */ React104.createElement(EGDSSpannableText, {
        data: price
    })))), belowSecondaryText)))));
};
FlightsSmartShoppingPriceSummary.fragment = fragment93;
FlightsSmartShoppingPriceSummary.displayName = "FlightsSmartShoppingPriceSummary";
// ../internal/src/components/flights-smart-shopping-offer-card/__private/__fragments/flights-smart-shopping-tertiary-section.tsx
import React106 from "react";
import { gql as gql106 } from "@apollo/client";
// ../internal/src/components/flights-smart-shopping-offer-card/__private/__fragments/flights-duration-timeline.tsx
import React105 from "react";
import { gql as gql105 } from "@apollo/client";
import { UitkExperimentalTimeline } from "uitk-react-experimental-timeline";
// ../internal/src/components/flights-smart-shopping-offer-card/__private/__fragments/duration-timeline-side-section.ts
import { gql as gql104 } from "@apollo/client";
var DurationTimelineSideSectionFragment = gql104(_templateObject103());
// ../internal/src/components/flights-smart-shopping-offer-card/__private/__fragments/flights-duration-timeline.tsx
var fragment94 = gql105(_templateObject104(), DurationTimelineSideSectionFragment);
var FlightsDurationTimeline = function(param) {
    var data = param.data;
    return /* @__PURE__ */ React105.createElement(UitkExperimentalTimeline, {
        start: data.start,
        end: data.end,
        primary: data.primary,
        secondary: data.secondary,
        marks: data.stops
    });
};
FlightsDurationTimeline.fragment = fragment94;
FlightsDurationTimeline.displayName = "FlightCardDurationTimeline";
// ../internal/src/components/flights-smart-shopping-offer-card/__private/__fragments/flights-smart-shopping-tertiary-section.tsx
var fragment95 = gql106(_templateObject105(), EGDSTextSection.fragment, EGDSGraphicText.fragment, FlightsDurationTimeline.fragment);
var FlightsSmartShoppingTertiarySection = function(param) {
    var data = param.data;
    switch(data.__typename){
        case "FlightCardDurationTimeline":
            return /* @__PURE__ */ React106.createElement(FlightsDurationTimeline, {
                data: data
            });
        case "EGDSGraphicText":
            return /* @__PURE__ */ React106.createElement(EGDSGraphicText, {
                data: data,
                size: 100,
                textOnTop: true
            });
        case "EGDSTextSection":
            return /* @__PURE__ */ React106.createElement(EGDSTextSection, {
                data: data,
                textSize: 100
            });
        default:
            return null;
    }
};
FlightsSmartShoppingTertiarySection.fragment = fragment95;
FlightsSmartShoppingTertiarySection.displayName = "FlightsSmartShoppingTertiarySection";
// ../internal/src/components/flights-smart-shopping-offer-card/flights-smart-shopping-offer-card.tsx
var fragment96 = gql107(_templateObject106(), EGDSBadge.fragment, EGDSTextSection.fragment, FlightsSmartShoppingPriceSummary.fragment, FlightsSmartShoppingTertiarySection.fragment, FlightsExperienceDialogTrigger.fragment, clientSideAnalyticsFragment);
var operatedBySpacingProps = {
    margin: {
        blockstart: "half"
    }
};
var headerSpacingProps = {
    padding: {
        inlineend: "two"
    }
};
var timelineSpacingProps = {
    margin: {
        inlinestart: "six",
        inlineend: "six"
    }
};
var priceSpacingProps = {
    margin: {
        inlinestart: "six"
    }
};
var addonsSpacingProps = {
    margin: {
        inlinestart: "three",
        inlineend: "three",
        blockstart: "six"
    }
};
var badgesSpacingProps = {
    margin: {
        blockend: "two"
    }
};
var offerCardSpacing = {
    padding: {
        inline: "three",
        block: "six"
    },
    border: [
        "blockend"
    ]
};
var SmallViewOffer = function(param) {
    var data = param.data, onClick = param.onClick;
    var _secondaryBadges;
    var offerDialogTrigger = data.offerDialogTrigger, content = data.content;
    var primarySection = content.primarySection, priceSection = content.priceSection, tertiarySection = content.tertiarySection, badges = content.badges, secondaryBadges = content.secondaryBadges;
    if (!priceSection) {
        return null;
    }
    return /* @__PURE__ */ React107.createElement(UitkSpacing40, {
        padding: offerCardSpacing.padding
    }, /* @__PURE__ */ React107.createElement(UitkCardContentSection4, {
        border: "bottom"
    }, /* @__PURE__ */ React107.createElement(UitkCardLink, null, /* @__PURE__ */ React107.createElement(FlightsExperienceDialogTrigger, {
        data: offerDialogTrigger,
        onClick: onClick,
        Wrapper: UitkCardLink
    })), /* @__PURE__ */ React107.createElement(UitkLayoutFlex26, {
        justifyContent: "space-between"
    }, /* @__PURE__ */ React107.createElement(UitkLayoutFlexItem23, {
        maxWidth: "half_width"
    }, /* @__PURE__ */ React107.createElement(UitkLayoutFlex26, {
        space: "three",
        direction: "column",
        wrap: "wrap"
    }, badges && badges.length > 0 && /* @__PURE__ */ React107.createElement(UitkLayoutFlexItem23, null, /* @__PURE__ */ React107.createElement(UitkLayoutFlex26, {
        wrap: "wrap",
        space: "two",
        "data-stid": "flights-badges"
    }, badges.map(function(badgeInfo, badgeIndex) {
        return /* @__PURE__ */ React107.createElement(EGDSBadge, {
            data: badgeInfo,
            key: badgeIndex
        });
    }))), primarySection.length > 0 && /* @__PURE__ */ React107.createElement(UitkLayoutFlexItem23, {
        maxWidth: "full_width"
    }, /* @__PURE__ */ React107.createElement(UitkLayoutFlex26, {
        space: "half",
        alignItems: "start",
        wrap: "wrap",
        "data-stid": "primary-section"
    }, primarySection.map(function(primaryInfo, primaryIndex) {
        return /* @__PURE__ */ React107.createElement(EGDSTextSection, {
            data: primaryInfo,
            key: primaryIndex,
            contentOverflow: "truncate",
            headingPadding: headerSpacingProps.padding,
            headingSize: 7
        });
    }))))), /* @__PURE__ */ React107.createElement(UitkLayoutFlexItem23, {
        maxWidth: "half_width"
    }, /* @__PURE__ */ React107.createElement(UitkLayoutFlex26, {
        direction: "column"
    }, /* @__PURE__ */ React107.createElement(UitkLayoutFlexItem23, {
        alignSelf: "end"
    }, /* @__PURE__ */ React107.createElement(UitkSpacing40, {
        margin: badgesSpacingProps.margin,
        stid: "secondary-badges"
    }, /* @__PURE__ */ React107.createElement("div", null, (_secondaryBadges = secondaryBadges) === null || _secondaryBadges === void 0 ? void 0 : _secondaryBadges.map(function(badgeInfo, badgeIndex) {
        return /* @__PURE__ */ React107.createElement(EGDSBadge, {
            data: badgeInfo,
            key: badgeIndex,
            size: badgeInfo.size ? UitkBadgeSizeMapper[badgeInfo.size] : void 0
        });
    })))), /* @__PURE__ */ React107.createElement(UitkLayoutFlexItem23, null, /* @__PURE__ */ React107.createElement(FlightsSmartShoppingPriceSummary, {
        data: priceSection
    }))))), tertiarySection.length > 0 && /* @__PURE__ */ React107.createElement(UitkLayoutFlexItem23, {
        alignSelf: "stretch"
    }, /* @__PURE__ */ React107.createElement("div", {
        "data-stid": "tertiary-section"
    }, /* @__PURE__ */ React107.createElement(FlightsSmartShoppingTertiarySection, {
        data: tertiarySection[0]
    })))));
};
var LargeViewOffer = function(param) {
    var data = param.data, onClick = param.onClick;
    var _badges, _secondaryBadges;
    var offerDialogTrigger = data.offerDialogTrigger, content = data.content;
    var primarySection = content.primarySection, priceSection = content.priceSection, tertiarySection = content.tertiarySection, badges = content.badges, secondaryBadges = content.secondaryBadges;
    if (!priceSection) {
        return null;
    }
    return /* @__PURE__ */ React107.createElement(UitkSpacing40, {
        padding: offerCardSpacing.padding
    }, /* @__PURE__ */ React107.createElement(UitkCardContentSection4, {
        border: "bottom"
    }, /* @__PURE__ */ React107.createElement(UitkCardLink, null, /* @__PURE__ */ React107.createElement(FlightsExperienceDialogTrigger, {
        data: offerDialogTrigger,
        onClick: onClick,
        Wrapper: UitkCardLink
    })), /* @__PURE__ */ React107.createElement(UitkLayoutFlex26, {
        alignItems: "center"
    }, /* @__PURE__ */ React107.createElement(UitkLayoutFlexItem23, {
        grow: 1
    }, /* @__PURE__ */ React107.createElement(UitkLayoutFlex26, {
        direction: "column",
        wrap: "wrap"
    }, badges && ((_badges = badges) === null || _badges === void 0 ? void 0 : _badges.length) > 0 && /* @__PURE__ */ React107.createElement(UitkLayoutFlexItem23, null, /* @__PURE__ */ React107.createElement(UitkLayoutFlex26, {
        space: "two",
        "data-stid": "flights-badges"
    }, /* @__PURE__ */ React107.createElement(UitkSpacing40, {
        margin: badgesSpacingProps.margin
    }, /* @__PURE__ */ React107.createElement("div", null, badges.map(function(badgeInfo, badgeIndex) {
        return /* @__PURE__ */ React107.createElement(EGDSBadge, {
            data: badgeInfo,
            key: badgeIndex
        });
    }))))), /* @__PURE__ */ React107.createElement(UitkLayoutFlexItem23, {
        maxWidth: "full_width"
    }, /* @__PURE__ */ React107.createElement(UitkLayoutFlex26, {
        justifyContent: "space-between"
    }, primarySection.length > 0 && /* @__PURE__ */ React107.createElement(UitkLayoutFlexItem23, {
        maxWidth: "full_width"
    }, /* @__PURE__ */ React107.createElement(UitkLayoutFlex26, {
        direction: "column",
        alignItems: "start",
        "data-stid": "primary-section"
    }, primarySection.map(function(primaryInfo, primaryIndex) {
        return /* @__PURE__ */ React107.createElement(UitkLayoutFlexItem23, {
            key: primaryIndex
        }, /* @__PURE__ */ React107.createElement(UitkLayoutFlex26, {
            direction: "row",
            alignItems: "start"
        }, /* @__PURE__ */ React107.createElement(EGDSTextSection, {
            data: primaryInfo,
            key: primaryIndex,
            contentOverflow: "truncate",
            headingSize: 7,
            headingPadding: headerSpacingProps.padding,
            contentMargin: operatedBySpacingProps.margin
        })));
    }))))), /* @__PURE__ */ React107.createElement(UitkLayoutFlex26, null, tertiarySection.length > 0 && /* @__PURE__ */ React107.createElement(UitkLayoutFlexItem23, {
        grow: 1,
        alignSelf: "stretch"
    }, /* @__PURE__ */ React107.createElement(UitkSpacing40, {
        margin: timelineSpacingProps.margin,
        stid: "tertiary-section"
    }, /* @__PURE__ */ React107.createElement("div", null, /* @__PURE__ */ React107.createElement(FlightsSmartShoppingTertiarySection, {
        data: tertiarySection[0]
    }))))))), /* @__PURE__ */ React107.createElement(UitkLayoutFlexItem23, {
        grow: 0
    }, /* @__PURE__ */ React107.createElement(UitkLayoutFlex26, {
        direction: "column"
    }, /* @__PURE__ */ React107.createElement(UitkLayoutFlexItem23, {
        alignSelf: "end"
    }, /* @__PURE__ */ React107.createElement(UitkSpacing40, {
        margin: badgesSpacingProps.margin,
        stid: "secondary-badges"
    }, /* @__PURE__ */ React107.createElement("div", null, (_secondaryBadges = secondaryBadges) === null || _secondaryBadges === void 0 ? void 0 : _secondaryBadges.map(function(badgeInfo, badgeIndex) {
        return /* @__PURE__ */ React107.createElement(EGDSBadge, {
            data: badgeInfo,
            key: badgeIndex,
            size: badgeInfo.size ? UitkBadgeSizeMapper[badgeInfo.size] : void 0
        });
    })))), /* @__PURE__ */ React107.createElement(UitkLayoutFlexItem23, null, /* @__PURE__ */ React107.createElement(UitkLayoutFlex26, null, /* @__PURE__ */ React107.createElement(UitkSpacing40, {
        margin: addonsSpacingProps.margin,
        stid: "tertiary-section"
    }, /* @__PURE__ */ React107.createElement("div", {
        "data-stid": "add-ons-section"
    }, tertiarySection.length > 1 && /* @__PURE__ */ React107.createElement(FlightsSmartShoppingTertiarySection, {
        data: tertiarySection[1]
    }))), /* @__PURE__ */ React107.createElement(UitkSpacing40, {
        margin: priceSpacingProps.margin
    }, /* @__PURE__ */ React107.createElement("div", null, /* @__PURE__ */ React107.createElement(FlightsSmartShoppingPriceSummary, {
        hideAddonSection: true,
        data: priceSection
    }))))))))));
};
var FlightsSmartShoppingOfferCard = function(param) {
    var data = param.data, onTriggerClick = param.onTriggerClick, onOfferSelect = param.onOfferSelect;
    var _featuredHeader;
    var featuredHeader = data.featuredHeader, journeyContinuationId = data.journeyContinuationId, sanitizedOfferToken = data.sanitizedOfferToken, sponsoredListingBeacons = data.sponsoredListingBeacons, onDisplayAnalyticsList = data.onDisplayAnalyticsList;
    useBeaconsWrapper(sponsoredListingBeacons);
    var trackAnalytics = useClickstreamAnalytics11();
    React107.useEffect(function() {
        if (onDisplayAnalyticsList) {
            trackDisplayAnalyticsList(trackAnalytics, onDisplayAnalyticsList);
        }
    }, [
        trackAnalytics,
        onDisplayAnalyticsList
    ]);
    var fireClickBeaconWrapper = useClickBeaconWrapper();
    var onFSLClick = React107.useCallback(function() {
        var _sponsoredListingBeacons_clickBeacons, _sponsoredListingBeacons;
        (_sponsoredListingBeacons = sponsoredListingBeacons) === null || _sponsoredListingBeacons === void 0 ? void 0 : (_sponsoredListingBeacons_clickBeacons = _sponsoredListingBeacons.clickBeacons) === null || _sponsoredListingBeacons_clickBeacons === void 0 ? void 0 : _sponsoredListingBeacons_clickBeacons.forEach(function(url) {
            fireClickBeaconWrapper(url);
        });
    }, []);
    var handleOnClick = React107.useCallback(function(jcid) {
        var _onTriggerClick;
        (_onTriggerClick = onTriggerClick) === null || _onTriggerClick === void 0 ? void 0 : _onTriggerClick(jcid);
        onFSLClick();
        if (sanitizedOfferToken) {
            var _onOfferSelect;
            (_onOfferSelect = onOfferSelect) === null || _onOfferSelect === void 0 ? void 0 : _onOfferSelect(sanitizedOfferToken, false);
        }
    }, [
        onOfferSelect,
        onTriggerClick,
        sanitizedOfferToken
    ]);
    return /* @__PURE__ */ React107.createElement("li", {
        "data-test-id": "offer-listing",
        id: journeyContinuationId
    }, ((_featuredHeader = featuredHeader) === null || _featuredHeader === void 0 ? void 0 : _featuredHeader.heading) && /* @__PURE__ */ React107.createElement(UitkCardFeaturedHeader2, {
        title: {
            tag: "h3",
            text: featuredHeader.heading
        }
    }), /* @__PURE__ */ React107.createElement(Viewport3, null, /* @__PURE__ */ React107.createElement(ViewSmall3, null, /* @__PURE__ */ React107.createElement(SmallViewOffer, {
        data: data,
        onClick: handleOnClick
    })), /* @__PURE__ */ React107.createElement(ViewLarge3, null, /* @__PURE__ */ React107.createElement(LargeViewOffer, {
        data: data,
        onClick: handleOnClick
    }))));
};
FlightsSmartShoppingOfferCard.fragment = fragment96;
FlightsSmartShoppingOfferCard.displayName = "FlightsSmartShoppingOfferCard";
// src/components/smart-shopping-listings/__private/__fragments/flight-smart-shopping-loaded-listings.tsx
import { UitkCard as UitkCard8 } from "uitk-react-cards";
import { UitkToast } from "uitk-react-toast";
import { liveAnnounce as liveAnnounce4 } from "uitk-react-utils";
// src/components/smart-shopping-listings/__private/__fragments/details-and-fares/utils/parse-inputs.ts
var parseTravelerType = function(travelerType) {
    switch(travelerType){
        case "ADULT" /* ADULT */ :
            return "ADULT" /* ADULT */ ;
        case "CHILD" /* CHILD */ :
            return "CHILD" /* CHILD */ ;
        case "INFANT_IN_LAP" /* INFANT_IN_LAP */ :
            return "INFANT_IN_LAP" /* INFANT_IN_LAP */ ;
        case "INFANT_IN_SEAT" /* INFANT_IN_SEAT */ :
            return "INFANT_IN_SEAT" /* INFANT_IN_SEAT */ ;
        default:
            return "ADULT" /* ADULT */ ;
    }
};
var getTravelerDetails = function(travelerDetails) {
    var travelers = [];
    travelerDetails.forEach(function(traveler) {
        travelers.push({
            count: traveler.count,
            ages: traveler.ages,
            travelerType: parseTravelerType(traveler.travelerType)
        });
    });
    return travelers;
};
var getDetailsAndFaresInputs = function(listingsInputs, selectedJcid, selectedFilters, addOnRequested) {
    return {
        journeyCriteria: _to_consumable_array(listingsInputs.journeyCriteria),
        searchPreferences: listingsInputs.searchPreferences ? _object_spread({}, listingsInputs.searchPreferences) : null,
        shoppingContext: listingsInputs.shoppingContext ? _object_spread({}, listingsInputs.shoppingContext) : null,
        travelerDetails: getTravelerDetails(listingsInputs.travelerDetails),
        searchFilterValuesList: _to_consumable_array(selectedFilters),
        sortOption: listingsInputs.sortOption ? _object_spread({}, listingsInputs.sortOption) : null,
        flightsSearchContext: _object_spread({}, listingsInputs.flightsSearchContext),
        queryState: "LOADED" /* LOADED */ ,
        sideSheetQueryContext: {
            addOnRequested: _to_consumable_array(addOnRequested),
            isFirstLoad: false,
            journeyContinuationId: selectedJcid
        }
    };
};
// src/components/smart-shopping-listings/__private/__fragments/details-and-fares/utils/handle-filters-click.ts
var isFilterApplied = function(filter, filtersList) {
    if (!filtersList || filtersList.length === 0) {
        return false;
    }
    var filterApplied = false;
    if (filter === "SEAT_CHOICE" /* SEAT_CHOICE */ ) {
        filtersList.forEach(function(filterItem) {
            if (filterItem.seatChoiceBasedFilterValue) {
                filterApplied = true;
            }
        });
    } else if (filter === "CHECKED_BAG" /* CHECKED_BAG */ ) {
        filtersList.forEach(function(filterItem) {
            if (filterItem.checkedBagBasedFilterValue) {
                filterApplied = true;
            }
        });
    } else if (filter === "CARRY_ON_BAG" /* CARRY_ON_BAG */ ) {
        filtersList.forEach(function(filterItem) {
            if (filterItem.carryOnBagBasedFilterValue) {
                filterApplied = true;
            }
        });
    }
    return filterApplied;
};
var getFilter = function(filter) {
    if (filter === "SEAT_CHOICE" /* SEAT_CHOICE */ ) {
        return {
            seatChoiceBasedFilterValue: {
                seatChoice: "SEAT_CHOICE" /* SEAT_CHOICE */ 
            }
        };
    }
    if (filter === "CARRY_ON_BAG" /* CARRY_ON_BAG */ ) {
        return {
            carryOnBagBasedFilterValue: {
                carryOnBag: "CARRY_ON_BAG" /* CARRY_ON_BAG */ 
            }
        };
    }
    if (filter === "CHECKED_BAG" /* CHECKED_BAG */ ) {
        return {
            checkedBagBasedFilterValue: {
                numOfCheckedBags: 1
            }
        };
    }
    return null;
};
var getFilterType = function(value) {
    if (value === "SEAT_CHOICE" /* SEAT_CHOICE */ ) {
        return "SEAT_CHOICE" /* SEAT_CHOICE */ ;
    }
    if (value === "CARRY_ON_BAG" /* CARRY_ON_BAG */ ) {
        return "CARRY_ON_BAG" /* CARRY_ON_BAG */ ;
    }
    return "CHECKED_BAG" /* CHECKED_BAG */ ;
};
var parseFilterItem = function(field, event) {
    var filterType = getFilterType(event.target.value);
    return {
        filterInput: getFilter(filterType),
        type: filterType,
        operation: event.target.checked ? "ADD" : "REMOVE"
    };
};
var handleFilterSelection = function(inputs, filterItem, filter, operation) {
    var isApplied = isFilterApplied(filter, inputs.searchFilterValuesList);
    if (operation === "ADD" && !isApplied) {
        if (inputs.searchFilterValuesList) {
            inputs.searchFilterValuesList.push(filterItem);
            return _to_consumable_array(inputs.searchFilterValuesList);
        }
        return [
            filterItem
        ];
    }
    if (operation === "REMOVE" && isApplied) {
        var _inputs_searchFilterValuesList;
        var filters = (_inputs_searchFilterValuesList = inputs.searchFilterValuesList) === null || _inputs_searchFilterValuesList === void 0 ? void 0 : _inputs_searchFilterValuesList.filter(function(currentFilterItem) {
            if (filter === "SEAT_CHOICE" /* SEAT_CHOICE */  && currentFilterItem.seatChoiceBasedFilterValue) {
                return false;
            }
            if (filter === "CARRY_ON_BAG" /* CARRY_ON_BAG */  && currentFilterItem.carryOnBagBasedFilterValue) {
                return false;
            }
            if (filter === "CHECKED_BAG" /* CHECKED_BAG */  && currentFilterItem.checkedBagBasedFilterValue) {
                return false;
            }
            return true;
        });
        return filters ? _to_consumable_array(filters) : [];
    }
    var _inputs_searchFilterValuesList1;
    return (_inputs_searchFilterValuesList1 = inputs.searchFilterValuesList) !== null && _inputs_searchFilterValuesList1 !== void 0 ? _inputs_searchFilterValuesList1 : [];
};
var getAddOnRequestedFromFiltersSelected = function(filters) {
    var addOns = [];
    filters.forEach(function(filter) {
        var filterKey = Object.keys(filter)[0];
        switch(filterKey){
            case "seatChoiceBasedFilterValue":
                addOns.push("SC" /* SC */ );
                break;
            case "carryOnBagBasedFilterValue":
                addOns.push("COB" /* COB */ );
                break;
            case "checkedBagBasedFilterValue":
                addOns.push("CB1" /* CB1 */ );
                break;
            default:
        }
    });
    return addOns;
};
// src/components/smart-shopping-listings/__private/utils/flights-smart-shopping-loaded-listings-reducer.ts
var loadedListingsReducer = function(state, action) {
    switch(action.type){
        case "setSelectedJcid":
            return _object_spread_props(_object_spread({}, state), {
                selectedJcid: action.selectedJcid,
                flightSearchFilterValuesList: action.flightSearchFilterValuesList,
                addOnRequested: getAddOnRequestedFromFiltersSelected(action.flightSearchFilterValuesList),
                renderToast: action.renderToast
            });
        case "setSelectedFilters":
            return _object_spread_props(_object_spread({}, state), {
                flightSearchFilterValuesList: action.flightSearchFilterValuesList,
                addOnRequested: getAddOnRequestedFromFiltersSelected(action.flightSearchFilterValuesList),
                renderToast: action.renderToast
            });
        default:
            return state;
    }
};
// src/components/smart-shopping-listings/__private/__fragments/__fragments/flights-experience-bargain-fare-offer.tsx
import React108 from "react";
import { gql as gql108 } from "@apollo/client";
import { useHeadingLevelContext } from "@shared-ui/heading-level-context";
import { UitkCardContentSection as UitkCardContentSection5, UitkCardLink as UitkCardLink2 } from "uitk-react-cards";
import { UitkLayoutFlex as UitkLayoutFlex27, UitkLayoutFlexItem as UitkLayoutFlexItem24 } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing41 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading8, UitkText as UitkText26 } from "uitk-react-text";
var __Fragment = gql108(_templateObject107(), FlightsSmartShoppingPriceSummary.fragment, FlightsExperienceDialogTrigger.fragment);
var headingSpacingProps = {
    margin: {
        blockend: "one"
    }
};
var FlightsExperienceBargainFareOffer = function(param) {
    var data = param.data, onTriggerClick = param.onTriggerClick, onOfferSelect = param.onOfferSelect;
    var headingLevel = useHeadingLevelContext(1).headingLevel;
    var offerDialogTrigger = data.offerDialogTrigger, sanitizedOfferToken = data.sanitizedOfferToken;
    var handleOnClick = React108.useCallback(function(jcid) {
        var _onTriggerClick;
        (_onTriggerClick = onTriggerClick) === null || _onTriggerClick === void 0 ? void 0 : _onTriggerClick(jcid);
        if (sanitizedOfferToken) {
            var _onOfferSelect;
            (_onOfferSelect = onOfferSelect) === null || _onOfferSelect === void 0 ? void 0 : _onOfferSelect(sanitizedOfferToken, true);
        }
    }, [
        onOfferSelect,
        onTriggerClick,
        sanitizedOfferToken
    ]);
    return /* @__PURE__ */ React108.createElement(UitkCardContentSection5, {
        border: "bottom"
    }, /* @__PURE__ */ React108.createElement(UitkCardLink2, null, /* @__PURE__ */ React108.createElement(FlightsExperienceDialogTrigger, {
        data: offerDialogTrigger,
        onClick: handleOnClick,
        Wrapper: UitkCardLink2
    })), /* @__PURE__ */ React108.createElement(UitkLayoutFlex27, {
        space: "three"
    }, /* @__PURE__ */ React108.createElement(UitkLayoutFlexItem24, {
        grow: 1
    }, /* @__PURE__ */ React108.createElement(UitkLayoutFlex27, null, /* @__PURE__ */ React108.createElement(UitkLayoutFlexItem24, null, /* @__PURE__ */ React108.createElement("div", null, /* @__PURE__ */ React108.createElement(UitkSpacing41, {
        margin: headingSpacingProps.margin
    }, /* @__PURE__ */ React108.createElement(UitkHeading8, {
        tag: headingLevel !== null && headingLevel !== void 0 ? headingLevel : "h2",
        size: 6,
        align: "left"
    }, data.header)), /* @__PURE__ */ React108.createElement(UitkText26, {
        size: 200
    }, data.description))))), data.bargainPricingInformation.price.text && /* @__PURE__ */ React108.createElement(UitkLayoutFlexItem24, {
        shrink: 0,
        maxWidth: "third_width"
    }, /* @__PURE__ */ React108.createElement("div", null, /* @__PURE__ */ React108.createElement(FlightsSmartShoppingPriceSummary, {
        data: data.bargainPricingInformation
    })))));
};
FlightsExperienceBargainFareOffer.displayName = "FlightsExperienceBargainFareOffer";
FlightsExperienceBargainFareOffer.fragment = __Fragment;
// src/components/smart-shopping-listings/__private/__fragments/details-and-fares/flights-details-and-fares.tsx
import React111, { useCallback, useEffect as useEffect4, useMemo as useMemo3 } from "react";
import { gql as gql110, useQuery } from "@apollo/client";
import { useBexApi } from "@shared-ui/bex-api-context";
// ../internal/src/components/failed-request-messaging/failed-request-messaging.tsx
import React109 from "react";
import { gql as gql109 } from "@apollo/client";
import { UitkPrimaryButton as UitkPrimaryButton3 } from "uitk-react-button";
import { UitkLayoutFlex as UitkLayoutFlex28 } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing42 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading9, UitkText as UitkText27 } from "uitk-react-text";
var fragment97 = gql109(_templateObject108(), Icon.fragment);
var mainSpacingProps4 = {
    margin: {
        block: "twelve"
    },
    padding: {
        block: "twelve",
        inline: "four"
    }
};
var iconSpacingProps3 = {
    margin: {
        blockend: "four"
    }
};
var headingSpacingProps2 = {
    margin: {
        blockend: "two"
    }
};
var bodySpacingProps = {
    margin: {
        blockend: "three"
    }
};
var actionSpacingProps = {
    margin: {
        blockstart: "six"
    }
};
var FailedRequestMessaging = function(param) {
    var data = param.data, onRetry = param.onRetry;
    return /* @__PURE__ */ React109.createElement(UitkSpacing42, {
        margin: mainSpacingProps4.margin,
        padding: mainSpacingProps4.padding
    }, /* @__PURE__ */ React109.createElement(UitkLayoutFlex28, {
        direction: "column",
        alignItems: "center"
    }, /* @__PURE__ */ React109.createElement(UitkSpacing42, {
        margin: iconSpacingProps3.margin
    }, /* @__PURE__ */ React109.createElement(Icon, {
        data: data.icon
    })), /* @__PURE__ */ React109.createElement(UitkSpacing42, {
        margin: headingSpacingProps2.margin
    }, /* @__PURE__ */ React109.createElement(UitkHeading9, {
        size: 5,
        align: "center"
    }, data.title)), /* @__PURE__ */ React109.createElement(UitkSpacing42, {
        margin: bodySpacingProps.margin
    }, /* @__PURE__ */ React109.createElement(UitkText27, {
        align: "center"
    }, data.message)), /* @__PURE__ */ React109.createElement(UitkSpacing42, {
        margin: actionSpacingProps.margin
    }, /* @__PURE__ */ React109.createElement(UitkPrimaryButton3, {
        onClick: onRetry
    }, data.action.displayAction))));
};
FailedRequestMessaging.displayName = "FailedRequestMessaging";
FailedRequestMessaging.fragment = fragment97;
// ../internal/src/components/flights-loading-skeletons/flights-loading-skeletons.tsx
import React110 from "react";
import { UitkLineSkeleton as UitkLineSkeleton3 } from "uitk-react-skeleton";
import { UitkSpacing as UitkSpacing43 } from "uitk-react-spacing";
var FlightsLoadingSkeletons = function(param) {
    var isSmartShoppingFlightCard = param.isSmartShoppingFlightCard;
    var spacingSkeletons = !isSmartShoppingFlightCard ? {
        blockstart: "six",
        inlinestart: "six"
    } : {
        block: "six"
    };
    return /* @__PURE__ */ React110.createElement(UitkSpacing43, {
        margin: spacingSkeletons
    }, /* @__PURE__ */ React110.createElement("div", {
        "data-stid": "loading-skeletons"
    }, /* @__PURE__ */ React110.createElement(UitkSpacing43, null, /* @__PURE__ */ React110.createElement("div", null, /* @__PURE__ */ React110.createElement(UitkLineSkeleton3, null))), /* @__PURE__ */ React110.createElement(UitkSpacing43, {
        padding: {
            blockstart: "three"
        }
    }, /* @__PURE__ */ React110.createElement("div", null, /* @__PURE__ */ React110.createElement(UitkLineSkeleton3, {
        type: "secondary"
    })))));
};
// src/components/smart-shopping-listings/__private/__fragments/details-and-fares/flights-details-and-fares.tsx
import { FlightsSortAndFilters, SortAndFiltersViewType } from "@shared-ui/retail-sort-and-filter-flights";
var __Query = gql110(_templateObject109(), FlightsDetailsAndFaresContent.fragment, FailedRequestMessaging.fragment);
var FlightsDetailsAndFares = function(props) {
    var _data, _data_flightsSearch_listingResult;
    var inputs = props.inputs, handleFilter = props.handleFilter, onFareApplied = props.onFareApplied, onErrorContent = props.onErrorContent, onSuccessSideSheet = props.onSuccessSideSheet, onErrorSideSheet = props.onErrorSideSheet, headerSpacing = props.headerSpacing;
    var context = useBexApi().context;
    var variables = _object_spread_props(_object_spread({}, inputs), {
        context: context
    });
    var _useQuery = useQuery(__Query, {
        notifyOnNetworkStatusChange: true,
        variables: variables,
        ssr: false
    }), data = _useQuery.data, error = _useQuery.error, loading = _useQuery.loading, refetch = _useQuery.refetch;
    useEffect4(function() {
        var _data_flightsSearch_listingResult, _data_flightsSearch_listingResult_listings;
        if (error) {
            var _onErrorSideSheet;
            (_onErrorSideSheet = onErrorSideSheet) === null || _onErrorSideSheet === void 0 ? void 0 : _onErrorSideSheet();
        }
        if (data && ((_data_flightsSearch_listingResult = data.flightsSearch.listingResult) === null || _data_flightsSearch_listingResult === void 0 ? void 0 : _data_flightsSearch_listingResult.__typename) === "FlightsLoadedListingResult" && ((_data_flightsSearch_listingResult_listings = data.flightsSearch.listingResult.listings) === null || _data_flightsSearch_listingResult_listings === void 0 ? void 0 : _data_flightsSearch_listingResult_listings.length) === 0) {
            var _onErrorSideSheet1;
            (_onErrorSideSheet1 = onErrorSideSheet) === null || _onErrorSideSheet1 === void 0 ? void 0 : _onErrorSideSheet1();
        }
    }, [
        data,
        error,
        onErrorSideSheet
    ]);
    useEffect4(function() {
        var _data_flightsSearch_listingResult, _data_flightsSearch_listingResult_listings_, _data_flightsSearch_listingResult_listings;
        if (data && ((_data_flightsSearch_listingResult = data.flightsSearch.listingResult) === null || _data_flightsSearch_listingResult === void 0 ? void 0 : _data_flightsSearch_listingResult.__typename) === "FlightsLoadedListingResult" && ((_data_flightsSearch_listingResult_listings = data.flightsSearch.listingResult.listings) === null || _data_flightsSearch_listingResult_listings === void 0 ? void 0 : (_data_flightsSearch_listingResult_listings_ = _data_flightsSearch_listingResult_listings[0]) === null || _data_flightsSearch_listingResult_listings_ === void 0 ? void 0 : _data_flightsSearch_listingResult_listings_.__typename) === "FlightsStandardOffer" && data.flightsSearch.listingResult.listings[0].journeys[0].detailsAndFares) {
            var _onSuccessSideSheet;
            (_onSuccessSideSheet = onSuccessSideSheet) === null || _onSuccessSideSheet === void 0 ? void 0 : _onSuccessSideSheet();
        }
    }, [
        data,
        onSuccessSideSheet
    ]);
    var handleRetry = useCallback(function() {
        refetch();
    }, [
        refetch
    ]);
    var handlePillClick = useCallback(function(target, event) {
        var _parseFilterItem = parseFilterItem(target, event), filterInput = _parseFilterItem.filterInput, type = _parseFilterItem.type, operation = _parseFilterItem.operation;
        if (filterInput) {
            var _handleFilter;
            (_handleFilter = handleFilter) === null || _handleFilter === void 0 ? void 0 : _handleFilter(filterInput, type, operation);
        }
    }, [
        handleFilter
    ]);
    var filterPills = useMemo3(function() {
        return /* @__PURE__ */ React111.createElement(FlightsSortAndFilters, {
            inputs: inputs,
            onFieldChange: handlePillClick,
            view: SortAndFiltersViewType.FILTERS_PILLS
        });
    }, [
        handlePillClick,
        inputs
    ]);
    if (loading) {
        return /* @__PURE__ */ React111.createElement(FlightsLoadingSkeletons, null);
    }
    if (!data || error) {
        return /* @__PURE__ */ React111.createElement(React111.Fragment, null, onErrorContent);
    }
    if (((_data = data) === null || _data === void 0 ? void 0 : _data.flightsSearch) && ((_data_flightsSearch_listingResult = data.flightsSearch.listingResult) === null || _data_flightsSearch_listingResult === void 0 ? void 0 : _data_flightsSearch_listingResult.__typename) === "FlightsLoadedListingResult") {
        var listingResult = data.flightsSearch.listingResult;
        if (listingResult.listings && listingResult.listings.length > 0) {
            var _listingResult_listings_;
            if (((_listingResult_listings_ = listingResult.listings[0]) === null || _listingResult_listings_ === void 0 ? void 0 : _listingResult_listings_.__typename) === "FlightsStandardOffer" && listingResult.listings[0].journeys[0].detailsAndFares) {
                return /* @__PURE__ */ React111.createElement(FlightsDetailsAndFaresContent, {
                    size: 4,
                    data: listingResult.listings[0].journeys[0].detailsAndFares.content,
                    onFareApplied: onFareApplied,
                    filterPillComponent: filterPills,
                    headerSpacing: headerSpacing
                });
            }
        }
    }
    if (data.flightsSearch.failedRequestMessaging) {
        return /* @__PURE__ */ React111.createElement(FailedRequestMessaging, {
            data: data.flightsSearch.failedRequestMessaging,
            onRetry: handleRetry
        });
    }
    return /* @__PURE__ */ React111.createElement(React111.Fragment, null, onErrorContent);
};
FlightsDetailsAndFares.displayName = "FlightsDetailsAndFares";
// src/components/smart-shopping-listings/__private/__fragments/flights-experience-dialog-sheet.tsx
import React113 from "react";
import { gql as gql112 } from "@apollo/client";
import { useDialog as useDialog9 } from "@shared-ui/dialog-context";
// ../internal/src/components/flights-sheet/flights-side-sheet.tsx
import React112 from "react";
import { gql as gql111 } from "@apollo/client";
import { useDialog as useDialog8 } from "@shared-ui/dialog-context";
import { UitkSheet as UitkSheet2, UitkSheetContent, UitkSheetFooter } from "uitk-react-sheet";
import { UitkSpacing as UitkSpacing44 } from "uitk-react-spacing";
import { UitkSticky as UitkSticky2 } from "uitk-react-sticky";
import { UitkToolbar as UitkToolbar2 } from "uitk-react-toolbar";
var fragment98 = gql111(_templateObject110(), EGDSElement.fragment);
var FlightsSideSheet = function(param) {
    var actionsCallback = param.actionsCallback, columns = param.columns, header = param.header, content = param.content, contentSpacing = param.contentSpacing, footer = param.footer, data = param.data, isVisible = param.isVisible, layout = param.layout, title = param.title, onClose = param.onClose, dialogId = param.dialogId;
    var _useDialog8 = _sliced_to_array(useDialog8(dialogId), 2), dialogActions = _useDialog8[1];
    React112.useEffect(function() {
        if (data.initialState === "OPEN" /* OPEN */ ) {
            dialogActions.openDialog();
        }
    }, []);
    var titleContent = title || data.title;
    var sheetContent = React112.useMemo(function() {
        if (content) {
            return content;
        }
        return /* @__PURE__ */ React112.createElement(React112.Fragment, null, data.content && data.content.length > 0 && data.content.map(function(element, key) {
            return /* @__PURE__ */ React112.createElement(EGDSElement, {
                data: element,
                key: key,
                callback: actionsCallback
            });
        }));
    }, [
        content,
        data.content,
        actionsCallback
    ]);
    var footerContent = React112.useMemo(function() {
        if (footer) {
            return footer;
        }
        return /* @__PURE__ */ React112.createElement(React112.Fragment, null, data.footer && data.footer.length > 0 && data.footer.map(function(element, key) {
            return /* @__PURE__ */ React112.createElement(EGDSElement, {
                data: element,
                key: key,
                callback: actionsCallback
            });
        }));
    }, [
        footer,
        data.footer,
        actionsCallback
    ]);
    var layoutMemo = React112.useMemo(function() {
        var defaultLayout = {
            position: "trailing",
            columns: columns !== null && columns !== void 0 ? columns : 3
        };
        return layout !== null && layout !== void 0 ? layout : defaultLayout;
    }, [
        layout,
        columns
    ]);
    return /* @__PURE__ */ React112.createElement(UitkSheet2, {
        isVisible: isVisible,
        type: "side",
        sideSheetLayout: layoutMemo,
        triggerRef: null
    }, /* @__PURE__ */ React112.createElement(UitkToolbar2, {
        toolbarTitle: titleContent !== null && titleContent !== void 0 ? titleContent : void 0,
        navigationContent: {
            onClick: onClose
        }
    }), header && /* @__PURE__ */ React112.createElement(UitkSticky2, null, header), /* @__PURE__ */ React112.createElement(UitkSheetContent, {
        padded: false
    }, contentSpacing ? /* @__PURE__ */ React112.createElement(UitkSpacing44, {
        padding: contentSpacing.padding,
        margin: contentSpacing.margin
    }, /* @__PURE__ */ React112.createElement("div", null, sheetContent)) : /* @__PURE__ */ React112.createElement("div", null, sheetContent)), footerContent && /* @__PURE__ */ React112.createElement(UitkSheetFooter, null, /* @__PURE__ */ React112.createElement(React112.Fragment, null, footerContent)));
};
FlightsSideSheet.displayName = "FlightsSideSheet";
FlightsSideSheet.fragment = fragment98;
// src/components/smart-shopping-listings/__private/__fragments/flights-experience-dialog-sheet.tsx
import { ViewLarge as ViewLarge4, Viewport as Viewport4, ViewSmall as ViewSmall4 } from "@shared-ui/viewport-context";
var fragment99 = gql112(_templateObject111(), EGDSDialog.fragment, EGDSElement.fragment);
var FlightsExperienceDialogSheet = function(param) {
    var actionsCallback = param.actionsCallback, sheetColumns = param.sheetColumns, header = param.header, content = param.content, data = param.data, dialogSpacing = param.dialogSpacing, footer = param.footer, sheetLayout = param.sheetLayout, sheetSpacing = param.sheetSpacing, onDialogClose = param.onDialogClose;
    var dialogId = data.dialogId, dialog = data.dialog, sheet = data.sheet;
    var _useDialog9 = _sliced_to_array(useDialog9(dialogId), 2), isOpen = _useDialog9[0], dialogActions = _useDialog9[1];
    var handleOnClose = React113.useCallback(function() {
        var _onDialogClose;
        dialogActions.closeDialog();
        (_onDialogClose = onDialogClose) === null || _onDialogClose === void 0 ? void 0 : _onDialogClose();
    }, [
        dialogActions,
        onDialogClose
    ]);
    var sideSheetData = {
        __typename: "FlightsSideSheet",
        content: null,
        footer: null,
        title: sheet.title,
        initialState: null
    };
    return /* @__PURE__ */ React113.createElement(Viewport4, null, /* @__PURE__ */ React113.createElement(ViewSmall4, null, /* @__PURE__ */ React113.createElement(EGDSDialog, {
        actionsCallback: actionsCallback,
        content: content,
        header: header,
        data: dialog.dialog,
        footer: footer,
        spacing: dialogSpacing,
        handleCloseCallback: handleOnClose,
        dialogId: dialog.dialogId
    })), /* @__PURE__ */ React113.createElement(ViewLarge4, null, /* @__PURE__ */ React113.createElement(FlightsSideSheet, {
        data: sideSheetData,
        actionsCallback: actionsCallback,
        onClose: handleOnClose,
        isVisible: isOpen,
        header: header,
        content: content,
        columns: sheetColumns,
        footer: footer,
        contentSpacing: sheetSpacing,
        layout: sheetLayout,
        dialogId: dialogId
    })));
};
FlightsExperienceDialogSheet.fragment = fragment99;
FlightsExperienceDialogSheet.displayName = "FlightsExperienceDialogSheet";
// src/components/smart-shopping-listings/__private/__fragments/multi-item/flights-search-cross-sell-offer.tsx
import React116, { useCallback as useCallback3, useMemo as useMemo5 } from "react";
import { gql as gql115 } from "@apollo/client";
import { BrandedDealCrossSellFlight } from "@shared-ui/multi-item-branded-deal-cross-sell";
// src/components/smart-shopping-listings/__private/utils/strip-graphql-metadata.ts
function stripGraphQlMetadata(obj) {
    return JSON.parse(JSON.stringify(obj, function(k, v) {
        return k.startsWith("__") || k.endsWith("__") ? void 0 : v;
    }));
}
// src/components/smart-shopping-listings/__private/__fragments/multi-item/flights-search-cross-sell-loading-placeholder.tsx
import React114 from "react";
import { UitkCardContentSection as UitkCardContentSection6 } from "uitk-react-cards";
import { UitkSpacing as UitkSpacing45 } from "uitk-react-spacing";
var offerCardSpacing2 = {
    padding: {
        inline: "three",
        block: "six"
    },
    border: [
        "blockend"
    ]
};
var CrossSellLoadingPlaceholder = React114.memo(function() {
    return /* @__PURE__ */ React114.createElement(UitkSpacing45, {
        padding: offerCardSpacing2.padding
    }, /* @__PURE__ */ React114.createElement(UitkCardContentSection6, {
        border: "bottom"
    }, /* @__PURE__ */ React114.createElement(FlightsLoadingSkeletons, {
        isSmartShoppingFlightCard: true
    })));
});
CrossSellLoadingPlaceholder.displayName = "CrossSellLoadingPlaceholder";
// src/components/smart-shopping-listings/__private/__fragments/multi-item/flights-search-static-cross-sell-offer.tsx
import React115, { useCallback as useCallback2, useMemo as useMemo4 } from "react";
import { StaticMultiItemCrossSell } from "@shared-ui/multi-item-static-cross-sell";
var FlightsSearchStaticCrossSellOffer = function(param) {
    var brandedDealFallBack = param.brandedDealFallBack;
    var _ref = brandedDealFallBack !== null && brandedDealFallBack !== void 0 ? brandedDealFallBack : {}, flightCrossSellProductType = _ref.flightCrossSellProductType, multiItemSearchContext = _ref.multiItemSearchContext;
    var memoizedLoadingPlaceHolder = useCallback2(function() {
        return /* @__PURE__ */ React115.createElement(CrossSellLoadingPlaceholder, null);
    }, []);
    var staticCrossSellInputs = stripGraphQlMetadata({
        searchContext: multiItemSearchContext,
        crossSellProductType: flightCrossSellProductType
    });
    var inputs = useMemo4(function() {
        return staticCrossSellInputs;
    }, [
        staticCrossSellInputs
    ]);
    return /* @__PURE__ */ React115.createElement(StaticMultiItemCrossSell, {
        skipSsr: true,
        inputs: inputs,
        loadingPlaceholder: memoizedLoadingPlaceHolder,
        isSmartShoppingFlightCard: true
    });
};
// src/components/smart-shopping-listings/__private/__fragments/multi-item/fragments.ts
import { gql as gql114 } from "@apollo/client";
// ../internal/src/components/common/date-fragment.tsx
import { gql as gql113 } from "@apollo/client";
var DateFragment = gql113(_templateObject112());
// src/components/smart-shopping-listings/__private/__fragments/multi-item/fragments.ts
var multiItemSearchContextFragment = gql114(_templateObject113(), DateFragment);
var multiItemPackageableProductFragment = gql114(_templateObject114());
var multiItemFlightCrossSellPrimerFragment = gql114(_templateObject115(), multiItemSearchContextFragment);
// src/components/smart-shopping-listings/__private/__fragments/multi-item/flights-search-cross-sell-offer.tsx
var fragment100 = gql115(_templateObject116(), multiItemSearchContextFragment, multiItemPackageableProductFragment, multiItemFlightCrossSellPrimerFragment);
var FlightsSearchCrossSellOffer = function(param) {
    var data = param.data;
    var _price, _price1;
    var multiItemFlightCrossSellOfferPrimer = data.multiItemFlightCrossSellOfferPrimer;
    var multiItemSearchContext = multiItemFlightCrossSellOfferPrimer.multiItemSearchContext, multiItemPackageableProduct = multiItemFlightCrossSellOfferPrimer.multiItemPackageableProduct, price = multiItemFlightCrossSellOfferPrimer.price, brandedDealFallBack = multiItemFlightCrossSellOfferPrimer.brandedDealFallBack;
    var memoizedLoadingPlaceHolder = useCallback3(function() {
        return /* @__PURE__ */ React116.createElement(CrossSellLoadingPlaceholder, null);
    }, []);
    var memoizedFallback = useCallback3(function() {
        return /* @__PURE__ */ React116.createElement(FlightsSearchStaticCrossSellOffer, {
            brandedDealFallBack: brandedDealFallBack
        });
    }, [
        brandedDealFallBack
    ]);
    var brandedDealsInputs = stripGraphQlMetadata({
        searchContext: multiItemSearchContext,
        multiItemProducts: multiItemPackageableProduct,
        price: {
            base: (_price = price) === null || _price === void 0 ? void 0 : _price.base,
            taxesAndFees: (_price1 = price) === null || _price1 === void 0 ? void 0 : _price1.taxesAndFees
        }
    });
    var inputs = useMemo5(function() {
        return brandedDealsInputs;
    }, [
        brandedDealsInputs
    ]);
    return /* @__PURE__ */ React116.createElement(BrandedDealCrossSellFlight, {
        skipSsr: true,
        inputs: inputs,
        loadingPlaceholder: memoizedLoadingPlaceHolder,
        noResultsFallback: memoizedFallback,
        isSmartShoppingFlightCard: true
    });
};
FlightsSearchCrossSellOffer.fragment = fragment100;
FlightsSearchCrossSellOffer.displayName = "FlightsSearchCrossSellOffer";
// src/components/smart-shopping-listings/__private/__fragments/offer-cards.tsx
import React119 from "react";
import { withUitkLayoutGrid } from "uitk-react-layout-grid";
import { UitkList as UitkList9 } from "uitk-react-list";
// src/components/smart-shopping-listings/__private/__fragments/render-offer.tsx
import React118 from "react";
import { UitkSpacing as UitkSpacing46 } from "uitk-react-spacing";
// src/components/smart-shopping-listings/__private/__fragments/render-sponsored-content.tsx
import React117 from "react";
import { BrandResultListingFlights } from "@shared-ui/sponsored-content-brand-result-listing-flights";
var renderSponsoredContent = function(sponsoredContentPlacement, index) {
    var productType = sponsoredContentPlacement.productType;
    switch(productType){
        case "BRAND_RESULT_LISTING_FLIGHTS" /* BRAND_RESULT_LISTING_FLIGHTS */ :
            return /* @__PURE__ */ React117.createElement("li", {
                key: index
            }, /* @__PURE__ */ React117.createElement(BrandResultListingFlights, {
                inputs: stripGraphQlMetadata(sponsoredContentPlacement),
                smartShopping: true
            }));
        default:
            return null;
    }
};
// src/components/smart-shopping-listings/__private/__fragments/render-offer.tsx
var offerCardSpacing3 = {
    padding: {
        blockend: "three",
        blockstart: "three"
    }
};
var separatorSpacing = {
    padding: {
        blockend: "two",
        blockstart: "four",
        inlinestart: "four"
    },
    margin: {
        blockstart: "three"
    }
};
var renderOffer = function(offer, index, withBorder, onTriggerClick, onOfferSelect) {
    switch(offer.__typename){
        case "FlightsExperienceBargainFareOffer":
            return /* @__PURE__ */ React118.createElement("li", {
                key: "offer-key-".concat(index)
            }, /* @__PURE__ */ React118.createElement(FlightsExperienceBargainFareOffer, {
                data: offer,
                onTriggerClick: onTriggerClick,
                onOfferSelect: onOfferSelect
            }));
        case "FlightsSmartShoppingOfferCard":
            return /* @__PURE__ */ React118.createElement(UitkSpacing46, {
                padding: offerCardSpacing3.padding,
                border: withBorder ? [
                    "blockend"
                ] : void 0,
                key: "offer-key-".concat(index)
            }, /* @__PURE__ */ React118.createElement(FlightsSmartShoppingOfferCard, {
                data: offer,
                key: "flight-offer-".concat(index),
                onTriggerClick: onTriggerClick,
                onOfferSelect: onOfferSelect
            }));
        case "FlightsSearchCrossSellOffer":
            return offer.multiItemFlightCrossSellOfferPrimer ? /* @__PURE__ */ React118.createElement("li", null, /* @__PURE__ */ React118.createElement(FlightsSearchCrossSellOffer, {
                data: offer
            })) : null;
        case "EGDSStylizedText":
            return /* @__PURE__ */ React118.createElement(UitkSpacing46, {
                padding: separatorSpacing.padding,
                margin: separatorSpacing.margin,
                key: "messaging-key-".concat(index)
            }, /* @__PURE__ */ React118.createElement("li", null, /* @__PURE__ */ React118.createElement(EGDSStylizedText, {
                data: offer,
                key: "listing-text-".concat(index),
                size: 400
            })));
        case "SponsoredContentPlacement":
            return renderSponsoredContent(offer, index);
        default:
            return null;
    }
};
// src/components/smart-shopping-listings/__private/__fragments/offer-cards.tsx
var LayoutGridWrapper = withUitkLayoutGrid(function(props) {
    return /* @__PURE__ */ React119.createElement(UitkList9, _object_spread_props(_object_spread({}, props), {
        bullet: "no-bullet",
        spacing: false,
        type: "ordered",
        "data-test-id": "listings"
    }));
});
var OfferCards = React119.memo(function(param) {
    var listings = param.listings, onOfferClicked = param.onOfferClicked, onOfferSelect = param.onOfferSelect;
    return /* @__PURE__ */ React119.createElement(LayoutGridWrapper, {
        columns: 1
    }, listings.map(function(offer, index) {
        return renderOffer(offer, index, index + 1 < listings.length, onOfferClicked, onOfferSelect);
    }));
});
OfferCards.displayName = "OfferCards";
// src/components/smart-shopping-listings/__private/__fragments/sponsored-content-placement-fragment.tsx
import { gql as gql116 } from "@apollo/client";
var SponsoredListingPlacementFragment = gql116(_templateObject117(), DateFragment);
// src/components/smart-shopping-listings/__private/__fragments/flight-smart-shopping-loaded-listings.tsx
var __Fragment2 = gql117(_templateObject118(), FlightsSmartShoppingOfferCard.fragment, FlightsExperienceBargainFareOffer.fragment, EGDSStylizedText.fragment, SponsoredListingPlacementFragment, clientSideAnalyticsFragment, FlightsExperienceDialogSheet.fragment, FlightsSearchCrossSellOffer.fragment);
var FlightsSmartShoppingLoadedListings = function(param) {
    var data = param.data, listingsInputs = param.listingsInputs, onDialogClose = param.onDialogClose, onErrorSideSheet = param.onErrorSideSheet, onEmptyListings = param.onEmptyListings, onFareApplied = param.onFareApplied, onSideSheetLoad = param.onSideSheetLoad, onSuccessSideSheet = param.onSuccessSideSheet, onTriggerClick = param.onTriggerClick, isDisabledLoading = param.isDisabledLoading, detailsAndFaresContent = param.detailsAndFaresContent, detailsAndFaresFooter = param.detailsAndFaresFooter, onOfferSelect = param.onOfferSelect, isUpsellLoading = param.isUpsellLoading, shouldKeepLoading = param.shouldKeepLoading, hasPreviousData = param.hasPreviousData, setIsDisabledLoading = param.setIsDisabledLoading;
    var _listingsInputs_flightSearchFilterValuesList;
    var _useReducer = _sliced_to_array(useReducer(loadedListingsReducer, {
        selectedJcid: "",
        flightSearchFilterValuesList: (_listingsInputs_flightSearchFilterValuesList = listingsInputs.flightSearchFilterValuesList) !== null && _listingsInputs_flightSearchFilterValuesList !== void 0 ? _listingsInputs_flightSearchFilterValuesList : [],
        addOnRequested: listingsInputs.flightSearchFilterValuesList ? getAddOnRequestedFromFiltersSelected(listingsInputs.flightSearchFilterValuesList) : [],
        renderToast: !!data.toast
    }), 2), state = _useReducer[0], dispatch = _useReducer[1];
    var accessibilityMessage = data.accessibilityMessage, listings = data.listings, flightsDetailsAndFaresWrapper = data.flightsDetailsAndFaresWrapper, flightsListingsAnalytics = data.flightsListingsAnalytics, toast = data.toast;
    var clickstreamAnalytics = useClickstreamAnalytics12();
    var onOfferClicked = useCallback4(function(jcid) {
        onTriggerClick(jcid);
        var _listingsInputs_flightSearchFilterValuesList;
        setTimeout(function() {
            return dispatch({
                type: "setSelectedJcid",
                selectedJcid: jcid,
                flightSearchFilterValuesList: (_listingsInputs_flightSearchFilterValuesList = listingsInputs.flightSearchFilterValuesList) !== null && _listingsInputs_flightSearchFilterValuesList !== void 0 ? _listingsInputs_flightSearchFilterValuesList : [],
                renderToast: false
            });
        }, 10);
    }, [
        listingsInputs.flightSearchFilterValuesList,
        onTriggerClick
    ]);
    React120.useEffect(function() {
        if (listings.length) {
            liveAnnounce4(accessibilityMessage !== null && accessibilityMessage !== void 0 ? accessibilityMessage : void 0);
            if (flightsListingsAnalytics.length) {
                trackAnalyticsList(clickstreamAnalytics, flightsListingsAnalytics);
            }
        }
    }, [
        accessibilityMessage,
        listings.length,
        flightsListingsAnalytics.length
    ]);
    var handleFilter = useCallback4(function(filterInput, filter, operation) {
        var inputs = getDetailsAndFaresInputs(listingsInputs, state.selectedJcid, state.flightSearchFilterValuesList, state.addOnRequested);
        var filters = handleFilterSelection(inputs, filterInput, filter, operation);
        dispatch({
            type: "setSelectedFilters",
            flightSearchFilterValuesList: filters,
            renderToast: false
        });
    }, [
        listingsInputs,
        state
    ]);
    var getSheetLayout = React120.useCallback(function() {
        if (detailsAndFaresContent) {
            var numCols = 4;
            var faresSectionWrapper = detailsAndFaresContent.sections.filter(function(section) {
                return section.__typename === "FlightsFaresInformation";
            });
            if (faresSectionWrapper && faresSectionWrapper.length === 1) {
                var faresSection = faresSectionWrapper[0];
                if (faresSection.fares) {
                    numCols = faresSection.fares.length !== 1 || isUpsellLoading ? 6 : numCols;
                }
            }
            return {
                position: "trailing",
                columns: numCols
            };
        }
        return {
            position: "trailing",
            columns: 4
        };
    }, [
        isUpsellLoading,
        detailsAndFaresContent
    ]);
    var detailsAndFaresContentMemo = React120.useMemo(function() {
        if (detailsAndFaresContent) {
            var faresInformation = detailsAndFaresContent.sections.find(function(section) {
                return section.__typename === "FlightsFaresInformation";
            });
            var totalFareCount = faresInformation ? faresInformation.totalFareCount : 1;
            var availableFares = faresInformation ? faresInformation.fares.length : 0;
            return /* @__PURE__ */ React120.createElement(FlightsDetailsAndFaresContent, {
                onFareApplied: onFareApplied,
                data: detailsAndFaresContent,
                size: 4,
                isUpsellLoading: isUpsellLoading,
                availableFaresCount: totalFareCount - availableFares
            });
        }
        if (state.selectedJcid !== "") {
            var inputs = getDetailsAndFaresInputs(listingsInputs, state.selectedJcid, state.flightSearchFilterValuesList, state.addOnRequested);
            return /* @__PURE__ */ React120.createElement(FlightsDetailsAndFares, {
                inputs: inputs,
                handleFilter: handleFilter,
                onErrorContent: null,
                onFareApplied: onFareApplied,
                onSideSheetLoad: onSideSheetLoad,
                onSuccessSideSheet: onSuccessSideSheet,
                onErrorSideSheet: onErrorSideSheet,
                headerSpacing: true
            });
        }
        return /* @__PURE__ */ React120.createElement(React120.Fragment, null);
    }, [
        detailsAndFaresContent,
        state.selectedJcid,
        state.flightSearchFilterValuesList,
        state.addOnRequested,
        onFareApplied,
        isUpsellLoading,
        listingsInputs,
        handleFilter,
        onSideSheetLoad,
        onSuccessSideSheet,
        onErrorSideSheet
    ]);
    var detailsAndFaresFooterMemo = React120.useMemo(function() {
        if (detailsAndFaresFooter) {
            return /* @__PURE__ */ React120.createElement(FlightsDetailsAndFaresFooter, {
                onFareApplied: onFareApplied,
                data: detailsAndFaresFooter
            });
        }
        return /* @__PURE__ */ React120.createElement(React120.Fragment, null);
    }, [
        detailsAndFaresFooter,
        onFareApplied
    ]);
    React120.useEffect(function() {
        if (!listings.length) {
            var _onEmptyListings;
            (_onEmptyListings = onEmptyListings) === null || _onEmptyListings === void 0 ? void 0 : _onEmptyListings();
        }
    }, [
        listings.length,
        onEmptyListings
    ]);
    var handleDialogClose = useCallback4(function() {
        var _onDialogClose;
        (_onDialogClose = onDialogClose) === null || _onDialogClose === void 0 ? void 0 : _onDialogClose(state.flightSearchFilterValuesList, state.addOnRequested);
        var _listingsInputs_flightSearchFilterValuesList;
        dispatch({
            type: "setSelectedJcid",
            selectedJcid: "",
            flightSearchFilterValuesList: (_listingsInputs_flightSearchFilterValuesList = listingsInputs.flightSearchFilterValuesList) !== null && _listingsInputs_flightSearchFilterValuesList !== void 0 ? _listingsInputs_flightSearchFilterValuesList : [],
            renderToast: false
        });
    }, [
        listingsInputs.flightSearchFilterValuesList,
        onDialogClose,
        state.addOnRequested,
        state.flightSearchFilterValuesList
    ]);
    if (shouldKeepLoading) {
        if (hasPreviousData) {
            setIsDisabledLoading(true);
        } else {
            return /* @__PURE__ */ React120.createElement(ListingsLoadingOffers, null);
        }
    } else {
        setIsDisabledLoading(false);
    }
    return /* @__PURE__ */ React120.createElement(React120.Fragment, null, /* @__PURE__ */ React120.createElement(UitkCard8, null, /* @__PURE__ */ React120.createElement("div", null, /* @__PURE__ */ React120.createElement(OfferCards, {
        listings: listings,
        onOfferClicked: onOfferClicked,
        onOfferSelect: onOfferSelect
    }))), flightsDetailsAndFaresWrapper && /* @__PURE__ */ React120.createElement(FlightsExperienceDialogSheet, {
        data: flightsDetailsAndFaresWrapper,
        content: detailsAndFaresContentMemo,
        footer: detailsAndFaresFooterMemo,
        sheetLayout: getSheetLayout(),
        dialogSpacing: "unset",
        onDialogClose: handleDialogClose
    }), !isDisabledLoading && toast && /* @__PURE__ */ React120.createElement(UitkToast, {
        show: state.renderToast
    }, toast.text));
};
FlightsSmartShoppingLoadedListings.displayName = "FlightsSmartShoppingLoadedListings";
FlightsSmartShoppingLoadedListings.fragment = __Fragment2;
// src/components/smart-shopping-listings/__private/__fragments/flights-smart-shopping-listings-error.tsx
import React129 from "react";
import { gql as gql126 } from "@apollo/client";
// ../internal/src/components/flights-on-load-error/flights-on-load-error.tsx
import React128 from "react";
import { gql as gql125 } from "@apollo/client";
// ../internal/src/components/flights-on-load-error/__fragments/flights-server-error.tsx
import React121 from "react";
import { gql as gql118 } from "@apollo/client";
import { UitkLayoutFlex as UitkLayoutFlex29 } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing47 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading10, UitkText as UitkText28 } from "uitk-react-text";
var fragment101 = gql118(_templateObject119(), Icon.fragment, FlightsActionButton.fragment);
var FlightsServerError = function(param) {
    var data = param.data, onClickEvent = param.onClickEvent, onError = param.onError;
    var heading = data.heading, message = data.message, icon = data.icon, action = data.action;
    React121.useEffect(function() {
        var _onError;
        if (action.clientAction.__typename === "FlightsSearchCriteriaChangeAction") {
            var _onError1;
            return (_onError1 = onError) === null || _onError1 === void 0 ? void 0 : _onError1("NO_FLIGHTS_FOUND" /* NO_FLIGHTS_FOUND */ );
        }
        (_onError = onError) === null || _onError === void 0 ? void 0 : _onError("SERVER_ERROR" /* SERVER_ERROR */ );
    }, [
        action.clientAction.__typename,
        onError
    ]);
    var mainSpacingProps7 = {
        margin: {
            block: "twelve"
        },
        padding: {
            block: "twelve",
            inline: "four"
        }
    };
    var iconSpacingProps4 = {
        margin: {
            blockend: "four"
        }
    };
    var headingSpacingProps3 = {
        margin: {
            blockend: "two"
        }
    };
    var bodySpacingProps2 = {
        margin: {
            blockend: "three"
        }
    };
    var actionSpacingProps2 = {
        margin: {
            blockstart: "six"
        }
    };
    return /* @__PURE__ */ React121.createElement(UitkSpacing47, {
        margin: mainSpacingProps7.margin,
        padding: mainSpacingProps7.padding
    }, /* @__PURE__ */ React121.createElement(UitkLayoutFlex29, {
        direction: "column",
        alignItems: "center"
    }, icon && /* @__PURE__ */ React121.createElement(UitkSpacing47, {
        margin: iconSpacingProps4.margin
    }, /* @__PURE__ */ React121.createElement(Icon, {
        data: icon
    })), /* @__PURE__ */ React121.createElement(UitkSpacing47, {
        margin: headingSpacingProps3.margin
    }, /* @__PURE__ */ React121.createElement(UitkHeading10, {
        size: 5,
        align: "center"
    }, heading)), /* @__PURE__ */ React121.createElement(UitkSpacing47, {
        margin: bodySpacingProps2.margin
    }, /* @__PURE__ */ React121.createElement(UitkText28, {
        align: "center"
    }, message)), /* @__PURE__ */ React121.createElement(UitkSpacing47, {
        margin: actionSpacingProps2.margin
    }, /* @__PURE__ */ React121.createElement(FlightsActionButton, {
        data: action,
        isFullWidth: false,
        callback: onClickEvent
    }))));
};
FlightsServerError.fragment = fragment101;
FlightsServerError.displayName = "FlightsServerError";
// ../internal/src/components/flights-on-load-error/__fragments/flights-smart-shopping-overfiltering-error.tsx
import React127 from "react";
import { gql as gql124 } from "@apollo/client";
import { UitkCard as UitkCard9 } from "uitk-react-cards";
import { UitkLayoutFlex as UitkLayoutFlex30 } from "uitk-react-layout-flex";
import { UitkPillContainer } from "uitk-react-pill";
import { UitkSpacing as UitkSpacing48 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading11, UitkText as UitkText29 } from "uitk-react-text";
// ../internal/src/components/flights-shopping-applied-filter/flights-shopping-applied-filter.tsx
import React126 from "react";
import { gql as gql123 } from "@apollo/client";
// ../internal/src/components/flights-shopping-applied-filter/__fragments/flights-basic-shopping-applied-filter.tsx
import React125 from "react";
import { gql as gql122 } from "@apollo/client";
// ../internal/src/components/egds-pill/egds-pill.tsx
import React124 from "react";
import { gql as gql121 } from "@apollo/client";
// ../internal/src/components/egds-pill/egds-basic-pill.tsx
import React122 from "react";
import { gql as gql119 } from "@apollo/client";
import { useClickTracker as useClickTracker11 } from "@shared-ui/clickstream-analytics-context";
import { UitkPill } from "uitk-react-pill";
var fragment102 = gql119(_templateObject120(), UiGraphic.fragment, clientSideAnalyticsFragment);
var EGDSBasicPill = function(param) {
    var data = param.data, onClickCallback = param.onClickCallback;
    var _icon;
    var trackClick = useClickTracker11();
    var accessibility = data.accessibility, disabled = data.disabled, icon = data.icon, primary = data.primary, selected = data.selected, name = data.name, value = data.value, selectAnalytics = data.selectAnalytics, deselectAnalytics = data.deselectAnalytics;
    var _React122_useState = _sliced_to_array(React122.useState(selected), 2), isSelected2 = _React122_useState[0], setSelected = _React122_useState[1];
    var clickHandle = React122.useCallback(function() {
        var _onClickCallback;
        setSelected(!isSelected2);
        if (isSelected2 && selectAnalytics) {
            trackClick(selectAnalytics.referrerId, selectAnalytics.linkName);
        } else if (!isSelected2 && deselectAnalytics) {
            trackClick(deselectAnalytics.referrerId, deselectAnalytics.linkName);
        }
        (_onClickCallback = onClickCallback) === null || _onClickCallback === void 0 ? void 0 : _onClickCallback();
    }, [
        isSelected2,
        setSelected,
        onClickCallback,
        trackClick,
        selectAnalytics,
        deselectAnalytics
    ]);
    return /* @__PURE__ */ React122.createElement(UitkPill, {
        id: value || "pill",
        disabled: disabled,
        selected: isSelected2,
        name: name || void 0,
        onChange: clickHandle,
        altText: accessibility || void 0,
        value: value || void 0,
        icon: ((_icon = icon) === null || _icon === void 0 ? void 0 : _icon.__typename) === "Icon" ? icon.id : void 0
    }, primary);
};
EGDSBasicPill.displayName = "EGDSBasicPill";
EGDSBasicPill.fragment = fragment102;
// ../internal/src/components/egds-pill/egds-basic-removable-pill.tsx
import React123 from "react";
import { gql as gql120 } from "@apollo/client";
import { useClickTracker as useClickTracker12 } from "@shared-ui/clickstream-analytics-context";
import { UitkRemovablePill } from "uitk-react-pill";
var fragment103 = gql120(_templateObject121(), UiGraphic.fragment, clientSideAnalyticsFragment);
var EGDSBasicRemovablePill = function(param) {
    var data = param.data, onClickCallback = param.onClickCallback;
    var _icon;
    var trackClick = useClickTracker12();
    var accessibility = data.accessibility, disabled = data.disabled, icon = data.icon, primary = data.primary, remove = data.remove, removeAnalytics = data.removeAnalytics, value = data.value;
    var clickHandle = React123.useCallback(function() {
        if (removeAnalytics) {
            trackClick(removeAnalytics.referrerId, removeAnalytics.linkName);
        }
        if (onClickCallback) {
            onClickCallback();
        }
    }, [
        onClickCallback
    ]);
    return /* @__PURE__ */ React123.createElement(UitkRemovablePill, {
        id: value || "pill",
        disabled: disabled,
        onClick: clickHandle,
        altText: accessibility || void 0,
        value: value || void 0,
        icon: ((_icon = icon) === null || _icon === void 0 ? void 0 : _icon.__typename) === "Icon" ? icon.id : void 0
    }, primary);
};
EGDSBasicRemovablePill.displayName = "EGDSBasicRemovablePill";
EGDSBasicRemovablePill.fragment = fragment103;
// ../internal/src/components/egds-pill/egds-pill.tsx
var fragment104 = gql121(_templateObject122(), EGDSBasicPill.fragment, EGDSBasicRemovablePill.fragment);
var EGDSPill = function(param) {
    var data = param.data, onClickCallback = param.onClickCallback;
    switch(data.__typename){
        case "EGDSBasicPill":
            return /* @__PURE__ */ React124.createElement(EGDSBasicPill, {
                data: data,
                onClickCallback: onClickCallback
            });
        case "EGDSBasicRemovablePill":
            return /* @__PURE__ */ React124.createElement(EGDSBasicRemovablePill, {
                data: data,
                onClickCallback: onClickCallback
            });
        default:
            return null;
    }
};
EGDSPill.displayName = "EGDSPill";
EGDSPill.fragment = fragment104;
// ../internal/src/components/flights-shopping-applied-filter/__fragments/flights-basic-shopping-applied-filter.tsx
var fragment105 = gql122(_templateObject123(), EGDSPill.fragment);
var FlightsBasicShoppingAppliedFilter = function(param) {
    var data = param.data, onRemovePillCB = param.onRemovePillCB;
    var filter = data.filter, nextSearchCriteria = data.nextSearchCriteria;
    var onClickHandler = function() {
        var _onRemovePillCB;
        (_onRemovePillCB = onRemovePillCB) === null || _onRemovePillCB === void 0 ? void 0 : _onRemovePillCB(nextSearchCriteria);
    };
    if (!filter) {
        return null;
    }
    return /* @__PURE__ */ React125.createElement(EGDSPill, {
        data: filter,
        onClickCallback: onClickHandler
    });
};
FlightsBasicShoppingAppliedFilter.fragment = fragment105;
FlightsBasicShoppingAppliedFilter.displayName = "FlightsBasicShoppingAppliedFilter";
// ../internal/src/components/flights-shopping-applied-filter/flights-shopping-applied-filter.tsx
var fragment106 = gql123(_templateObject124(), FlightsBasicShoppingAppliedFilter.fragment);
var FlightsShoppingAppliedFilter = function(param) {
    var data = param.data, onRemovePillCB = param.onRemovePillCB;
    switch(data.__typename){
        case "BasicShoppingAppliedFilter":
            return /* @__PURE__ */ React126.createElement(FlightsBasicShoppingAppliedFilter, {
                data: data,
                onRemovePillCB: onRemovePillCB
            });
        default:
            return null;
    }
};
FlightsShoppingAppliedFilter.fragment = fragment106;
FlightsShoppingAppliedFilter.displayName = "FlightsShoppingAppliedFilter";
// ../internal/src/components/flights-on-load-error/__fragments/flights-smart-shopping-overfiltering-error.tsx
var fragment107 = gql124(_templateObject125(), FlightsExperienceActionButton.fragment, FlightsShoppingAppliedFilter.fragment, Icon.fragment);
var overFilteringCardSpacingProps = {
    padding: {
        block: "twelve",
        inline: "four"
    }
};
var overFilteringHeadingSpacingProps = {
    margin: {
        blockstart: "two",
        blockend: "one"
    }
};
var overFilteringPillsSpacingProps = {
    margin: {
        blockstart: "six",
        blockend: "six"
    }
};
var FlightsSmartShoppingOverFilteringError = function(param) {
    var data = param.data, onRemoveAllCB = param.onRemoveAllCB, onRemovePillCB = param.onRemovePillCB, onError = param.onError;
    React127.useEffect(function() {
        var _onError;
        (_onError = onError) === null || _onError === void 0 ? void 0 : _onError("OVERFILTERING_ERROR" /* OVERFILTERING_ERROR */ );
    }, [
        onError
    ]);
    var errorAction = data.errorAction, filterPills = data.filterPills, heading = data.heading, icon = data.icon, message = data.message;
    var pills = React127.useMemo(function() {
        return filterPills.map(function(pill, index) {
            return /* @__PURE__ */ React127.createElement(FlightsShoppingAppliedFilter, {
                key: "filterPill".concat(index),
                data: pill,
                onRemovePillCB: onRemovePillCB
            });
        });
    }, [
        filterPills,
        onRemovePillCB
    ]);
    var onTriggerClicked = function() {
        var _onRemoveAllCB;
        (_onRemoveAllCB = onRemoveAllCB) === null || _onRemoveAllCB === void 0 ? void 0 : _onRemoveAllCB();
    };
    return /* @__PURE__ */ React127.createElement(UitkCard9, null, /* @__PURE__ */ React127.createElement(UitkSpacing48, {
        padding: overFilteringCardSpacingProps.padding
    }, /* @__PURE__ */ React127.createElement(UitkLayoutFlex30, {
        direction: "column",
        alignItems: "center"
    }, icon && /* @__PURE__ */ React127.createElement(Icon, {
        data: icon
    }), /* @__PURE__ */ React127.createElement(UitkSpacing48, {
        margin: overFilteringHeadingSpacingProps.margin
    }, /* @__PURE__ */ React127.createElement(UitkHeading11, {
        align: "center"
    }, heading)), /* @__PURE__ */ React127.createElement(UitkText29, {
        align: "center"
    }, message), /* @__PURE__ */ React127.createElement(UitkSpacing48, {
        margin: overFilteringPillsSpacingProps.margin
    }, /* @__PURE__ */ React127.createElement(UitkLayoutFlex30, null, /* @__PURE__ */ React127.createElement(UitkPillContainer, {
        wrap: true,
        align: "center"
    }, pills))), /* @__PURE__ */ React127.createElement(FlightsExperienceActionButton, {
        data: errorAction,
        callback: onTriggerClicked
    }))));
};
FlightsSmartShoppingOverFilteringError.fragment = fragment107;
FlightsSmartShoppingOverFilteringError.displayName = "FlightsSmartShoppingOverFilteringError";
// ../internal/src/components/flights-on-load-error/flights-on-load-error.tsx
var fragment108 = gql125(_templateObject126(), FlightsServerError.fragment, FlightsSmartShoppingOverFilteringError.fragment, ClientSideImpressionEventAnalytics.fragment);
var FlightsOnLoadError = function(param) {
    var data = param.data, onError = param.onError, onOverFilteringRemoveAllClick = param.onOverFilteringRemoveAllClick, onOverFilteringRemovePillClick = param.onOverFilteringRemovePillClick, onServerErrorClick = param.onServerErrorClick;
    var onErrorContent = React128.useMemo(function() {
        switch(data.__typename){
            case "FlightsServerError":
                return /* @__PURE__ */ React128.createElement(FlightsServerError, {
                    data: data,
                    onClickEvent: onServerErrorClick,
                    onError: onError
                });
            case "FlightsSmartShoppingOverFilteringError":
                return /* @__PURE__ */ React128.createElement(FlightsSmartShoppingOverFilteringError, {
                    data: data,
                    onError: onError,
                    onRemoveAllCB: onOverFilteringRemoveAllClick,
                    onRemovePillCB: onOverFilteringRemovePillClick
                });
            default:
                return null;
        }
    }, [
        data,
        onError,
        onOverFilteringRemoveAllClick,
        onOverFilteringRemovePillClick,
        onServerErrorClick
    ]);
    return data.analytics ? /* @__PURE__ */ React128.createElement(ClientSideImpressionEventAnalytics, {
        data: data.analytics,
        content: onErrorContent
    }) : onErrorContent;
};
FlightsOnLoadError.fragment = fragment108;
FlightsOnLoadError.displayName = "FlightsOnLoadError";
// src/components/smart-shopping-listings/__private/__fragments/flights-smart-shopping-listings-error.tsx
var fragment109 = gql126(_templateObject127(), FlightsOnLoadError.fragment);
var FlightsSmartShoppingListingsError = function(param) {
    var data = param.data, onServerErrorClick = param.onServerErrorClick, onOverFilteringRemoveAllClick = param.onOverFilteringRemoveAllClick, onOverFilteringRemovePillClick = param.onOverFilteringRemovePillClick, onError = param.onError;
    return /* @__PURE__ */ React129.createElement(FlightsOnLoadError, {
        data: data.errorResponse,
        onError: onError,
        onServerErrorClick: onServerErrorClick,
        onOverFilteringRemoveAllClick: onOverFilteringRemoveAllClick,
        onOverFilteringRemovePillClick: onOverFilteringRemovePillClick
    });
};
FlightsSmartShoppingListingsError.displayName = "FlightsSmartShoppingListingsError";
FlightsSmartShoppingListingsError.fragment = fragment109;
// src/components/smart-shopping-listings/__private/flights-listings-loaded.tsx
var __Query2 = gql127(_templateObject128(), FlightsSmartShoppingLoadedListings.fragment, FlightsSmartShoppingListingsError.fragment);
var FlightsListingsLoaded = function(props) {
    var _results, _results1;
    var batchKey = props.batchKey, inputs = props.inputs, onDialogClose = props.onDialogClose, onError = props.onError, onErrorSideSheet = props.onErrorSideSheet, onFareApplied = props.onFareApplied, onLoading = props.onLoading, onLoad = props.onLoad, onOverFilteringRemoveAllClick = props.onOverFilteringRemoveAllClick, onOverFilteringRemovePillClick = props.onOverFilteringRemovePillClick, onServerErrorClick = props.onServerErrorClick, onSideSheetLoad = props.onSideSheetLoad, onSuccessSideSheet = props.onSuccessSideSheet, onTriggerClick = props.onTriggerClick, detailsAndFaresContent = props.detailsAndFaresContent, detailsAndFaresFooter = props.detailsAndFaresFooter, onOfferSelect = props.onOfferSelect, isUpsellLoading = props.isUpsellLoading, shouldKeepLoading = props.shouldKeepLoading;
    var _useState2 = _sliced_to_array(useState2(false), 2), isDisabledLoading = _useState2[0], setIsDisabledLoading = _useState2[1];
    var context = useBexApi2().context;
    var variables = _object_spread_props(_object_spread({}, inputs), {
        queryState: "LOADED" /* LOADED */ ,
        context: context
    });
    var _useQuery2 = useQuery2(__Query2, {
        notifyOnNetworkStatusChange: true,
        context: {
            batchKey: batchKey !== null && batchKey !== void 0 ? batchKey : "smart-shopping-loaded-bk"
        },
        variables: variables,
        ssr: false
    }), data = _useQuery2.data, error = _useQuery2.error, loading = _useQuery2.loading, refetch = _useQuery2.refetch, previousData = _useQuery2.previousData;
    var results = data !== null && data !== void 0 ? data : previousData;
    var disabledClass = classNames("is-disabled");
    var hasPreviousData = !!previousData;
    useEffect5(function() {
        if (!loading) {
            var _onLoad, _onLoading;
            (_onLoad = onLoad) === null || _onLoad === void 0 ? void 0 : _onLoad();
            (_onLoading = onLoading) === null || _onLoading === void 0 ? void 0 : _onLoading(false);
        }
        if (loading) {
            var _onLoading1;
            (_onLoading1 = onLoading) === null || _onLoading1 === void 0 ? void 0 : _onLoading1(true);
        }
    }, [
        loading,
        onLoad,
        onLoading
    ]);
    useEffect5(function() {
        if (error) {
            var _onError;
            (_onError = onError) === null || _onError === void 0 ? void 0 : _onError("NO_API_RESPONSE" /* NO_API_RESPONSE */ );
        }
    }, [
        error,
        data,
        onError
    ]);
    useEffect5(function() {
        setIsDisabledLoading(Boolean(loading && previousData));
    }, [
        loading,
        previousData
    ]);
    var handleOnEmptyListings = useCallback5(function() {
        if (data && data.flightsListings.__typename === "FlightsSmartShoppingLoadedListings" && data.flightsListings.listings.length === 0) {
            var _onError;
            (_onError = onError) === null || _onError === void 0 ? void 0 : _onError("NO_FLIGHTS_FOUND" /* NO_FLIGHTS_FOUND */ );
        }
    }, [
        data,
        onError
    ]);
    var handleTriggerClick = React130.useCallback(function(jcid) {
        var _onTriggerClick;
        (_onTriggerClick = onTriggerClick) === null || _onTriggerClick === void 0 ? void 0 : _onTriggerClick(jcid);
    }, [
        onTriggerClick
    ]);
    var handleErrorClick = useCallback5(function(clientAction) {
        var _onServerErrorClick;
        if (clientAction.__typename === "FlightsRefreshAction" || clientAction.__typename === "FlightsClickAction") {
            refetch();
        }
        (_onServerErrorClick = onServerErrorClick) === null || _onServerErrorClick === void 0 ? void 0 : _onServerErrorClick(clientAction);
    }, [
        onServerErrorClick,
        refetch
    ]);
    if (loading && !results) {
        return /* @__PURE__ */ React130.createElement(ListingsLoadingOffers, null);
    }
    if (error) {
        return null;
    }
    if (((_results = results) === null || _results === void 0 ? void 0 : _results.flightsListings.__typename) === "FlightsSmartShoppingLoadedListings") {
        return /* @__PURE__ */ React130.createElement("div", {
            "data-stid": "smart-shopping-listings",
            className: isDisabledLoading ? disabledClass : void 0
        }, /* @__PURE__ */ React130.createElement(FlightsSmartShoppingLoadedListings, {
            data: results.flightsListings,
            listingsInputs: inputs,
            onFareApplied: onFareApplied,
            onTriggerClick: handleTriggerClick,
            onSideSheetLoad: onSideSheetLoad,
            onDialogClose: onDialogClose,
            onSuccessSideSheet: onSuccessSideSheet,
            onErrorSideSheet: onErrorSideSheet,
            onEmptyListings: handleOnEmptyListings,
            isDisabledLoading: isDisabledLoading,
            detailsAndFaresContent: detailsAndFaresContent,
            detailsAndFaresFooter: detailsAndFaresFooter,
            onOfferSelect: onOfferSelect,
            isUpsellLoading: isUpsellLoading,
            shouldKeepLoading: shouldKeepLoading,
            hasPreviousData: hasPreviousData,
            setIsDisabledLoading: setIsDisabledLoading
        }));
    }
    if (((_results1 = results) === null || _results1 === void 0 ? void 0 : _results1.flightsListings.__typename) === "FlightsSmartShoppingListingsError") {
        return /* @__PURE__ */ React130.createElement(FlightsSmartShoppingListingsError, {
            data: results.flightsListings,
            onError: onError,
            onServerErrorClick: handleErrorClick,
            onOverFilteringRemoveAllClick: onOverFilteringRemoveAllClick,
            onOverFilteringRemovePillClick: onOverFilteringRemovePillClick
        });
    }
    return null;
};
FlightsListingsLoaded.displayName = "FlightsListingsLoaded";
// src/components/smart-shopping-listings/__private/flights-listings-skeletons.tsx
import React131 from "react";
import { gql as gql128 } from "@apollo/client";
import { UitkLayoutFlex as UitkLayoutFlex31 } from "uitk-react-layout-flex";
import { UitkLoader } from "uitk-react-loader";
import { UitkSpacing as UitkSpacing49 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading12, UitkText as UitkText30 } from "uitk-react-text";
var __Fragment3 = gql128(_templateObject129());
var mainSpacingProps5 = {
    padding: {
        blockend: "twelve",
        large: {
            blockstart: "six"
        },
        extra_large: {
            blockstart: "six"
        }
    }
};
var FlightsSmartShoppingLoadingListings = function(param) {
    var data = param.data;
    return /* @__PURE__ */ React131.createElement(UitkLayoutFlex31, {
        justifyContent: "center",
        "data-stid": "loading-spinner"
    }, /* @__PURE__ */ React131.createElement(UitkSpacing49, {
        padding: mainSpacingProps5.padding
    }, /* @__PURE__ */ React131.createElement(UitkText30, {
        align: "center"
    }, /* @__PURE__ */ React131.createElement(UitkLoader, null), /* @__PURE__ */ React131.createElement(UitkHeading12, {
        tag: "h2",
        size: 5
    }, data.originDestination), /* @__PURE__ */ React131.createElement(UitkText30, {
        size: 300
    }, data.message))));
};
FlightsSmartShoppingLoadingListings.displayName = "SmartShoppingListingsSkeletons";
FlightsSmartShoppingLoadingListings.fragment = __Fragment3;
// src/components/smart-shopping-listings/__private/flights-spinner-skeleton.tsx
import React132 from "react";
import { UitkLayoutFlex as UitkLayoutFlex32 } from "uitk-react-layout-flex";
import { UitkLoader as UitkLoader2 } from "uitk-react-loader";
import { UitkSpacing as UitkSpacing50 } from "uitk-react-spacing";
import { UitkText as UitkText31 } from "uitk-react-text";
var mainSpacingProps6 = {
    padding: {
        blockend: "twelve",
        large: {
            blockstart: "six"
        },
        extra_large: {
            blockstart: "six"
        }
    }
};
var FlightsSpinnerSkeleton = function() {
    return /* @__PURE__ */ React132.createElement(UitkLayoutFlex32, {
        justifyContent: "center",
        "data-stid": "loading-spinner-skeleton"
    }, /* @__PURE__ */ React132.createElement(UitkSpacing50, {
        padding: mainSpacingProps6.padding
    }, /* @__PURE__ */ React132.createElement(UitkText31, {
        align: "center"
    }, /* @__PURE__ */ React132.createElement(UitkLoader2, null))));
};
// src/components/smart-shopping-listings/flights-listings.tsx
var __Query3 = gql129(_templateObject130(), FlightsSmartShoppingLoadingListings.fragment);
var SmartShoppingListingError2 = /* @__PURE__ */ function(SmartShoppingListingError3) {
    SmartShoppingListingError3["NO_API_RESPONSE"] = "NO_API_RESPONSE";
    SmartShoppingListingError3["SERVER_ERROR"] = "SERVER_ERROR";
    SmartShoppingListingError3["OVERFILTERING_ERROR"] = "OVERFILTERING_ERROR";
    SmartShoppingListingError3["BANNER_ERROR"] = "BANNER_ERROR";
    SmartShoppingListingError3["NO_FLIGHTS_FOUND"] = "NO_FLIGHTS_FOUND";
    return SmartShoppingListingError3;
}(SmartShoppingListingError2 || {});
var FlightsListings = function(props) {
    var _data;
    var inputs = props.inputs, skipSsr = props.skipSsr, onDialogClose = props.onDialogClose, onError = props.onError, onErrorSideSheet = props.onErrorSideSheet, onFareApplied = props.onFareApplied, onLoading = props.onLoading, onLoad = props.onLoad, onOverFilteringRemoveAllClick = props.onOverFilteringRemoveAllClick, onOverFilteringRemovePillClick = props.onOverFilteringRemovePillClick, onServerErrorClick = props.onServerErrorClick, onSideSheetLoad = props.onSideSheetLoad, onSuccessSideSheet = props.onSuccessSideSheet, onTriggerClick = props.onTriggerClick, detailsAndFaresContent = props.detailsAndFaresContent, detailsAndFaresFooter = props.detailsAndFaresFooter, onOfferSelect = props.onOfferSelect, isUpsellLoading = props.isUpsellLoading, shouldKeepLoading = props.shouldKeepLoading;
    var context = useBexApi3().context;
    var _useState3 = _sliced_to_array(useState3(true), 2), loaderVisible = _useState3[0], setLoaderVisible = _useState3[1];
    var variables = _object_spread_props(_object_spread({}, inputs), {
        flightSearchFilterValuesList: [],
        sortOption: null,
        queryState: "LOADING" /* LOADING */ ,
        context: context
    });
    var _useQuery3 = useQuery3(__Query3, {
        variables: variables,
        nextFetchPolicy: "cache-only",
        ssr: !skipSsr
    }), data = _useQuery3.data, error = _useQuery3.error, loading = _useQuery3.loading, previousData = _useQuery3.previousData;
    var handleListingsLoaded = useCallback6(function() {
        var _onLoad;
        setLoaderVisible(false);
        (_onLoad = onLoad) === null || _onLoad === void 0 ? void 0 : _onLoad();
    }, [
        setLoaderVisible,
        onLoad
    ]);
    if (loading && loaderVisible) {
        return /* @__PURE__ */ React133.createElement(FlightsSpinnerSkeleton, null);
    }
    if (error) {
        var _onError;
        (_onError = onError) === null || _onError === void 0 ? void 0 : _onError("NO_API_RESPONSE" /* NO_API_RESPONSE */ );
        return null;
    }
    if (loading && previousData) {
        return /* @__PURE__ */ React133.createElement(ListingsLoadingOffers, null);
    }
    if (((_data = data) === null || _data === void 0 ? void 0 : _data.flightsListings.__typename) === "FlightsSmartShoppingLoadingListings") {
        return /* @__PURE__ */ React133.createElement(React133.Fragment, null, loaderVisible && /* @__PURE__ */ React133.createElement(FlightsSmartShoppingLoadingListings, {
            data: data.flightsListings
        }), /* @__PURE__ */ React133.createElement(FlightsListingsLoaded, {
            inputs: inputs,
            onDialogClose: onDialogClose,
            onError: onError,
            onErrorSideSheet: onErrorSideSheet,
            onFareApplied: onFareApplied,
            onLoading: onLoading,
            onOverFilteringRemoveAllClick: onOverFilteringRemoveAllClick,
            onOverFilteringRemovePillClick: onOverFilteringRemovePillClick,
            onServerErrorClick: onServerErrorClick,
            onSideSheetLoad: onSideSheetLoad,
            onSuccessSideSheet: onSuccessSideSheet,
            onTriggerClick: onTriggerClick,
            onLoad: handleListingsLoaded,
            detailsAndFaresContent: detailsAndFaresContent,
            detailsAndFaresFooter: detailsAndFaresFooter,
            onOfferSelect: onOfferSelect,
            isUpsellLoading: isUpsellLoading,
            shouldKeepLoading: shouldKeepLoading
        }));
    }
    return null;
};
FlightsListings.displayName = "sharedui-FlightsListings";
export { FlightsCabinClass, FlightsListings, FlightsSortType, FlightsTravelerType, FlightsTripType, SmartShoppingListingError2 as SmartShoppingListingError, TravelerDetailsType };
//# sourceMappingURL=index.js.map